const HubSettings = {

    sections: {
        // pages: { key: 'pages', noChildren: false, name: '{{lang}}Pages', addNew: 'addPage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        general: { key: 'general', noChildren: false, name: 'general' },
        // help: { key: 'help', noChildren: false, name: 'help' },
        // extra: { key: 'extra', noChildren: false, name: 'extra' },

        // purchases: { key: 'purchases', name: 'Purchases', icon: '/images/applets-icons/accounting/shopping-bag.svg' },
        // accountant: { key: 'accountant', name: 'Accountant', icon: '/images/applets-icons/accounting/book.svg' },
        // reports: { key: 'reports', name: 'Reports', icon: '/images/applets-icons/accounting/increasing.svg' },
        // settings: { key: 'settings', name: 'Settings', icon: '/images/settings-4.svg' },

    },

    pages: {


        account: {
            key: 'account',
            title: '{{lang}}Account info',
            name: '{{lang}}Account info',
            description: 'Connection list',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'accountSetting',
            options: {},
            section: 'general',
            sort: { 'cDate': -1 },
            // customAdd: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'accountSettings/[var]' },


            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/crown (2).png',
            description: '{{lang}}The descriptions of this module would be shown here',
            // section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },

        config: {
            key: 'config',
            title: '{{lang}}Hub Config',
            name: '{{lang}}Hub Config',
            description: 'general settings',
            fetchUrl: 'getUserInfo',
            addUrl: 'updateUserInfo',
            editUrl: 'updateUserInfo',

            removeUrl: 'removeInvoice',
            pageType: 'config',
            section: 'general',
            defaultPage: true,

            options: {},
            filter: { _id: '{{appletHub}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/setting (2).png',

            description: '{{lang}}The descriptions of this module would be shown here',

            headers: [
                { type: 'ProfileImageInput', key: 'image', col: '12', section: 'sec-main', information: { label: '{{lang}}Profile Image', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}insertName', autoFocus: true, required: true } },
                { key: 'family', type: 'TextInput', col: '12', information: { label: '{{lang}}Family', placeholder: '{{lang}}insertFamily', required: true } },
                { key: 'username', type: 'UsernameInput', information: { label: '{{lang}}Username', hint: '{{lang}}ch-username', minLenght: 4, address: 'checkUsernameValidity', placeholder: '{{lang}}username', required: true, disabled: true } },
                // { key: 'gender', type: 'SelectInput', information: { type: 'local', items: [{ title: 'Male', value: 'Male' }, { title: 'Female', value: 'Female' }], placeholder: '{{lang}}gender', required: true } },
                { key: 'birthdate', type: 'DateInput', information: { label: '{{lang}}Birthdate', placeholder: '{{lang}}birthdate', required: true } },
                // { key: 'password', type: 'PasswordInput', information: { label: '{{lang}}Password', placeholder: '{{lang}}insertPassword', required: true } },

                { type: 'ImageInput', key: 'cover', col: '12', section: 'sec-main', information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: "3:1", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-main', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                { key: 'colorType', type: 'SelectInput', col: '12', information: { label: '{{lang}}Color Type', type: 'local', items: [{ value: 'default', title: '{{lang}}Default' }, { value: 'custom', title: '{{lang}}Custom' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true },

                // { key: 'colorSameAsHub', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Color same as hub', placeholder: '{{lang}}special', required: false }, showMain: true },

                {
                    key: 'colors.primaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Primary Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.primaryColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                {
                    key: 'colors.secondaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Secondary Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.secondaryColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                {
                    key: 'colors.textColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Text Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.textColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    },


                    { key: 'country', type: 'TextInput', col: '12', information: { label: '{{lang}}Country', placeholder: '{{lang}}insert', autoFocus: true, required: true } },

                    { key: 'language', type: 'TextInput', col: '12', information: { label: '{{lang}}Default language', placeholder: '{{lang}}insert', autoFocus: true, required: true } },

                    { key: 'dateFormat', type: 'TextInput', col: '12', information: { label: '{{lang}}Date Format', placeholder: '{{lang}}insert', autoFocus: true, required: true } },

                    { key: 'timeZone', type: 'TextInput', col: '12', information: { label: '{{lang}}Default time zone', placeholder: '{{lang}}insert', autoFocus: true, required: true } },



                    ],
                    showMain: false
                },
            ]

        },


        connectionRequests: {
            key: 'connectionRequests',
            title: '{{lang}}Connection requests',
            name: '{{lang}}Connection requests',
            description: 'Connection requests list',
            fetchUrl: 'getNotifications',
            addUrl: '',
            editUrl: '',
            yremoveRelation: '',
            pageType: 'requests',
            inbox: 'request',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },

            ]
        },


        connectionTypes: {
            key: 'connectionTypes',
            title: '{{lang}}Connection types',
            name: '{{lang}}Connection types',
            // description: 'Connection list',
            fetchUrl: 'getConnectionTypes',
            addUrl: 'postConnectionType',
            editUrl: 'postConnectionType',
            removeUrl: 'removeConnectionType',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            options: {},
            section: 'general',
            sort: { 'cDate': -1 },

            // customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },
            // customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },

            filter: { hub: "{{appletHub}}" },
            postBody: { hub: "{{appletHub}}" },
            removeBody: { hub: "{{appletHub}}" },

            icon: '/assets/icons/applets/general/link (3).png',
            description: '{{lang}}The descriptions of this module would be shown here',
            // section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
                { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}Type', type: 'local', items: [{ value: 'Public', title: '{{lang}}Public' }, { value: 'Private', title: '{{lang}}Private' }, { value: 'Subscribe', title: '{{lang}}Subscribe' }], hint: '{{lang}}Public connection requestes will be auto approved. Private connection types needs approval for connection after request is submitted. Subscription connections asks for payments from the hub which want to be connected.', isSearchable: true, placeholder: '{{lang}}Select', required: true }, showMain: true },
                { key: 'groups', type: 'GroupsSelectInput', page: 'information', section: 'main', information: { isSearchable: true, label: '{{lang}}Groups', address: 'getConnectionGroups', help: '{{lang}}Hubs will be added to this groups after they get connected to this connection type.', filter: { hub: "{{targetId}}" }, fields: { title: 'name', parent: 'parent', licensed: 'licensed', value: '_id' }, parentKey: 'parent', type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: true } },
                { key: 'hasForm', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Has form', help: '{{lang}}This option gives you the possibility to ask hubs to fill a form before connection.', required: false }, showMain: true },
                {
                    key: 'form', type: 'FormBuilderInput', col: '12', information: { label: '{{lang}}Form', required: false },
                    dependencies: [{
                        refKey: 'hasForm', targetKey: 'form',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.hasForm' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },




        hubs: {
            key: 'hubs',
            title: '{{lang}}Connected hubs',
            name: '{{lang}}Connected hubs',
            description: 'Hubs list',
            fetchUrl: 'getRelations',
            addUrl: 'hubinvitation',
            editUrl: 'editRelation',
            removeUrl: 'removeRelation',
            pageType: 'collection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Invite User', function: 'openInviteUser' },
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/connection.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'general',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },
            formPages: [{
                label: '{{lang}}Information', key: 'information', isLastPage: true,

                sections: [
                    { key: 'main', information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' } },
                    { key: 'contact', information: { label: '{{lang}}Contact information', fontSize: 16, color: '#000', fontWeight: '600' } },
                    { key: 'custom', information: { label: '{{lang}}Custom fields', fontSize: 16, color: '#000', fontWeight: '600' } },

                ]

            }],

            headers: [


                {
                    type: 'TextInput', page: 'information', section: 'main', key: 'hub.name', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}e.g. Mike', required: true, disabled: false },
                    dependencies: [{
                        refKey: 'hub', targetKey: 'hub.name',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.hub' }, operator: { value: '==' }, target: { value: null } }, 2: { id: 2, source: { value: '@data.status' }, operator: { value: '==' }, target: { value: 'V' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                {
                    type: 'TextInput', page: 'information', section: 'main', key: 'hub.family', col: '6', information: { label: '{{lang}}Family', placeholder: '{{lang}}e.g. Smith', required: false, disabled: false },
                    dependencies: [{
                        refKey: 'hub', targetKey: 'hub.family',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.hub' }, operator: { value: '==' }, target: { value: null } }, 2: { id: 2, source: { value: '@data.status' }, operator: { value: '==' }, target: { value: 'V' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                {
                    type: 'GlobalUserInput', page: 'information', section: 'main', key: 'hub', information: { label: '{{lang}}Hub', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, disabled: true },
                    dependencies: [{
                        refKey: 'hub', targetKey: 'hub',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hub' }, operator: { value: '!=' }, target: { value: null } }, 2: { id: 2, source: { value: '@data.status' }, operator: { value: '!=' }, target: { value: 'V' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,
                        // show:true,

                    },

                    ],
                    showMain: true
                },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                {
                    key: 'status', type: 'HubStatusIndicator', page: 'information', section: 'main', col: '12', information: { label: '{{lang}}useful.status', inputClass: ' ', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: false,
                    dependencies: [{
                        refKey: '_id', targetKey: 'status',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data._id' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { show: false, }
                        }],
                        else: { show: true },
                        init: true,
                        // show:true,

                    }],
                    showMain: true
                },

                // { key: 'type', type: 'StatusInput', page:'information', section:'main',col: '12', information: { label: '{{lang}}Type', placeholder: '{{lang}}type', required: false, disabled: true }, hideComponent: true, showMain: true },


                // { type: 'ImageInput', key: 'images', page:'information', section:'main',col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                {
                    key: 'requests', type: 'RequestsInput', page: 'information', section: 'main', information: { isSearchable: true, label: '{{lang}}Connection requests', required: false },
                    dependencies: [{
                        refKey: 'requests', targetKey: 'requests',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.requests' }, operator: { value: '!=' }, target: { value: null } }, 2: { id: 2, source: { value: '@data.requests' }, operator: { value: '!=' }, target: { value: [] } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                { key: 'groups', type: 'GroupsSelectInput', page: 'information', section: 'main', information: { isSearchable: true, label: '{{lang}}Groups', address: 'getConnectionGroups', filter: { hub: "{{targetId}}" }, fields: { title: 'name', parent: 'parent', licensed: 'licensed', value: '_id' }, parentKey: 'parent', type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },

                { key: 'licensed', type: 'LicenseInput', page: 'information', section: 'main', col: '12', information: { label: '{{lang}}Licensed', type: 'group', placeholder: '{{lang}}Licensed', hint: '{{lang}}Licensed hubs can have access to private frames and applets and can have private permissions. You can purchase licenses from the account settings.', required: false, disabled: false }, hideComponent: false, showMain: true },


                // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                { key: 'title', type: 'TextInput', page: 'information', section: 'main', col: '12', information: { label: '{{lang}}title', placeholder: '{{lang}}title', hint: '{{lang}}Title can be used for corporate titles or business titles and any other purpose that this hub can be called in this hub using this title.', required: false }, showMain: false },

                { key: '*extra.phone', type: 'PhoneInput', page: 'information', section: 'contact', col: '12', information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: false }, showMain: false },
                { key: '*extra.email', type: 'TextInput', page: 'information', section: 'contact', col: '12', information: { label: '{{lang}}email', placeholder: '{{lang}}email', required: false }, showMain: false },
                // { key: '*extra.registerDate', type: 'DateInput',page: 'information', section: 'contact', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput',page: 'information', section: 'contact', col: '12',  information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput',page: 'information', section: 'contact', col: '12', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                { key: '*extra.address', type: 'AddressInput', page: 'information', section: 'contact', col: '12', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: false }, showMain: false },
                { key: '*extra.description', type: 'TextAreaInput', page: 'information', section: 'contact', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },


        groups: {
            key: 'groups',
            title: '{{lang}}Groups',
            name: '{{lang}}Groups',
            description: 'groups list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}", type: 'G' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'general',

            icon: '/assets/icons/applets/general/connect (2).png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'parent', type: 'GroupsSelectInput', information: { label: '{{lang}}parent', single: true, hideTabs: true, parentKey: 'parent', inplaceEditable: false, address: 'getConnectionGroups', filter: { applet: '{{appletId}}', hub: "{{targetId}}", type: 'G' }, fields: { title: 'name', value: '_id', parent: 'parent', licensed: 'licensed', image: 'image' }, neId: true, type: 'api', isSearchable: true, required: false, } },
                { key: 'licensed', type: 'LicenseInput', col: '12', information: { label: '{{lang}}Licensed', placeholder: '{{lang}}Licensed', default: true, hint: '{{lang}}When a group is licenses any hub which be added to this group will receive a license from your available licenses. This groups can have access to private frames and applets.', required: false, disabled: false }, hideComponent: false, showMain: true },
                { key: 'hidden', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Is hidden group', default: false, hint: '{{lang}}If a hub is part of a hidden group, they will not see that they are part of this group and will not be informed about it. This groups will also be hidden in connections.', required: false, disabled: false }, hideComponent: false, showMain: true },

                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
                // { key: 'hubs', type: 'GlobalUserMultiInput', information: { label: '{{lang}}hubs', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: 'select hub', required: true, } },

            ]
        },



        department: {
            key: 'department',
            title: '{{lang}}Departments',
            name: '{{lang}}Departments',
            description: 'Departments list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}", type: 'G' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'general',

            icon: '/assets/icons/applets/general/structure.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'parent', type: 'GroupsSelectInput', information: { label: '{{lang}}parent', single: true, hideTabs: true, parentKey: 'parent', inplaceEditable: false, address: 'getConnectionGroups', filter: { applet: '{{appletId}}', hub: "{{targetId}}", type: 'G' }, fields: { title: 'name', value: '_id', parent: 'parent', licensed: 'licensed', image: 'image' }, type: 'api', isSearchable: true, required: false, } },
                { key: 'licensed', type: 'LicenseInput', col: '12', information: { label: '{{lang}}Licensed', placeholder: '{{lang}}Licensed', default: true, hint: '{{lang}}When a group is licenses any hub which be added to this group will receive a license from your available licenses. This groups can have access to private frames and applets.', required: false, disabled: false }, hideComponent: false, showMain: true },

                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
                // { key: 'hubs', type: 'GlobalUserMultiInput', information: { label: '{{lang}}hubs', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: 'select hub', required: true, } },

            ]
        },




        upgrade: {
            key: 'account/upgrade',
            title: '{{lang}}Upgrade Account',
            name: '{{lang}}Upgrade Account',
            description: 'Pages list',
            fetchUrl: 'getFrames',
            addUrl: 'postNavigation',
            editUrl: 'postNavigation',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'upgradeAccount',
            options: {},
            section: 'navigations',
            sort: { 'cDate': -1 },
            hideInDashboard: true,

            // customAdd: { title: '{{lang}}Add Rule', function: 'changeNavigationsView', functionInput: 'navigations/[var]' },
            // customEdit: { title: '{{lang}}Add Rule', function: 'changeNavigationsView', functionInput: 'navigations/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page', mode: 'user' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'user' },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            // section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },



        payment: {
            key: 'account/payment',
            title: '{{lang}}Yonnect payment',
            name: '{{lang}}Yonnect payment',
            description: 'Pages list',
            // fetchUrl: 'getFrames',
            // addUrl: 'postNavigation',
            // editUrl: 'postNavigation',
            // yremoveRelation: 'yremoveConnection',
            // actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'yonnectCart',
            options: {},
            section: 'navigations',
            sort: { 'cDate': -1 },
            hideInDashboard: true,

            // filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page', mode: 'user' },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'user' },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',


            headers: [


            ]
        },




        page: {
            key: 'pages/[var]',
            title: '{{lang}}Page Builder',
            name: '{{lang}}Page Builder',
            description: 'newpage list',
            fetchUrl: 'newPage',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            pageType: 'pageBuilder',
            section: 'pages',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'addRule' },
            hideInDashboard: true,

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", mode: 'user' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", mode: 'user' },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

        },

        applets: {
            key: 'applets',
            title: '{{lang}}Applets',
            name: '{{lang}}Applets',
            description: 'Applets list',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            options: {},
            section: 'general',
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page', mode: 'user' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", mode: 'user' },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            // section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },

        // navigations: {
        //     key: 'navigations',
        //     title: '{{lang}}Navigations',
        //     description: 'Pages list',
        //     fetchUrl: 'getFrames',
        //     addUrl: 'postPage',
        //     editUrl: 'postPage',
        //     yremoveRelation: 'yremoveConnection',
        //     actions: [{ type: 'edit' }, { type: 'remove' }],
        //     pageType: 'collection',
        //     options: {},
        //     section: 'general',
        //     sort: { 'cDate': -1 },

        //     customAdd: { title: '{{lang}}Add Rule', function: 'changeNavigationsView', functionInput: 'navigations/[var]' },
        //     customEdit: { title: '{{lang}}Add Rule', function: 'changeNavigationsView', functionInput: 'navigations/[var]' },

        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page', mode: 'user' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", mode: 'user' },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     // section: 'main',

        //     // actions: {
        //     //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
        //     //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        //     // },

        //     headers: [
        //         // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
        //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

        //         // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

        //         // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
        //     ]
        // },
        // navigation: {
        //     key: 'navigations/[var]',
        //     title: '{{lang}}Navigations',
        //     description: 'Pages list',
        //     fetchUrl: 'getFrames',
        //     addUrl: 'postNavigation',
        //     editUrl: 'postNavigation',
        //     yremoveRelation: 'yremoveConnection',
        //     actions: [{ type: 'edit' }, { type: 'remove' }],
        //     pageType: 'navigation',
        //     options: {},
        //     section: 'navigations',
        //     sort: { 'cDate': -1 },
        //     hideInDashboard: true,

        //     // customAdd: { title: '{{lang}}Add Rule', function: 'changeNavigationsView', functionInput: 'navigations/[var]' },
        //     // customEdit: { title: '{{lang}}Add Rule', function: 'changeNavigationsView', functionInput: 'navigations/[var]' },

        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page', mode: 'user' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'user' },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     // section: 'main',

        //     // actions: {
        //     //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
        //     //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        //     // },

        //     headers: [
        //         // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
        //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

        //         // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

        //         // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
        //     ]
        // },


        billing: {
            key: 'billing',
            title: '{{lang}}Billing',
            name: '{{lang}}Billing',
            description: 'Billing settings',
            fetchUrl: 'getInvoices',
            addUrl: 'postInvoice',
            editUrl: 'editInvoice',

            removeUrl: 'removeInvoice',
            pageType: 'collection',
            section: 'general',

            icon: '/assets/icons/applets/general/shield.png',

            headers: [


            ]
        },


        security: {
            key: 'security',
            title: '{{lang}}Security',
            name: '{{lang}}Security',
            description: 'security settings',
            fetchUrl: 'getInvoices',
            addUrl: 'postInvoice',
            editUrl: 'editInvoice',

            removeUrl: 'removeInvoice',
            pageType: 'collection',
            section: 'general',

            icon: '/assets/icons/applets/general/shield.png',

            headers: [


            ]
        },



        // privacy: {
        //     key: 'privacy',
        //     title: '{{lang}}privacy',
        //     description: 'privacy settings',
        //     fetchUrl: 'getInvoices',
        //     addUrl: 'postInvoice',
        //     editUrl: 'editInvoice',

        //     removeUrl: 'removeInvoice',
        //     pageType: 'collection',
        //     section: 'general',

        //     icon: '/assets/icons/applets/general/lock.png',

        //     headers: [


        //     ]
        // },

        activeSessions: {
            key: 'activeSessions',
            title: '{{lang}}Active Sessions',
            name: '{{lang}}Active Sessions',
            description: 'Active Sessions settings',
            fetchUrl: 'getInvoices',
            addUrl: 'postInvoice',
            editUrl: 'editInvoice',

            removeUrl: 'removeInvoice',
            pageType: 'activeSessions',
            section: 'general',

            icon: '/assets/icons/applets/general/clock.png',

            headers: []
        },

        permissions: {
            key: 'permissions',
            title: '{{lang}}Permissions',
            name: '{{lang}}Permissions',
            description: 'Permission settings',
            fetchUrl: 'getInvoices',
            addUrl: 'postInvoice',
            editUrl: 'editInvoice',

            removeUrl: 'removeInvoice',
            pageType: 'permission',
            section: 'general',

            icon: '/assets/icons/applets/general/clock.png',

            headers: []
        },

        // localization: {
        //     key: 'localization',
        //     title: '{{lang}}localization',
        //     description: 'localization settings',
        //     fetchUrl: 'getInvoices',
        //     addUrl: 'postInvoice',
        //     editUrl: 'editInvoice',

        //     removeUrl: 'removeInvoice',
        //     pageType: 'collection',
        //     section: 'general',

        //     icon: 'https://cdn-icons.flaticon.com/png/512/870/premium/870169.png?token=exp=1640161002~hmac=6b86a850c0c88af1f6047dff468757d5',

        //     headers: []
        // },

        // Advertisements: {
        //     key: 'Advertisements',
        //     title: '{{lang}}Advertisements',
        //     description: 'Advertisements settings',
        //     fetchUrl: 'getInvoices',
        //     addUrl: 'postInvoice',
        //     editUrl: 'editInvoice',

        //     removeUrl: 'removeInvoice',
        //     pageType: 'collection',
        //     section: 'general',

        //     icon: '/assets/icons/applets/general/fast.png',

        //     headers: []
        // },

        // academy: {
        //     key: 'academy',
        //     title: '{{lang}}academy',
        //     description: 'academy list',
        //     fetchUrl: 'getPermissions',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremovePermission',
        //     pageType: 'collection',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },

        //     section: 'help',

        //     icon: '/assets/icons/applets/general/text.png',

        // // },

        // help: {
        //     key: 'help',
        //     title: '{{lang}}help',
        //     description: 'help list',
        //     fetchUrl: 'getPermissions',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremovePermission',
        //     pageType: 'collection',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },

        //     section: 'help',

        //     icon: '/assets/icons/applets/general/help.png',

        // // },

        // deactivate: {
        //     key: 'deactivate',
        //     title: '{{lang}}Deactivate',
        //     description: 'deactivate list',
        //     fetchUrl: 'getPermissions',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremovePermission',
        //     pageType: 'collection',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },

        //     section: 'extra',

        //     icon: '/assets/icons/applets/general/close.png',

        // },
    },
}


const ConnectionsPages = {


    sections: {
        main: { key: 'main', noChildren: false, name: '{{lang}}Main' },
        // help: { key: 'help', noChildren: false, name: 'help' },
        // extra: { key: 'extra', noChildren: false, name: 'extra' },
    },

    pages: {

        hubs: {
            key: 'hubs',
            title: '{{lang}}useful.hubs',
            description: 'Hubs list',
            fetchUrl: 'getRelations',
            addUrl: 'hubinvitation',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Invite User', function: 'openInviteUser' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { hub: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                { key: '*extra.phone', type: 'PhoneInput', col: '12', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                { key: '*extra.email', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                { key: '*extra.commission', type: 'NumberInput', col: '12', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                { key: '*extra.salesperson', type: 'SelectInput', col: '12', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },


        groups: {
            key: 'groups',
            title: '{{lang}}useful.groups',
            description: 'groups list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}", type: 'G' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'main',

            icon: '/assets/icons/applets/general/shield.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
                // { key: 'hubs', type: 'GlobalUserMultiInput', information: { label: '{{lang}}hubs', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: 'select hub', required: true, } },
            ]
        },


        // organization: {
        //     key: 'organization',
        //     title: '{{lang}}useful.organization',
        //     description: 'organization list',
        //     // fetchUrl: 'getConnectionGroups',
        //     // addUrl: 'postConnectionGroup',
        //     // editUrl: 'postConnectionGroup',
        //     // removeUrl: 'yremoveConnectionGroup',
        //     // helperKey: 'values',
        //     pageType: 'collection',

        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}', hub: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
        //     section: 'main',

        //     icon: '/assets/icons/applets/general/shield.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
        //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
        //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
        //     ]
        // },

    },


}




const AutomationsPages = {


    sections: {
        main: { key: 'main', noChildren: false, name: '{{lang}}Main' },
        // help: { key: 'help', noChildren: false, name: 'help' },
        // extra: { key: 'extra', noChildren: false, name: 'extra' },
    },

    pages: {

        rules: {
            key: 'rules',
            title: '{{lang}}rules',
            description: 'rules list',
            fetchUrl: 'getRelations',
            addUrl: 'hubinvitation',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { hub: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },


        actions: {
            key: 'actions',
            title: '{{lang}}actions',
            description: 'actions list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'main',

            icon: '/assets/icons/applets/general/shield.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
            ]
        },



        variables: {
            key: 'variables',
            title: '{{lang}}Variables',
            description: 'variables list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'main',

            icon: '/assets/icons/applets/general/shield.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
            ]
        },




        journeys: {
            key: 'journeys',
            title: '{{lang}}Journeys',
            description: 'journeys list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'main',

            icon: '/assets/icons/applets/general/shield.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
            ]
        },





        forms: {
            key: 'forms',
            title: '{{lang}}forms',
            description: 'forms list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            // helperKey: 'values',
            pageType: 'collection',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', hub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            section: 'main',

            icon: '/assets/icons/applets/general/shield.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { type: 'ImageInput', key: 'image', col: '12', information: { label: '{{lang}}images', single: true, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
            ]
        },

    }


}



const SettingsFrames = {


    sections: {
        main: { key: 'main', noChildren: false, name: '{{lang}}Main' },
    },

    pages: {


        config: {
            key: 'config',
            title: '{{lang}}Applet configuration',
            subtitle: '{{lang}}settings',

            description: '{{lang}}The general configuration and settings of the applet',
            fetchUrl: 'getAppletConfig',
            addUrl: 'postAppletConfig',
            editUrl: 'postAppletConfig',
            configType: 'applet',

            // removeUrl: 'removeInvoice',
            pageType: 'config',
            section: 'general',
            defaultPage: true,

            options: {},
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',


            headers: [


                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', information: { label: '{{lang}}Applet Name', placeholder: '{{lang}}Insert applet name', required: false } },
                { type: 'ProfileImageInput', key: 'images', col: '12', section: 'sec-main', information: { label: '{{lang}}Applet Image', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-main', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                { key: 'colorType', type: 'SelectInput', col: '12', information: { label: '{{lang}}Color Type', type: 'local', items: [{ value: 'default', title: '{{lang}}Default' }, { value: 'sameAsHub', title: '{{lang}}Same as hub' }, { value: 'custom', title: '{{lang}}Custom' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true },

                // { key: 'colorSameAsHub', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Color same as hub', placeholder: '{{lang}}special', required: false }, showMain: true },

                {
                    key: 'colors.primaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Primary Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.primaryColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                {
                    key: 'colors.secondaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Secondary Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.secondaryColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                {
                    key: 'colors.textColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Text Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.textColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                // { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },


                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },

            ]

        },



        framesettings: {
            key: 'framesettings/[var]',
            title: '{{lang}}Frame configuration',
            subtitle: '{{lang}}settings',

            description: '{{lang}}The general configuration and settings of the frame',
            fetchUrl: 'getFrameConfig',
            addUrl: 'postFrameConfig',
            editUrl: 'postFrameConfig',
            configType: 'frame',
            pageType: 'config',
            section: 'general',
            defaultPage: true,
            postBody: { applet: '{{appletId}}' },
            options: {},
            filter: { frame: '{{*url.var}}', applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',


            headers: [


                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', information: { label: '{{lang}}Frame Name', placeholder: '{{lang}}Insert frame name', required: false } },
                { type: 'ProfileImageInput', key: 'images', col: '12', section: 'sec-main', information: { label: '{{lang}}Frame Image', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-main', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                // { key: 'colorType', type: 'SelectInput', col: '12', information: { label: '{{lang}}Color Type', type: 'local', items: [{ value: 'default', title: '{{lang}}Default' }, { value: 'sameAsHub', title: '{{lang}}Same as hub' }, { value: 'custom', title: '{{lang}}Custom' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true },

                // {
                //     key: 'colors.primaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Primary Color', placeholder: '{{lang}}Choose ...', required: false },
                //     dependencies: [{
                //         refKey: 'colorType',
                //         targetKey: 'colors.primaryColor',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },

                // {
                //     key: 'colors.secondaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Secondary Color', placeholder: '{{lang}}Choose ...', required: false },
                //     dependencies: [{
                //         refKey: 'colorType',
                //         targetKey: 'colors.secondaryColor',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },

                // {
                //     key: 'colors.textColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Text Color', placeholder: '{{lang}}Choose ...', required: false },
                //     dependencies: [{
                //         refKey: 'colorType',
                //         targetKey: 'colors.textColor',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },

                // { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },


                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },

            ]

        },


        automations: {
            key: 'automations',
            title: '{{lang}}Automations',
            description: 'automations list',
            fetchUrl: 'getAutomations',
            addUrl: 'postFlow',
            editUrl: 'editRelation',
            removeUrl: 'removeAutomation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'automations/[var]' },
            customEdit: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'automations/[var]' },

            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'applets', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Applets', type: 'api', fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '', required: false } },
                { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}Type', type: 'local', items: [{ value: 'workflow', title: '{{lang}}Workflow' }, { value: 'automation', title: '{{lang}}Automation' }], placeholder: '', required: false } },
                { key: 'mode', type: 'SelectInput', col: '12', information: { label: '{{lang}}Mode', type: 'local', items: [{ value: 'basic', title: '{{lang}}Basic' }, { value: 'advanced', title: '{{lang}}Advanced' }], placeholder: '', required: false } },
                { key: 'frames', type: 'MultiSelectInput', col: '6', information: { label: '{{lang}}Frames', address: 'getFrames', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", }, fields: { title: 'name', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Frames', required: false }, showMain: true },

                // { key: 'stages', type: 'StageInput', col: '12', information: { label: '{{lang}}Stages', type: 'api', address: 'getAutomation', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Select ...', required: false } },
                // { key: 'stages', type: 'TextInput', col: '12', information: { label: '{{lang}}Stages', placeholder: '{{lang}}Stages ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                // { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },



        automation: {
            key: 'automations/[var]',
            title: '{{lang}}Automation',
            description: 'Single Automation',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'automation',
            options: {},
            hideInDashboard: true,
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'automations/[var]' },

            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },



            ]
        },






        variables: {
            key: 'variables',
            title: '{{lang}}Variables',
            description: 'Variables list',
            fetchUrl: 'getVariables',
            addUrl: 'postVariables',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',


            headers: [


                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}variable.name', required: false } },
                { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: false } },

                {
                    key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                    dependencies: [{
                        refKey: 'type',
                        targetKey: 'frame',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'or',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'frame' } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value', placeholder: '{{lang}}value', required: false },
                    dependencies: [{
                        refKey: 'type',
                        targetKey: 'value',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'or',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'applet' } },
                                    2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'hub' } }

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                // { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },


                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


            ]
        },



        permissions: {
            key: 'permissions',
            title: '{{lang}}Permissions',
            description: 'Permissions list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Permission', function: 'changePage', functionInput: 'permissions/[var]' },
            customEdit: { title: '{{lang}}Add Permission', function: 'changePage', functionInput: 'permissions/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },
                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },



        permission: {
            key: 'permissions/[var]',
            title: '{{lang}}Permission',
            description: 'Single Permission',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'permission',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Permission', function: 'changePage', functionInput: 'permissions/[var]' },
            hideInDashboard: true,
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },





        actions: {
            key: 'actions',
            title: '{{lang}}Actions',
            description: 'Actions list',
            fetchUrl: 'getAppletActions',
            addUrl: 'postAppletActions',
            editUrl: 'postAppletActions',
            // yremoveRelation: 'removeAppletActions',
            removeUrl: 'removeAppletActions',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            // customAdd: { title: '{{lang}}Add Action', function: 'changePage', functionInput: 'actions/[var]' },
            // customEdit: { title: '{{lang}}Add Action', function: 'changePage', functionInput: 'actions/[var]' },
            referenceKey: 'actions',
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'Template Message', value: 'templateMessage' }], label: '{{lang}}Action', placeholder: 'Choose...', required: true } },
                {
                    type: 'SubformInput',
                    key: 'templateMessage',
                    information: {
                        headers: [
                            { key: 'description', type: 'TextAreaInput', col: '4', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'templateMessage',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'templateMessage' } } }, },
                            effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                        }],
                        else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                        init: true,
                        // show:true,

                    }],
                    showMain: false,
                },
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },


        channels: {
            key: 'channels',
            title: '{{lang}}Channels',
            description: 'Channels list',
            fetchUrl: 'getAppletChannels',
            addUrl: 'postAppletChannels',
            editUrl: 'postAppletChannels',
            // yremoveRelation: 'removeAppletChannels',
            removeUrl: 'removeAppletChannels',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            // customAdd: { title: '{{lang}}Add Action', function: 'changePage', functionInput: 'actions/[var]' },
            // customEdit: { title: '{{lang}}Add Action', function: 'changePage', functionInput: 'actions/[var]' },
            referenceKey: 'channels',
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            // customAdd: { title: '{{lang}}Add Channels', function: 'changeChannels', functionInput: 'channels/[var]' },
            // customEdit: { title: '{{lang}}Add Channels', function: 'changeChannels', functionInput: 'channels/[var]' },

            actions: {
                edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
                remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            },
            formPages: [
                {
                    label: '{{lang}}Channel Type', key: 'type',

                },
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-thirdparty', information: { label: '{{lang}}Third party', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-config', information: { label: '{{lang}}Configuration', fontSize: 16, color: '#000', fontWeight: '600' } },

                    ]
                }],
            headers: [
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the channel type. Each type has its settings and configurations', fontSize: 16, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Payment type', backgroundColor: '#fff', border: '1px solid #eee', col: 4, imageOnSide: false, type: 'local', inputClass: 'fake', items: [
                            { value: 'Facebook', title: '{{lang}}Face Book', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/manual.svg' },
                            { value: 'WhatsApp', title: '{{lang}}Whats App', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/manual.svg' },
                            { value: 'Instagram', title: '{{lang}}Instagram', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/manual.svg' },
                        ],


                        placeholder: '{{lang}}Select', required: true
                    }, showMain: true
                },
                {
                    key: 'thirdparty', type: 'ThirdPartyInput', col: '12', section: 'sec-thirdparty', pages: ['information'], information: { label: '{{lang}}Connect', refKey: "type", required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'thirdparty',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "manual" } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                { key: 'name', type: 'TextInput', section: 'sec-config', col: '12', pages: ['information'], information: { label: '{{lang}}Name', placeholder: '{{lang}}Insert name', required: true } },
                { key: 'status', type: 'SelectInput', col: '12', section: 'sec-config', pages: ['information'], information: { type: "local", items: [{ title: '{{lang}}Active', value: 'active' }, { title: '{{lang}}Not active', value: 'notActive' }], label: '{{lang}}Status', placeholder: 'Choose...', required: true } },

                // { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'Facebook', value: 'facebook' }], label: '{{lang}}Channels', placeholder: 'Choose...', required: true } },
                // {
                //     type: 'SubformInput',
                //     key: 'facebook',
                //     information: {
                //         headers: [
                //             { key: 'description', type: 'TextAreaInput', col: '4', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
                //         ],

                //         placeholder: '{{lang}}placeholders.insertInformation',
                //         required: false
                //     },
                //     dependencies: [{
                //         refKey: 'type', targetKey: 'facebook',
                //         conditions: [{
                //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'facebook' } } }, },
                //             effect: { show: true, changeHeader: [{ key: 'information.required', value: true }] }
                //         }],
                //         else: { show: false, changeHeader: [{ key: 'information.required', value: false }] },
                //         init: true,
                //         // show:true,

                //     }],
                //     showMain: false,
                // },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },




        collections: {
            key: 'collections',
            title: '{{lang}}Collections',
            description: 'collections list',
            fetchUrl: 'getFrames',
            addUrl: 'postFrame',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            customEdit: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },


            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        collection: {
            key: 'collections/[var]',
            title: '{{lang}}Collections',
            description: 'collections list',
            fetchUrl: 'getFrames',
            addUrl: 'postFrame',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collectionBuilder',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            hideInDashboard: true,
            // addNew: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },

        newproject: {
            key: 'newproject/[var]',
            title: '{{lang}}newproject',
            description: 'newproject list',
            fetchUrl: 'getFrames',
            addUrl: 'postProject',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'newproject',
            options: {},
            sort: { 'cDate': -1 },
            hideInDashboard: true,
            customAdd: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            customEdit: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },


            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },


                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        newSubCollection: {
            key: 'newSubCollection/[var]',
            title: '{{lang}}newSubCollection',
            description: 'newSubCollection list',
            fetchUrl: 'getFrames',
            addUrl: 'postSubCollection',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'newSubCollection',
            options: {},
            sort: { 'cDate': -1 },
            hideInDashboard: true,
            customAdd: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            customEdit: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },


            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },

        page: {
            key: 'pages/[var]',
            title: '{{lang}}Page Builder',
            description: 'newpage list',
            fetchUrl: 'newpage',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            pageType: 'pageBuilder',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'addRule' },
            hideInDashboard: true,

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

        },



        newaccount: {
            key: 'newaccount',
            title: '{{lang}}Add New Account',
            description: 'Add New Account',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'newaccount',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: ['page', 'project'] },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },


        pages: {
            key: 'pages',
            title: '{{lang}}Pages',
            description: 'Pages list',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }, { type: 'setAsHomePage' }],
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: ['page', 'project'] },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Name', required: false } },
                // { key: 'slug', type: 'TextInput', col: '12', information: { label: '{{lang}}Slug', placeholder: '{{lang}}Slug', required: false } },

                { key: 'userPerspective', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Active user perspective', hideComponent: true, required: false } },

                { key: 'isDefault', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Home page', hideComponent: true, required: false } },

                // { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}desc', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },



        frames: {
            key: 'frames',
            title: '{{lang}}Frames',
            description: 'Frames list',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }, { type: 'setAsHomePage' }],
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'frames/[var]' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'frames/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },



        newFrame: {
            key: 'frames/[var]',
            title: '{{lang}}New Frame',
            description: 'New Frame',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            // yremoveRelation: 'yremoveConnection',
            actions: [{ type: 'edit' }, { type: 'remove' }, { type: 'setAsHomePage' }],
            pageType: 'frameBuilder',
            options: {},
            sort: { 'cDate': -1 },

            // customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'frames/[var]' },
            // customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'frames/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },


        // newform: {
        //     key: 'newform',
        //     title: '{{lang}}new form',
        //     description: 'newform list',
        //     fetchUrl: 'newform',
        //     addUrl: 'DiagramEditor',
        //     editUrl: 'editRelation',
        //     yremoveRelation: 'yremoveConnection',
        //     pageType: 'newform',
        //     options: {},
        //     sort: { 'cDate': -1 },
        //     addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
        //     // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     section: 'main',

        //     // actions: {
        //     //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
        //     //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        //     // },

        //     headers: [

        //         // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

        //         // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

        //         // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

        //         // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

        //         // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


        //         // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


        //         // { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
        //         // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
        //         // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
        //         // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

        //         // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
        //         // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

        //         // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
        //         // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

        //     ]
        // },

    }


}


const MainSettings = {


    sections: {
        main: { key: 'main', noChildren: false, name: '{{lang}}Main' },
    },

    pages: {
        config: {
            key: 'config',
            title: '{{lang}}Applet configuration',
            subtitle: '{{lang}}settings',

            description: '{{lang}}The general configuration and settings of the applet',
            fetchUrl: 'getAppletConfig',
            addUrl: 'postAppletConfig',
            editUrl: 'postAppletConfig',

            // removeUrl: 'removeInvoice',
            pageType: 'config',
            section: 'general',
            defaultPage: true,

            options: {},
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',


            headers: [


                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', information: { label: '{{lang}}Applet Name', placeholder: '{{lang}}Insert applet name', required: false, disabled: true } },
                // { type: 'ProfileImageInput', key: 'images', col: '12', section: 'sec-main', information: { label: '{{lang}}Applet Image', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false, disabled: true }, showMain: true },

                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-main', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: false },

                { key: 'colorType', type: 'SelectInput', col: '12', information: { label: '{{lang}}Color Type', type: 'local', items: [{ value: 'default', title: '{{lang}}Default' }, { value: 'sameAsHub', title: '{{lang}}Same as hub' }, { value: 'custom', title: '{{lang}}Custom' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true },

                // { key: 'colorSameAsHub', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Color same as hub', placeholder: '{{lang}}special', required: false }, showMain: true },

                {
                    key: 'colors.primaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Primary Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.primaryColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                {
                    key: 'colors.secondaryColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Secondary Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.secondaryColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                {
                    key: 'colors.textColor', type: 'ColorInput', col: '4', information: { label: '{{lang}}Text Color', placeholder: '{{lang}}Choose ...', required: false },
                    dependencies: [{
                        refKey: 'colorType',
                        targetKey: 'colors.textColor',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.colorType' }, operator: { value: '==' }, target: { value: 'custom' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },

                // { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },


                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },

            ]

        },
        automations: {
            key: 'automations',
            title: '{{lang}}Automations',
            description: 'automations list',
            fetchUrl: 'getAutomations',
            addUrl: 'postFlow',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'automations/[var]' },
            customEdit: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'automations/[var]' },

            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}' },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                { key: 'applets', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Applets', type: 'api', fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Name ...', required: false } },
                // { key: 'stages', type: 'TextInput', col: '12', information: { label: '{{lang}}Stages', placeholder: '{{lang}}Stages ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                // { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },
        automation: {
            key: 'automations/[var]',
            title: '{{lang}}Automation',
            description: 'Single Automation',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'automation',
            options: {},
            hideInDashboard: true,
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Automation', function: 'changePage', functionInput: 'automations/[var]' },

            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },



            ]
        },
        variables: {
            key: 'variables',
            title: '{{lang}}Variables',
            description: 'Variables list',
            fetchUrl: 'getVariables',
            addUrl: 'postVariables',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',


            headers: [


                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}variable.name', required: false } },
                { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: false } },

                {
                    key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
                    dependencies: [{
                        refKey: 'type',
                        targetKey: 'frame',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'or',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'frame' } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}value', placeholder: '{{lang}}value', required: false },
                    dependencies: [{
                        refKey: 'type',
                        targetKey: 'value',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'or',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'applet' } },
                                    2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'hub' } }

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                // { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },


                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


            ]
        },
        permissions: {
            key: 'permissions',
            title: '{{lang}}Permissions',
            description: 'Permissions list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Permission', function: 'changePage', functionInput: 'permissions/[var]' },
            customEdit: { title: '{{lang}}Add Permission', function: 'changePage', functionInput: 'permissions/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        permission: {
            key: 'permissions/[var]',
            title: '{{lang}}Permission',
            description: 'Single Permission',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'permission',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Permission', function: 'changePage', functionInput: 'permissions/[var]' },
            hideInDashboard: true,
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'applets', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Applets', placeholder: '{{lang}}Select ...', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        actions: {
            key: 'actions',
            title: '{{lang}}Actions',
            description: 'Actions list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customAdd: { title: '{{lang}}Add Action', function: 'changePage', functionInput: 'actions/[var]' },
            customEdit: { title: '{{lang}}Add Action', function: 'changePage', functionInput: 'actions/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        collections: {
            key: 'collections',
            title: '{{lang}}Collections',
            description: 'collections list',
            fetchUrl: 'getFrames',
            addUrl: 'postFrame',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            customEdit: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },


            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        collection: {
            key: 'collections/[var]',
            title: '{{lang}}Collections',
            description: 'collections list',
            fetchUrl: 'getFrames',
            addUrl: 'postFrame',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collectionBuilder',
            options: {},
            sort: { 'cDate': -1 },
            hideInDashboard: true,
            // addNew: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        newproject: {
            key: 'newproject/[var]',
            title: '{{lang}}newproject',
            description: 'newproject list',
            fetchUrl: 'getFrames',
            addUrl: 'postFrame',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'newproject',
            options: {},
            sort: { 'cDate': -1 },
            hideInDashboard: true,
            customAdd: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },
            customEdit: { title: '{{lang}}Add Collection', function: 'changePage', functionInput: 'collections/[var]' },


            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}", type: 'collection' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}name ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },
        page: {
            key: 'pages/[var]',
            title: '{{lang}}Page Builder',
            description: 'newpage list',
            fetchUrl: 'newpage',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            pageType: 'pageBuilder',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'addRule' },
            hideInDashboard: true,

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

        },
        pages: {
            key: 'pages',
            title: '{{lang}}Pages',
            description: 'Pages list',
            fetchUrl: 'getFrames',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'pages/[var]' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", type: 'page' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                // { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },


    }


}




const BookingUserPages = {


    sections: {
    },


    pages: {




        orders: {
            key: 'orders',
            title: '{{lang}}orders',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getUserOrders',
            // addUrl: 'postProductCategory',
            // editUrl: 'postProductCategory',
            // removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            // description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        vouchers: {
            key: 'vouchers',
            title: '{{lang}}Vouchers',
            description: 'Vouchers list',
            fetchUrl: 'getUserVouchers',
            // addUrl: 'postProductCategory',
            // editUrl: 'postProductCategory',
            // removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        addresses: {
            key: 'addresses',
            title: '{{lang}}addresses',
            description: 'Addresses list',
            fetchUrl: 'getUserAddresses',
            addUrl: 'postUserAddress',
            editUrl: 'postUserAddress',
            removeUrl: 'removeUserAddress',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        whishlist: {
            key: 'whishlist',
            title: '{{lang}}whishlist',
            description: 'Addresses list',
            fetchUrl: 'getUserWhishlist',
            // addUrl: 'postUserAddress',
            // editUrl: 'postUserAddress',
            removeUrl: 'removeUserWhishlist',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        payments: {
            key: 'payments',
            title: '{{lang}}Payments',
            description: 'DeliveryTypes',
            fetchUrl: 'getUserPayments',
            // addUrl: 'postDeliveryType',
            // editUrl: 'postDeliveryType',
            // removeUrl: 'removeDeliveryType',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                // { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // { key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },
                // { key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },
                // { key: 'availableForAllHubs', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // { key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false } },
                // { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },
                // { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
                // { key: 'maxOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Order Price', placeholder: '{{lang}}maxOrderPrice', required: false } },
                // { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
                // { key: 'maxOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Order Count', placeholder: '{{lang}}maxOrderCount', required: false } },
                // { key: 'extraDiscount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'minDays', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Days', placeholder: '{{lang}}minDays', required: false } },
                // { key: 'maxDays', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Days%', placeholder: '{{lang}}maxDays', required: false } },
                // { key: 'deliveryPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'paymentTypes', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Payment Types', address: 'getPaymentTypes', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        paymentTypes: {
            key: 'paymentTypes',
            title: '{{lang}}Payment Types',
            description: 'paymentTypes',
            fetchUrl: 'getPaymentTypes',
            addUrl: 'postPaymentType',
            editUrl: 'postPaymentType',
            removeUrl: 'removePaymentType',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "cash", value: 'cash' }, { title: "online", value: 'online' }] }, showMain: true, inExport: true },
                { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'products',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'productCategories',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                    dependencies: [{
                        refKey: 'availableForAllHubs',
                        targetKey: 'hubs',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'haveConditions', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Have Conditions', placeholder: '{{lang}}haveConditions', default: true, required: false } },
                { key: 'conditions.prePayType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Pre Pay Type', required: false, type: 'local', items: [{ title: "const", value: 'const' }, { title: "percentage", value: 'percentage' }] }, showMain: true, inExport: true },
                { key: 'conditions.prePay', type: 'NumberInput', col: '6', information: { label: '{{lang}}Pre Pay', placeholder: '{{lang}}prePay', required: false } },
                { key: 'conditions.timingType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Timing Type', required: false, type: 'local', items: [{ title: "week", value: 'week' }, { title: "month", value: 'month' }, { title: "year", value: 'year' }] }, showMain: true, inExport: true },
                { key: 'conditions.timing', type: 'NumberInput', col: '6', information: { label: '{{lang}}Timing', placeholder: '{{lang}}timing', required: false } },
                { key: 'conditions.extraChargeType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Extra Charge Type', required: false, type: 'local', items: [{ title: "on total", value: 'on total' }, { title: "on remaining", value: 'on remaining' }] }, showMain: true, inExport: true },
                { key: 'conditions.extraCharge', type: 'NumberInput', col: '6', information: { label: '{{lang}}Extra Charge%', placeholder: '{{lang}}extracharge%', required: false } },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        priceList: {
            key: 'priceLists',
            title: '{{lang}}Price List',
            description: 'Price List',
            fetchUrl: 'getPriceLists',
            addUrl: 'postPriceList',
            editUrl: 'postPriceList',
            removeUrl: 'removePriceList',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/events.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'priceListCode', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'products',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'productCategories',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                    dependencies: [{
                        refKey: 'availableForAllHubs',
                        targetKey: 'hubs',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

                { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
                { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
                { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },

        credits: {
            key: 'credits',
            title: '{{lang}}Credits',
            description: "Users' Credits",
            fetchUrl: 'getProductsCategories',
            icon: '/assets/icons/applets/general/pages.png',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/Asset 8.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'parent', type: 'SelectInput', col: '6', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        vouchers: {
            key: 'vouchers',
            title: '{{lang}}Vouchers',
            description: 'Vouchers',
            fetchUrl: 'getVouchers',
            addUrl: 'postVoucher',
            editUrl: 'postVoucher',
            removeUrl: 'removeVoucher',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ad-center.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'code', type: 'TextInput', col: '6', information: { label: '{{lang}}code', placeholder: '{{lang}}code', required: false } },
                { key: 'automaticApply', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Automatic Apply', placeholder: '{{lang}}automaticApply', default: true, required: false } },
                { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "first", value: 'first' }, { title: "second", value: 'second' }] }, showMain: true, inExport: true },

                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false } },
                { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'products',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'productCategories',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                    dependencies: [{
                        refKey: 'availableForAllHubs',
                        targetKey: 'hubs',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

                { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
                { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
                { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                { key: 'maxVoucherUse', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Voucher Use', placeholder: '{{lang}}maxVoucherUse', required: false } },
                { key: 'maxHubsUse', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Hubs Use', placeholder: '{{lang}}maxHubsUse', required: false } },
                { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                { key: 'expiry', type: 'DateInput', col: '3', information: { label: '{{lang}}Expiry', placeholder: '{{lang}}expiry', required: false }, showMain: true },
                {
                    type: 'SubformInput',
                    key: 'discount',
                    information: {
                        headers: [
                            { key: 'unit', type: 'SelectInput', col: '4', information: { label: '{{lang}}unit', required: false, type: 'local', items: [{ title: "percentage", value: 'percentage' }, { title: "cash", value: 'cash' }] } },
                            { key: 'discount', type: 'NumberInput', col: '4', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: false } },
                            { key: 'maxDiscount', type: 'PriceInput', col: '4', information: { label: '{{lang}}maxDiscount', placeholder: '{{lang}}maxDiscount', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    showMain: false
                },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        settings: {
            key: 'settings',
            title: '{{lang}}Settings',
            description: 'Settings list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeExtraSection',
            // helperKey: 'values',
            pageType: 'settings',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/crisis.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'connections', type: 'TextInput', col: '12', information: { label: '{{lang}}connections', placeholder: '{{lang}}name', required: false } },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },

        addresses: {
            key: 'addresses',
            title: '{{lang}}addresses',
            description: 'addresses list',
            fetchUrl: 'getAddresses',
            addUrl: 'postAddress',
            editUrl: 'postAddress',
            removeUrl: 'removeAddress',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/climate.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { col: '6', key: 'name', type: 'TextInput', information: { label: 'name', placeholder: '{{lang}}name', required: false, } },
                { col: '6', key: 'country', type: 'SelectInput', information: { label: '{{lang}}country', updateAfterSelect: true, isSearchable: true, address: 'getAllCountries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select state', required: false }, showMain: false },
                { col: '6', key: 'province', type: 'TextInput', information: { label: 'province/state', placeholder: '{{lang}}province/state', required: false, } },
                { col: '6', key: 'city', type: 'TextInput', information: { label: 'city', placeholder: '{{lang}}city', required: false, } },
                { col: "6", key: 'zipCode', type: 'TextInput', information: { label: 'Zip code', placeholder: '{{lang}}Zip code', required: false, } },
                { key: 'Phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Capacity', placeholder: '{{lang}}number', required: false } },
                { col: "12", key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: false, } },

                // { key: 'location', type: 'MapLeafletInput', information: { label: 'Location', placeholder: '', disabled: false, required: false, }, showMain: false },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}Code', required: false } },


            ]
        },

    },

}


const CommerceUserPages = {


    sections: {
    },


    pages: {




        orders: {
            key: 'orders',
            title: '{{lang}}orders',
            description: 'orders list',
            fetchUrl: 'getUserOrders',
            // addUrl: 'postProductCategory',
            // editUrl: 'postProductCategory',
            // removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',
            model: 'orders',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        vouchers: {
            key: 'vouchers',
            title: '{{lang}}Vouchers',
            description: 'Vouchers list',
            fetchUrl: 'getUserVouchers',
            // addUrl: 'postProductCategory',
            // editUrl: 'postProductCategory',
            // removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',
            model: 'vouchers',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        addresses: {
            key: 'addresses',
            title: '{{lang}}addresses',
            description: 'Addresses list',
            fetchUrl: 'getUserAddresses',
            addUrl: 'postUserAddress',
            editUrl: 'postUserAddress',
            removeUrl: 'removeUserAddress',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        whishlist: {
            key: 'whishlist',
            title: '{{lang}}whishlist',
            description: 'Addresses list',
            fetchUrl: 'getUserWhishlist',
            // addUrl: 'postUserAddress',
            // editUrl: 'postUserAddress',
            removeUrl: 'removeUserWhishlist',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        payments: {
            key: 'payments',
            title: '{{lang}}Payments',
            description: 'DeliveryTypes',
            fetchUrl: 'getUserPayments',
            // addUrl: 'postDeliveryType',
            // editUrl: 'postDeliveryType',
            // removeUrl: 'removeDeliveryType',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                // { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // { key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },
                // { key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },
                // { key: 'availableForAllHubs', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // { key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false } },
                // { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },
                // { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
                // { key: 'maxOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Order Price', placeholder: '{{lang}}maxOrderPrice', required: false } },
                // { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
                // { key: 'maxOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Order Count', placeholder: '{{lang}}maxOrderCount', required: false } },
                // { key: 'extraDiscount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'minDays', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Days', placeholder: '{{lang}}minDays', required: false } },
                // { key: 'maxDays', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Days%', placeholder: '{{lang}}maxDays', required: false } },
                // { key: 'deliveryPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'paymentTypes', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Payment Types', address: 'getPaymentTypes', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        paymentTypes: {
            key: 'paymentTypes',
            title: '{{lang}}Payment Types',
            description: 'paymentTypes',
            fetchUrl: 'getPaymentTypes',
            addUrl: 'postPaymentType',
            editUrl: 'postPaymentType',
            removeUrl: 'removePaymentType',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "cash", value: 'cash' }, { title: "online", value: 'online' }] }, showMain: true, inExport: true },
                { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'products',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'productCategories',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                    dependencies: [{
                        refKey: 'availableForAllHubs',
                        targetKey: 'hubs',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'haveConditions', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Have Conditions', placeholder: '{{lang}}haveConditions', default: true, required: false } },
                { key: 'conditions.prePayType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Pre Pay Type', required: false, type: 'local', items: [{ title: "const", value: 'const' }, { title: "percentage", value: 'percentage' }] }, showMain: true, inExport: true },
                { key: 'conditions.prePay', type: 'NumberInput', col: '6', information: { label: '{{lang}}Pre Pay', placeholder: '{{lang}}prePay', required: false } },
                { key: 'conditions.timingType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Timing Type', required: false, type: 'local', items: [{ title: "week", value: 'week' }, { title: "month", value: 'month' }, { title: "year", value: 'year' }] }, showMain: true, inExport: true },
                { key: 'conditions.timing', type: 'NumberInput', col: '6', information: { label: '{{lang}}Timing', placeholder: '{{lang}}timing', required: false } },
                { key: 'conditions.extraChargeType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Extra Charge Type', required: false, type: 'local', items: [{ title: "on total", value: 'on total' }, { title: "on remaining", value: 'on remaining' }] }, showMain: true, inExport: true },
                { key: 'conditions.extraCharge', type: 'NumberInput', col: '6', information: { label: '{{lang}}Extra Charge%', placeholder: '{{lang}}extracharge%', required: false } },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        priceList: {
            key: 'priceLists',
            title: '{{lang}}Price List',
            description: 'Price List',
            fetchUrl: 'getPriceLists',
            addUrl: 'postPriceList',
            editUrl: 'postPriceList',
            removeUrl: 'removePriceList',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/events.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'priceListCode', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'products',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'productCategories',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                    dependencies: [{
                        refKey: 'availableForAllHubs',
                        targetKey: 'hubs',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

                { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
                { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
                { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        // wallet: {
        //     key: 'wallet',
        //     title: '{{lang}}Wallet',
        //     description: 'Price list',
        //     fetchUrl: 'getProductsCategories',
        //     addUrl: 'postProductCategory',
        //     editUrl: 'postProductCategory',
        //     removeUrl: 'removeProductCategory',
        //     // helperKey: 'values',
        //     pageType: 'collection',
        //     section:'loyaltysystem',
        wallet: {
            key: 'wallet',
            title: '{{lang}}Wallet',
            description: 'Price list',
            fetchUrl: 'getProductsCategories',
            icon: '/assets/icons/applets/general/pages.png',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/Asset 8.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'parent', type: 'SelectInput', col: '6', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        vouchers: {
            key: 'vouchers',
            title: '{{lang}}Vouchers',
            description: 'Vouchers',
            fetchUrl: 'getVouchers',
            addUrl: 'postVoucher',
            editUrl: 'postVoucher',
            removeUrl: 'removeVoucher',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ad-center.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
                { key: 'voucherCode', type: 'TextInput', col: '6', information: { label: '{{lang}}code', placeholder: '{{lang}}code', required: false } },
                { key: 'automaticApply', type: 'SwitchInput', col: '6', information: { label: '{{lang}}Automatic Apply', placeholder: '{{lang}}automaticApply', default: true, required: false } },
                { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "first", value: 'first' }, { title: "second", value: 'second' }] }, showMain: true, inExport: true },

                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false } },
                { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'products',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                {
                    key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                    dependencies: [{
                        refKey: 'availableForAllProducts',
                        targetKey: 'productCategories',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                {
                    key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                    dependencies: [{
                        refKey: 'availableForAllHubs',
                        targetKey: 'hubs',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                },
                { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

                { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
                { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
                { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                { key: 'maxVoucherUse', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Voucher Use', placeholder: '{{lang}}maxVoucherUse', required: false } },
                { key: 'maxHubsUse', type: 'NumberInput', col: '6', information: { label: '{{lang}}Max Hubs Use', placeholder: '{{lang}}maxHubsUse', required: false } },
                { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                { key: 'expiry', type: 'DateInput', col: '3', information: { label: '{{lang}}Expiry', placeholder: '{{lang}}expiry', required: false }, showMain: true },
                {
                    type: 'SubformInput',
                    key: 'discount',
                    information: {
                        headers: [
                            { key: 'unit', type: 'SelectInput', col: '4', information: { label: '{{lang}}unit', required: false, type: 'local', items: [{ title: "percentage", value: 'percentage' }, { title: "cash", value: 'cash' }] } },
                            { key: 'discount', type: 'NumberInput', col: '4', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: false } },
                            { key: 'maxDiscount', type: 'PriceInput', col: '4', information: { label: '{{lang}}maxDiscount', placeholder: '{{lang}}maxDiscount', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    showMain: false
                },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        settings: {
            key: 'settings',
            title: '{{lang}}Settings',
            description: 'Settings list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeExtraSection',
            // helperKey: 'values',
            pageType: 'settings',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/crisis.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'connections', type: 'TextInput', col: '12', information: { label: '{{lang}}connections', placeholder: '{{lang}}name', required: false } },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },
        // warehouses: {
        //     key: 'warehouses',
        //     title: '{{lang}}Warehouses',
        //     description: 'Warehouse list',
        //     fetchUrl: 'getWarehouses',
        //     addUrl: 'postWarehouse',
        //     editUrl: 'postWarehouse',
        //     removeUrl: 'removeWarehouse',
        //     // helperKey: 'values',
        //     pageType: 'collection',
        //     section: 'inventory',

        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
        //     icon: '/assets/icons/applets/general/climate.png',
        //     image: '/images/covers/settings.jpg',

        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
        //         { key: 'code', type: 'TextInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}code', required: false } },
        //         { key: 'parent', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
        //         { col: '12', key: 'address', type: 'TextInput', information: { label: '{{lang}}address', updateAfterSelect: true, isSearchable: true, address: 'getMyAddresses', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select state', required: false }, showMain: false },

        //         { key: 'lock', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Locked', placeholder: '{{lang}}name', required: false, hideFromMenu: true }, hideComponent: true },

        //         // { key: 'code', type: 'TextInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}code', required: false } },
        //         // { key: 'address', type: 'TextInput', col: '12', information: { label: '{{lang}}Address', placeholder: '{{lang}}address', required: false } },
        //         // { key: 'zipcode', type: 'TextInput', col: '12', information: { label: '{{lang}}Zip code', placeholder: '{{lang}}zip code', required: false } },
        //         // { key: 'country', type: 'TextInput', col: '12', information: { label: '{{lang}}Country', placeholder: '{{lang}}country', required: false } },
        //         // { key: 'provinces', type: 'TextInput', col: '12', information: { label: '{{lang}}Provinces', placeholder: '{{lang}}provinces', required: false } },
        //         // { key: 'city', type: 'TextInput', col: '12', information: { label: '{{lang}}City', placeholder: '{{lang}}city', required: false } },
        //         // { key: 'Phone', type: 'NumberInput', col: '12', information: { label: '{{lang}}Capacity', placeholder: '{{lang}}number', required: false } },

        //     ]
        // },
        addresses: {
            key: 'addresses',
            title: '{{lang}}addresses',
            description: 'addresses list',
            fetchUrl: 'getAddresses',
            addUrl: 'postAddress',
            editUrl: 'postAddress',
            removeUrl: 'removeAddress',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/climate.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { col: '6', key: 'name', type: 'TextInput', information: { label: 'name', placeholder: '{{lang}}name', required: false, } },
                { col: '6', key: 'country', type: 'SelectInput', information: { label: '{{lang}}country', updateAfterSelect: true, isSearchable: true, address: 'getAllCountries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select state', required: false }, showMain: false },
                { col: '6', key: 'province', type: 'TextInput', information: { label: 'province/state', placeholder: '{{lang}}province/state', required: false, } },
                { col: '6', key: 'city', type: 'TextInput', information: { label: 'city', placeholder: '{{lang}}city', required: false, } },
                { col: "6", key: 'zipCode', type: 'TextInput', information: { label: 'Zip code', placeholder: '{{lang}}Zip code', required: false, } },
                { key: 'Phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Capacity', placeholder: '{{lang}}number', required: false } },
                { col: "12", key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: false, } },

                // { key: 'location', type: 'MapLeafletInput', information: { label: 'Location', placeholder: '', disabled: false, required: false, }, showMain: false },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}Code', required: false } },


            ]
        },
        inventoryTransactions: {
            key: 'inventoryTransactions',
            title: '{{lang}}inventoryTransactions',
            description: 'inventoryTransactions list',
            fetchUrl: 'getInventoryTransactions',
            addUrl: 'postInventoryTransaction',
            editUrl: 'postInventoryTransaction',
            removeUrl: 'removeInventoryTransaction',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'inventory',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/climate.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}type', required: false, type: 'local', items: [{ title: "input", value: 'input' }, { title: "output", value: 'output' }] }, showMain: true, inExport: true },
                { key: 'status', type: 'SelectInput', col: '6', information: { label: '{{lang}}status', required: false, type: 'local', items: [{ title: "sold", value: 'sold' }, { title: "bought", value: 'bought' }] }, showMain: true, inExport: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: "{{lang}}transaction's title", placeholder: "{{lang}}transaction's title", required: false } },
                { key: 'transactionCode', type: 'TextInput', col: '12', information: { label: '{{lang}}transactionCode', placeholder: '{{lang}}transactionCode', required: false } },
                { key: 'warehouse', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'source.warehouse', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'source.warehouse', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'destination.otherSource', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'destination.otherDestination', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'totalCount', type: 'TextInput', col: '12', information: { label: '{{lang}}Zip code', placeholder: '{{lang}}zip code', required: false } },
                { key: 'totalValue', type: 'TextInput', col: '12', information: { label: '{{lang}}Country', placeholder: '{{lang}}country', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Provinces', placeholder: '{{lang}}provinces', required: false } },
                { key: 'files', type: 'FileInput', col: '12', information: { label: '{{lang}}City', placeholder: '{{lang}}city', required: false } },

                {
                    type: 'SubformInput',
                    key: 'products',
                    information: {
                        headers: [
                            { key: 'product', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}product', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'count', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.count', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'value', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.price', placeholder: '{{lang}}useful.price', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    showMain: false
                },
            ]
        },
    },

}




const CommercePages = {


    sections: {
        main: { key: 'main', name: '{{lang}}Main', icon: '/images/applets-icons/accounting/063-cart.svg' },
        inventory: { key: 'inventory', name: '{{lang}}Inventory', icon: '/images/applets-icons/accounting/063-cart.svg' },
        orders: { key: 'orders', name: '{{lang}}Orders', icon: '/images/applets-icons/accounting/063-cart.svg' },
        loyaltySystem: { key: 'loyaltysystem', name: '{{lang}}Loyalty System', icon: '/images/applets-icons/accounting/063-cart.svg' },

        // purchases: { key: 'purchases', name: 'Purchases', icon: '/images/applets-icons/accounting/shopping-bag.svg' },
        // accountant: { key: 'accountant', name: 'Accountant', icon: '/images/applets-icons/accounting/book.svg' },
        // reports: { key: 'reports', name: 'Reports', icon: '/images/applets-icons/accounting/increasing.svg' },
        // settings: { key: 'settings', name: 'Settings', icon: '/images/settings-4.svg' },
    },


    pages: {

        products: {
            key: 'products',
            title: '{{lang}}Products & Services',
            fetchUrl: 'getProducts',
            addUrl: 'postProduct',
            editUrl: 'postProduct',
            section: 'main',
            removeUrl: 'removeProduct',
            pageType: 'collection',
            model: 'products',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            actions: [{ type: 'edit' }, { type: 'remove' }],
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            formPages: [
                {
                    label: '{{lang}}Product Type', key: 'type',
                    // changeConditions: [
                    //     {
                    //         nextPage: 'information',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "physical" } }
                    //                 }
                    //             },
                    //         },
                    //     },
                    //     {
                    //         nextPage: 'membership',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "membership" } }
                    //                 }
                    //             },
                    //         },
                    //     },
                    //     {
                    //         nextPage: 'service',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "service" } }
                    //                 }
                    //             },
                    //         },
                    //     },
                    //     {
                    //         nextPage: 'digital',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "digital" } }
                    //                 }
                    //             },
                    //         },
                    //     }
                    // ]
                },
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-main', information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-media', information: { label: '{{lang}}Images and Videos', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-price', information: { label: '{{lang}}Pricing' } },
                        { key: 'sec-inventory', information: { label: '{{lang}}Inventory' } },

                        { key: 'sec-delivery-financial', information: { label: '{{lang}}Delivery & Financial' } },


                        { key: 'sec-additional', information: { label: '{{lang}}Additional', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-extra', information: { label: '{{lang}}Extra Information' } },
                        { key: 'sec-selling', information: { label: '{{lang}}Selling Tools' } },

                        { key: 'sec-custom', information: { label: '{{lang}}Custom Fields' } },

                    ]
                },
                // { label: '{{lang}}Membership', key: 'membership', isLastPage: true }
            ],


            headers: [

                { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },

                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Type', backgroundColor: '#f8f8f8', border: '1px solid #eee', col: 4, imageOnSide: false, type: 'local', inputClass: 'fake', items: [
                            { value: 'physical', title: '{{lang}}Physical', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/price-tag.png' },
                            { value: 'service', title: '{{lang}}Service', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/useful/bot.png' },
                            { value: 'digital', title: '{{lang}}Digital download', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/useful/stack1.png' },
                            { value: 'membership', title: '{{lang}}Membership', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/useful/key.png' }],

                        placeholder: '{{lang}}Select', required: true
                    }, showMain: false
                },

                // { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', maxWidth: '50%', pages: ['information'], information: { label: '{{lang}}Name', autoFocus: true, placeholder: '{{lang}}Insert product name', required: true } },
                // { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Short description', rows: 4, showToolbar: true, placeholder: '{{lang}}Write a short description about this product / service.\nIf you need to add more information, you can use the additionals section.', required: false, style: { minHeight: 100, } }, showMain: false },
                { key: 'barcode', type: 'BarCodeGeneratorInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Barcode', length: 7, placeholder: '{{lang}}e.g. 23AVBF346D', required: true, disabled: false }, showMain: true },

                // { key: 'additional', type: 'SubFormInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', showToolbar: true, placeholder: '{{lang}}description', required: false, style: { minHeight: 100, } }, showMain: false },




                { key: 'category', type: 'MultiLevelSelect', col: '6', section: 'sec-main', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Category', address: 'getProductsCategories', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}category', required: false } },

                {
                    key: 'unit', type: 'SelectInput', col: '6', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Unit', type: 'local', items: [{ value: 'piece', title: 'piece' }, { value: 'box', title: 'box' }, { value: 'kg', title: 'kg' }, { value: 'cm', title: 'cm' }], placeholder: '{{lang}}Select', required: false },
                    dependencies: [{
                        refKey: 'type',
                        targetKey: 'unit',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'physical' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },



                // { key: 'sec-media', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Images and Videos', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },

                { type: 'ImageInput', key: 'media', col: '12', section: 'sec-media', pages: ['information'], information: { label: 'Media', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'productsCode', type: 'TextInput', col: '6',page:'informaton', information: { label: '{{lang}}Products Code', placeholder: '{{lang}}productsCode', required: false } },




                // { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

                //   {
                //     type: 'SelectInput', key: 'priceType', col: '6', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Pricing type', type: 'local', items: [{ value: 'fixed', title: 'Fixed amount' }, { value: 'subscription', title: 'Subscription' }, { value: 'free', title: 'Free' }, { value: 'config', title: 'Based on config' }, { value: 'contact', title: 'Contact' }], isSearchable: true, placeholder: '{{lang}}type', required: true },
                //     dependencies: [{
                //       refKey: 'type', targetKey: 'priceType',
                //       conditions: [{
                //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                //         effect: { show: true }
                //       }],
                //       else: { show: false },
                //       init: true,

                //     }],
                //     showMain: false
                //   },
                {
                    type: 'SelectInput', key: 'duration', col: '6', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Duration', type: 'local', items: [{ value: 'year', title: 'Annual' }, { value: 'month', title: 'monthly' }, { value: 'week', title: 'weekly' }], isSearchable: true, placeholder: '{{lang}}type', required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'duration',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },




                // {
                //   type: 'SubformInput',
                //   key: 'subscriptionPrice',
                //   col: '12',
                //   section: 'sec-price',

                //   // tab: 'specifications',
                //   pages: ['information'],
                //   information: {
                //     label: '{{lang}}Pricing options',
                //     help: '{{lang}}You can create different prices for different subscription durations.',
                //     // formType: 'modal',
                //     headers: [
                //       { key: 'price', type: 'PriceInput', col: '4', information: { label: '{{lang}}Price', autoFocus: true, placeholder: '{{lang}}0', required: true }, showMain: true },

                //       {
                //         key: 'repeat', type: 'componentSwitcher', col: '4',
                //         information: {
                //           label: '{{lang}}Repeats every', required: true,
                //         },
                //         states: [

                //           {
                //             conditions: [{
                //               root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.duration' }, operator: { value: '==' }, target: { value: 'week' } } }, },
                //               effect: { show: false }
                //             }],

                //             header: { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }, { value: 2, title: '2' }, { value: 3, title: '3' }, { value: 4, title: '4' }, { value: 5, title: '5' }, { value: 6, title: '6' }, { value: 7, title: '7' }, { value: 8, title: '8' }, { value: 9, title: '9' }, { value: 10, title: '10' }, { value: 11, title: '11' }, { value: 12, title: '12' }], isSearchable: true, placeholder: '{{lang}}Type', required: true, disabled: true }, showMain: true, disabled: true },

                //           },

                //           {
                //             conditions: [{
                //               root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.duration' }, operator: { value: '==' }, target: { value: "month" } } }, },
                //               effect: { show: false }
                //             }],

                //             header: { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }, { value: 2, title: '2' }, { value: 3, title: '3' }, { value: 4, title: '4' }, { value: 5, title: '5' }, { value: 6, title: '6' }, { value: 7, title: '7' }, { value: 8, title: '8' }, { value: 9, title: '9' }, { value: 10, title: '10' }, { value: 11, title: '11' }, { value: 12, title: '12' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },


                //           },

                //           {
                //             conditions: [{
                //               root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.duration' }, operator: { value: '==' }, target: { value: 'year' } } }, },
                //               effect: { show: false }
                //             }],

                //             header: { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }], isSearchable: true, placeholder: '{{lang}}Type', required: true, disabled: true }, showMain: true, disabled: true },
                //           },


                //         ]
                //         , showMain: true
                //       },
                //       // { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }, { value: 2, title: '2' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },
                //       { key: 'duration', type: 'SelectInput', col: '4', information: { label: '{{lang}}Duration', type: 'local', default: 'month', items: [{ value: 'week', title: '{{lang}}Week(s)' }, { value: 'month', title: '{{lang}}Month(s)' }, { value: 'year', title: '{{lang}}Year' }], isSearchable: false, placeholder: '{{lang}}Duration', required: true }, showMain: true },
                //     ],
                //     placeholder: '{{lang}}specifications',
                //     required: false,
                //   },
                //   dependencies: [{
                //     refKey: ['type', 'priceType'], targetKey: 'subscriptionPrice',
                //     conditions: [{
                //       root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } }, 2: { id: 2, source: { value: '@data.priceType' }, operator: { value: '==' }, target: { value: 'subscription' } } }, },
                //       effect: { show: true }
                //     }],
                //     else: { show: false },
                //     init: true,

                //   }],
                //   showMain: false

                // },



                {
                    key: 'price', type: 'PriceInput', col: '12', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Selling Price', withDiscount: true, placeholder: '{{lang}}Selling Price', required: false },
                    // dependencies: [{
                    //   refKey: 'type', targetKey: 'price',
                    //   conditions: [{
                    //     root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                    //     effect: { show: true }
                    //   }],
                    //   else: { show: false },
                    //   init: true,

                    // }],
                },


                {
                    key: 'hasCountryPrice', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Has Country Price', required: false, default: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'priceType',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: true
                },
                {
                    type: 'SubformInput',
                    key: 'subscriptionPrice',
                    col: '12',
                    section: 'sec-price',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Pricing options',
                        help: '{{lang}}You can create different prices for different countries.',
                        // formType: 'modal',
                        headers: [
                            { key: 'price', type: 'PriceInput', col: '4', information: { label: '{{lang}}Price', autoFocus: true, placeholder: '{{lang}}0', required: true }, showMain: true },
                            { key: 'regions', type: 'RegionsInput', col: '4', information: { isSearchable: true, label: '{{lang}}Regions', address: 'getCountries', filter: {}, fields: { title: 'name', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: '', help: "", placeholder: '{{lang}}International', required: false }, showMain: true },
                            { key: 'currency', type: 'RegionsInput', col: '4', information: { isSearchable: true, label: '{{lang}}Currency', address: 'getCountries', filter: {}, fields: { title: 'currency', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: '', help: "", placeholder: '{{lang}}International', required: false }, showMain: true },


                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: ['hasCountryPrice'], targetKey: 'subscriptionPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hasCountryPrice' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false

                },


                {
                    key: 'inventory.cost', type: 'PriceInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Cost of good', leftIndicator: '{{currency}}', placeholder: '0', required: false, help: 'The amount you’re spending to produce and sell this product. Your customers won’t see this.' },
                    dependencies: [{
                        refKey: 'type', targetKey: 'inventory.cost',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                {
                    key: 'profit', type: 'FormulaInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Profit', formula: '{{price.final}} - {{inventory.cost}}', placeholder: '{{lang}}Profit', help: 'The price of the product minus your cost of goods.', required: false, disabled: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'profit',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                {
                    key: 'margin', type: 'FormulaInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Margin', rightIndicator: '%', minusInfinity: -100, formula: '(({{price.final}} - {{inventory.cost}}) / {{price.final}}) * 100', placeholder: '{{lang}}Margin', help: 'The percentage of the price that’s left after deducting your cost of goods.', required: false, disabled: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'margin',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },







                {
                    key: 'isPhysical', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Item is physical', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'isPhysical',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                {
                    type: 'MultiSelectInput', key: 'fulfillments', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Available Fulfillments', address: 'getDeliveryTypes', groupBy: [{ key: 'type', options: [{ key: '*', label: '{{lang}}Fulfillments' }, { key: 'group', label: '{{lang}}Groups' }] }], fields: { title: 'name', value: '_id', type: 'type' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default option', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'fulfillments',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                { type: 'MultiSelectInput', key: 'taxes', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Taxes', address: 'getTaxes', groupBy: [{ key: 'type', options: [{ key: 'single', label: '{{lang}}Single rate' }, { key: 'group', label: '{{lang}}Taxes group' }] }], fields: { title: 'name', value: '_id', type: 'type' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default tax', required: false }, showMain: false },

                { type: 'SelectInput', key: 'salesAccount', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Sales account', address: 'getAccounts', groupBy: [{ key: 'type', options: [{ key: 'income', label: '{{lang}}Income' }, { key: 'expense', label: '{{lang}}Expense' }] }], fields: { title: 'name', value: '_id', type: 'type', }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default sales account', required: false }, showMain: false },

                {
                    type: 'SelectInput', key: 'purchasesAccount', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Purchase account', address: 'getAccounts', groupBy: [{ key: 'type', options: [{ key: 'income', label: '{{lang}}Income' }, { key: 'expense', label: '{{lang}}Expense' }] }], fields: { title: 'name', value: '_id', type: 'type', }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default purchases account', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'purchasesAccount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                // {
                //     key: 'priceSttings.discount.value', type: 'PriceInput', col: '6', pages: ['information'], section: 'sec-price',
                //     information: {
                //         label: '{{lang}}Discount', help: 'Discount based on percentage or amount', placeholder: '{{lang}}Discount', required: false,
                //         unit: { key: 'priceSttings.discount.type', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}Select', required: true }, showMain: true }

                //     },
                //     showMain: true
                // },

                // {
                //     key: 'priceSttings.discount', type: 'CombinedInput', col: '6', pages: ['information'], section: 'sec-price',
                //     information: {
                //         label: '{{lang}}Discount', headers: [
                //             { key: 'priceSttings.discount.value', type: 'PriceInput', col: '9', information: { label: '{{lang}}Discount', hint: 'Discount based on percentage or cash', placeholder: '{{lang}}Discount', required: false } },
                //             { key: 'priceSttings.discount.type', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}Select', required: false }, showMain: true },
                //         ], showMain: true
                //     }
                // },





                // { key: 'sec-selling', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Selling Tools' } },







                // { key: 'priceSttings.discount.type', type: 'SelectInput', col: '6', pages: ['information'], information: { label: '{{lang}}type', type: 'local', items: [{ value: 'percent', title: 'percentage' }, { value: 'cash', title: 'cash' }], placeholder: '{{lang}}Select', required: false }, showMain: true },

                // { key: 'priceSttings.discount.value', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Discount', hint: 'Discount based on percentage or cash', placeholder: '{{lang}}Discount', required: false } },

                // { key: 'priceSttings.currency', type: 'SelectInput', col: '6',page:'informaton', information: { label: '{{lang}}Choose currency', type: 'local', items: [{ value: 'USD', title: 'USD' }, { value: 'IRR', title: 'IRR' }], placeholder: '{{lang}}Select', required: false }, showMain: false },
                // { type: 'SelectInput', key: 'status', col: '6',page:'informaton', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: false }, showMain: true },
                // { key: 'sec-inventory', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Inventory' }, showMain: false },

                {
                    key: 'inventory.dimensions', type: 'DimensionsInput', col: '6', pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Dimensions', placeholder: 'Insert ...', required: false, disabled: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'inventory.dimensions',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: true
                },


                {
                    key: 'includesVariants', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Includes variants', placeholder: '{{lang}}Includes variants', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'includesVariants',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                {
                    key: 'inventory.stock', type: 'StockInput', col: '12', pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Stock', placeholder: '0', required: false, disabled: false },
                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'stock',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: true
                },

                {
                    key: 'available', type: 'SwitchInput', col: "4", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false },
                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'available',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: true
                },


                {
                    key: 'track', type: 'SwitchInput', col: "4", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Unlimited stock', placeholder: '{{lang}}Unlimited stock', default: true, required: false },
                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'track',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: true
                },


                {
                    type: 'SubformInput',
                    key: 'variants',
                    col: '12',
                    // tab: 'specifications',
                    pages: ['information'],
                    section: 'sec-inventory',
                    information: {
                        editInModal: true,
                        defaultRow: true,
                        label: '{{lang}}Variants List',
                        help: 'Product variants allow you to list different versions of the same product, like clothes in different colors or sizes.',

                        headers: [
                            { key: 'name', type: 'TextInput', col: '4', information: { label: '{{lang}}Name', autoFocus: true, updateAfterSelect: true, isSearchable: true, placeholder: '{{lang}}e.g., Size, Color', required: true }, showMain: true },
                            { key: 'options', type: 'TagInput', col: '8', information: { label: '{{lang}}Options', placeholder: '{{lang}}Seperate choises with commas e.g., Small, Medium', required: true }, showMain: true },
                            // { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },

                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'variants',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '!=' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false

                },





                {
                    type: 'VariantsInventory',
                    key: 'inventory.variants',
                    col: '12',
                    // tab: 'specifications',
                    pages: ['information'],
                    section: 'sec-inventory',
                    information: {
                        variantsKey: 'variants',
                        editInModal: true,
                        addDisabled: true,
                        removeDisabled: true,
                        label: '{{lang}}Manage Variants',
                        help: 'Product variants allow you to list different versions of the same product, like clothes in different colors or sizes.',

                        headers: [
                            { key: 'name', type: 'TextInput', col: '4', information: { label: '{{lang}}Name', updateAfterSelect: true, isSearchable: true, placeholder: '{{lang}}e.g., Size, Color', required: true }, showMain: false },
                            { key: 'options', type: 'TagInput', col: '8', information: { label: '{{lang}}Options', placeholder: '{{lang}}Seperate choises with commas e.g., Small, Medium', required: true }, showMain: true },
                            // { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },

                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'inventory.variants',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '!=' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false

                },







                {
                    key: 'SKU', type: 'TextInput', col: '12', maxWidth: '50%', section: 'sec-inventory', pages: ['information'], information: {
                        label: '{{lang}}SKU', hint: 'Stock keeping unit', placeholder: '{{lang}}SKU',


                        required: false
                    },
                    // dependencies: [{
                    //     refKey: 'type',
                    //     targetKey: 'SKU',
                    //     conditions: {
                    //         root: {
                    //             id: 'root',
                    //             action: 'and',
                    //             conditions: {
                    //                 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'physical' } }
                    //             }
                    //         },
                    //     },
                    //     show: true,
                    //     init: true,
                    // }],

                    // dependencies: [{
                    //     refKey: 'type', targetKey: 'SKU',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                    //         effect: { show: true }
                    //     }],
                    //     else: { show: false },
                    //     init: true,

                    // }],

                    dependencies: [{
                        refKey: ['includesVariants', 'type'], targetKey: 'SKU',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: false }
                        },],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false
                },



                // { key: 'cprice', type: 'PriceInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Opening stock value', leftIndicator: '{{currency}}', placeholder: '{{lang}}Opening stock value', required: false, help: 'The amount you’re spending to produce and sell this product. Your customers won’t see this.' }, showMain: false },






                // { key: 'inventory.allWarehousesAvailable', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}All Warehouses Available', placeholder: '{{lang}}allWarehousesAvailable', default: true, required: false }, showMain: true },
                // { type: 'MultiSelectInput', key: 'inventory', section: 'sec-main', col: '6', pages: ['information'], information: { label: '{{lang}}Special', type: 'localSelect', fields: { title: 'warehouseName', value: 'warehouse' }, isSearchable: true, placeholder: '{{lang}}Special', required: false },
                // dependencies: [{
                //     refKey: 'allWarehousesAvailable',
                //     targetKey: 'availableWarehouses',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'and',
                //             conditions: {
                //                 1: { id: 1, source: { value: '@data.allWarehousesAvailable' }, operator: { value: '==' }, target: { value: false } }
                //             }
                //         },
                //     },
                //     show: true,
                //     init: true,
                // }], showMain: true },

                // { key: 'changeProductStatusWhenOrderd', type: 'SwitchInput', col: "6",page:'informaton', information: { label: '{{lang}}Change Product Status When Ordered', placeholder: '{{lang}}changeProductStatusWhenOrdered', default: true, required: false }, showMain: true },
                // { key: 'maxOrderCount', type: 'NumberInput', col: '6', pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Max Order Count', placeholder: '{{lang}}maxOrderCount', required: false }, showMain: true },
                // {
                //     type: 'ExtraSettingsInput',
                //     key: 'inventory',
                //     col: '12',
                //     pages: ['information'], section: 'sec-inventory', information: {
                //         // label: '{{lang}}inventory',
                //         headers: [
                //             { col: '4', type: 'TextInput', key: 'warehouseName', information: { label: '{{lang}}warehouse', updateAfterSelect: true, isSearchable: true, address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}warehouse', required: false }, showMain: false },
                //             { col: '4', type: 'SelectInput', key: 'warehouse', information: { label: '{{lang}}warehouse', updateAfterSelect: true, isSearchable: true, address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}warehouse', required: false }, showMain: false },
                //             {
                //                 key: 'defaultWarehouse', type: 'SwitchInput', col: '12', information: { label: '{{lang}}defaultWarehouse', placeholder: '{{lang}}defaultWarehouse', default: false, required: false },
                //                 dependencies: [{
                //                     refKey: 'inventory.allWarehousesAvailable',
                //                     targetKey: 'inventory.defaultWarehouse',
                //                     conditions: {
                //                         root: {
                //                             id: 'root',
                //                             action: 'and',
                //                             conditions: {
                //                                 1: { id: 1, source: { value: '@data.allWarehousesAvailable' }, operator: { value: '==' }, target: { value: false } }
                //                             }
                //                         },
                //                     },
                //                     show: true,
                //                     init: true,
                //                 }],
                //                 showMain: false
                //             },
                //             // { key: 'priority', type: 'NumberInput', col: "6", information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false }, showMain: false },
                //             { key: 'count', type: 'NumberInput', col: "6", information: { label: '{{lang}}stock', placeholder: '{{lang}}stock', required: false }, showMain: true },
                //             // { key: 'capacity', type: 'NumberInput', col: "6", information: { label: '{{lang}}capacity', placeholder: '{{lang}}capacity', required: false }, showMain: false },
                //             // { key: 'orderPoint', type: 'NumberInput', col: "6", information: { label: '{{lang}}Opening Stock Value', placeholder: '{{lang}}orderPoint', required: false }, showMain: false },
                //             // { type: 'MultiSelectInput', key: 'tags', col: '6', information: { label: '{{lang}}tags', address: 'getMyCommerceTags', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}tags', required: false }, showMain: false },
                //             // {
                //             //     type: 'SubformInput',
                //             //     key: 'count',
                //             //     col: '12',
                //             //     information: {
                //             //         label: '{{lang}}productStatusAndCount',
                //             //         headers: [
                //             //             { type: 'SelectInput', key: 'status', col: '4', information: { label: '{{lang}}Status', type: 'local', items: [{ value: 'stock', title: 'stock' }, { value: 'orderd', title: 'orderd' }, { value: 'sold', title: 'sold' }], isSearchable: true, placeholder: '{{lang}}status', required: false }, showMain: true },
                //             //             { key: 'count', type: 'NumberInput', col: "4", information: { label: '{{lang}}count', placeholder: '{{lang}}count', required: false }, showMain: false },
                //             //             { key: 'availableForsale', type: 'SwitchInput', col: "4", information: { label: '{{lang}}available for sale', placeholder: '{{lang}}available for sale', default: false, required: false }, showMain: false },

                //             //         ],
                //             //         placeholder: '{{lang}}specifications',
                //             //         required: false,
                //             //     },
                //             //     showMain: false

                //             // },

                //         ],
                //         placeholder: '{{lang}}specifications',
                //         title: '{{lang}}Inventory',
                //         required: false,
                //     },
                //     showMain: false

                // },
                // {
                //     type: 'SubformInput',
                //     key: 'inventory',
                //     col: '12',
                //     information: {
                //         label: '{{lang}}inventory',
                //         headers: [
                //             { col: '8', type: 'SelectInput', key: 'warehouse', information: { label: '{{lang}}warehouse', updateAfterSelect: true, isSearchable: true, address: 'getMyWarehoses', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}warehouse', required: false }, showMain: false },
                //             { key: 'defaultWarehouse', type: 'SwitchInput', col: '4',information: { label: '{{lang}}defaultWarehouse', placeholder: '{{lang}}defaultWarehouse', default: false, required: false }, showMain: false },
                //             { key: 'priority', type: 'NumberInput', col: "4", information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false }, showMain: false },
                //             // {
                //             //     type: 'SubformInput',
                //             //     key: 'count',
                //             //     col: '12',
                //             //     information: {
                //             //         label: '{{lang}}productStatusAndCount',
                //             //         headers: [
                //             //             { type: 'SelectInput', key: 'status', col: '4', information: { label: '{{lang}}Status', type: 'local', items: [{ value: 'stuck', title: 'stuck' }, { value: 'orderd', title: 'orderd' }, { value: 'sold', title: 'sold' }], isSearchable: true, placeholder: '{{lang}}status', required: false }, showMain: true },
                //             //             { key: 'count', type: 'NumberInput', col: "4", information: { label: '{{lang}}orderPoint', placeholder: '{{lang}}orderPoint', required: false }, showMain: false },
                //             //             { key: 'availableForsale', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                //             //         ],
                //             //         placeholder: '{{lang}}specifications',
                //             //         required: false,
                //             //     },
                //             //     showMain: false

                //             // },
                //             { key: 'capacity', type: 'NumberInput', col: "4", information: { label: '{{lang}}capacity', placeholder: '{{lang}}capacity', required: false }, showMain: false },
                //             { key: 'orderPoint', type: 'NumberInput', col: "4", information: { label: '{{lang}}orderPoint', placeholder: '{{lang}}orderPoint', required: false }, showMain: false },
                //             { type: 'MultiSelectInput', key: 'tags', col: '6', information: { label: '{{lang}}categories', address: 'getMyCommerceTags', fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },

                //         ],
                //         placeholder: '{{lang}}specifications',
                //         required: false,
                //     },
                //     showMain: false

                // },

                { type: 'MultiSelectInput', key: 'label', section: 'sec-selling', col: '6', pages: ['information'], information: { label: '{{lang}}Item label', type: 'local', items: [{ value: 'Trending', title: '{{lang}}Trending' }, { value: 'Featured', title: '{{lang}}Featured' }, { value: 'New', title: '{{lang}}New' }], isSearchable: true, placeholder: '{{lang}}Label', help: 'Labels help you to specialize your products and services so you can filter them easier when you want to show them to the users', required: false }, showMain: true },






                // { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },

                {
                    type: 'SubformInput',
                    key: 'additionals',
                    col: '12',
                    section: 'sec-additional',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Additoinal options',
                        help: '{{lang}}Additional option helps customization of  product / service. The price can also be customizaed based on these customizations',
                        // formType: 'modal',
                        modalMode: true,
                        headers: [
                            { key: 'title', type: 'TextInput', col: '4', information: { label: '{{lang}}Title', autoFocus: true, placeholder: '{{lang}}e.g. Topping, Style, ...', required: true }, showMain: true },

                            { key: 'type', type: 'SelectInput', col: '4', information: { label: '{{lang}}Type', type: 'local', default: 'multiSelect', items: [{ value: 'multiSelect', title: 'Multi select' }, { value: 'singleSelect', title: 'Single select' }, { value: 'text', title: 'Text' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },

                            {
                                key: 'max', type: 'NumberInput', col: '2', information: { label: '{{lang}}Max allowed options', placeholder: '{{lang}}Unlimited', required: false },
                                dependencies: [{
                                    refKey: 'type', targetKey: 'max',
                                    conditions: [{
                                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multiSelect' } } }, },
                                        effect: { show: true }
                                    }],
                                    else: { show: false },
                                    init: true,

                                }],
                                showMain: false
                            },


                            {
                                key: 'options',
                                type: 'SubformInput',
                                col: '4',
                                information: {
                                    label: '{{lang}}Options',
                                    formType: 'modal',
                                    headers: [
                                        { key: 'label', type: 'TextInput', col: '4', information: { label: '{{lang}}Label', placeholder: '{{lang}}e.g., Material, display, ...', required: true }, showMain: true },
                                        { key: 'priceDifference', type: 'PriceInput', col: '8', information: { label: '{{lang}}Price difference', placeholder: '{{lang}}Value ...', required: true }, showMain: true },
                                    ],
                                    placeholder: '{{lang}}specifications',
                                    required: false,
                                },
                                dependencies: [{
                                    refKey: 'type', targetKey: 'options',
                                    conditions: [{
                                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multiSelect' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'singleSelect' } } }, },
                                        effect: { show: true }
                                    }],
                                    else: { show: false },
                                    init: true,

                                }],
                                showMain: false

                            },



                            {
                                key: 'options-switcher', type: 'componentSwitcher', col: '4',
                                information: { label: '{{lang}}Options' },
                                states: [
                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'text' } } }, },
                                            effect: { show: false }
                                        }],
                                        // header: { key: 'body', type: 'TextEditorInput', col: '4', information: { label: '{{lang}}body', placeholder: '{{lang}}Description', showToolbar: true, required: false }, showMain: true },
                                    },

                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "text" } } }, },
                                            effect: { show: false }
                                        }],
                                        header: {
                                            key: 'options',
                                            type: 'SubformInput',
                                            col: '4',
                                            information: {
                                                // label: '{{lang}}Information sections',
                                                formType: 'modal',
                                                headers: [
                                                    { key: 'label', type: 'TextInput', col: '4', information: { label: '{{lang}}Label', placeholder: '{{lang}}e.g., Material, display, ...', required: true }, showMain: true },
                                                    { key: 'priceDifference', type: 'PriceInput', col: '8', information: { label: '{{lang}}Price difference', placeholder: '{{lang}}Value ...', required: true }, showMain: true },
                                                ],
                                                showCondition: '',
                                                placeholder: '{{lang}}specifications',
                                                required: false,
                                            },
                                            hideInHeader: true,
                                            showMain: true

                                        },

                                    }
                                ]
                                , showMain: true
                            },





                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: ['type'], targetKey: 'additionals',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        },],
                        else: { show: false },
                        init: true,
                    }],
                    showMain: false

                },




                {
                    type: 'SubformInput',
                    key: 'benefits',
                    col: '12',
                    section: 'sec-extra',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Benefits',
                        // help: 'Specifications and extra information about your product / service using this field. These will appeared add seperate sections on the product page.',
                        // formType: 'modal',
                        headers: [
                            { key: 'title', type: 'TextInput', col: '5', information: { label: '{{lang}}Title', autoFocus: true, placeholder: '{{lang}}e.g. Product Info, Policies, ...', required: true }, showMain: true },
                            { type: 'SelectInput', key: 'type', col: '3', information: { label: '{{lang}}Type', type: 'local', default: 'included', items: [{ value: 'included', title: '{{lang}}Included' }, { value: 'excluded', title: '{{lang}}Excluded' }], placeholder: '{{lang}}Type', required: true }, showMain: true },
                            { key: 'description', type: 'TextEditorInput', col: '4', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', showToolbar: true, required: false }, showMain: true },



                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: ['type'], targetKey: 'benefits',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        },],
                        else: { show: false },
                        init: true,
                    }],
                    showMain: false

                },





                {
                    type: 'SubformInput',
                    key: 'sections',
                    col: '12',
                    section: 'sec-extra',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Sections ( Sepecifications and information )',
                        help: 'Specifications and extra information about your product / service using this field. These will appeared add seperate sections on the product page.',
                        // formType: 'modal',
                        headers: [
                            { key: 'title', type: 'TextInput', col: '4', information: { label: '{{lang}}Title', autoFocus: true, placeholder: '{{lang}}e.g. Product Info, Policies, ...', required: true }, showMain: true },
                            { type: 'SelectInput', key: 'type', col: '4', information: { label: '{{lang}}Type', type: 'local', default: 'editor', items: [{ value: 'editor', title: 'Editor' }, { value: 'specifications', title: 'Specifications' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },

                            {
                                key: 'body', type: 'componentSwitcher', col: '4',
                                information: { label: '{{lang}}Body' },
                                states: [
                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'editor' } } }, },
                                            effect: { show: false }
                                        }],
                                        header: { key: 'body', type: 'TextEditorInput', col: '4', information: { label: '{{lang}}body', placeholder: '{{lang}}Description', showToolbar: true, required: false }, showMain: true },
                                    },

                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "specifications" } } }, },
                                            effect: { show: false }
                                        }],
                                        header: {
                                            type: 'SubformInput',
                                            key: 'list',
                                            col: '4',
                                            information: {
                                                label: '{{lang}}Information sections',
                                                formType: 'modal',
                                                headers: [
                                                    { key: 'label', type: 'TextInput', col: '4', information: { label: '{{lang}}Label', placeholder: '{{lang}}e.g., Material, display, ...', required: true }, showMain: true },
                                                    { key: 'value', type: 'TextInput', col: '8', information: { label: '{{lang}}Value', placeholder: '{{lang}}Value ...', required: true }, showMain: true },

                                                ],
                                                showCondition: '',
                                                placeholder: '{{lang}}specifications',
                                                required: false,
                                            },
                                            hideInHeader: true,
                                            showMain: true

                                        },

                                    }
                                ]
                                , showMain: true
                            },





                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'sections',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        },],
                        else: { show: false },
                        init: true,
                    }],
                    showMain: false

                },




                {
                    key: 'brand', type: 'SelectInput', col: '6', section: 'sec-extra', pages: ['information'], information: { label: '{{lang}}Brand', address: 'getProductsBrands', filter: { appletHub: '{{appletHub}}', applet: '{{appletId}}' }, fields: { title: 'name', image: 'image', value: '_id' }, type: 'api', placeholder: '{{lang}}Brand', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'brand',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },





                // {
                //     type: 'SubformInput',
                //     key: 'specificationsList',
                //     col: '12',
                //     // tab: 'specifications',
                //     pages: ['information'],
                //     section: 'sec-additional', 
                //     information: {
                //         // label: '{{lang}}Specifications',
                //         headers: [
                //             { col: '4', type: 'TextInput', key: 'key', information: { label: '{{lang}}Specification', updateAfterSelect: true, isSearchable: true, address: 'getFilteredSpecifications', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Specification', required: false }, showMain: false },
                //             { key: 'value', type: 'TextInput', col: '4', information: { label: '{{lang}}value', placeholder: '{{lang}}vlaue', required: false }, showMain: true },
                //             { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                //         ],
                //         placeholder: '{{lang}}specifications',
                //         required: false,
                //     },
                //     showMain: false

                // },



                { key: '*extra.dimensions', type: 'TextInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}Dimensions (cm)', hint: '(Length X Width X Height)', placeholder: '{{lang}}Dimensions', required: false }, showMain: false },
                { key: '*extra.weight', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}Weight (kg)', placeholder: '{{lang}}Weight', required: false }, showMain: false },
                { key: '*extra.MPN', type: 'TextInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}MPN', hint: 'Manufacturing Part Number', placeholder: '{{lang}}MPN', required: false }, showMain: false },
                { key: '*extra.UPC', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}UPC', hint: 'Universal product code', placeholder: '{{lang}}UPC', required: false }, showMain: false },
                { key: '*extra.ISBN', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}ISBN', hint: 'International standard book number', placeholder: '{{lang}}ISBN', required: false }, showMain: false },
                { key: '*extra.EAN', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}EAN', hint: 'International article number', placeholder: '{{lang}}EAN', required: false }, showMain: false },






                //// MEMBERSHIP

                // { key: 'name', type: 'TextInput', col: '12', page: 'membership', information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
                // { key: 'cover', type: 'ImageInput', col: '12', page: 'membership', information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                // { type: 'ImageInput', key: 'images', col: '12', page: 'membership', information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                // { key: 'description', type: 'EditorInput', col: '12', page: 'membership', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        orders: {
            key: 'orders',
            title: 'Orders',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getOrders',
            addUrl: 'postOrder',
            editUrl: 'postOrder',

            removeUrl: 'removeOrder',
            helperKey: 'values',
            pageType: 'collection',
            model: 'orders',
            section: 'main',
            parent: 'shop',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            //             tabs: [
            //     { title: 'Pending', filter: { "status": '0' } },
            //     { title: 'Finished', filter: { "status": '2' } },
            //     { title: 'Canceled', filter: { "status": '-1' } },
            // ],
            // addNew: -1,
            image: '/images/back1.jpg',
            // extra: { export: { url: 'usersExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
            headers: [

                { key: 'hub', type: 'AdvancedSelectInput', col: "12", information: { label: '{{lang}}Hub', address: 'searchHub', filter: {}, fields: { title: 'fullname', description: "username", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

                { type: 'TextInput', key: 'id', col: '6', information: { label: '{{lang}}id', placeholder: '{{lang}}Id', required: false, disabled: true }, showMain: true, hideComponent: true },

                {
                    type: 'InvoiceInput',
                    key: 'items',
                    information: {
                        inputClass: 'mt-2 p-0',
                        // label: '{{lang}}applets.accounting.items',
                        headers: [
                            { key: 'product', type: 'ProductSelectInput', col: '5', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', name: 'name', media: 'media', image: 'images', value: '_id', _id: '_id', price: 'price', type: 'type', priceType: 'priceType', subscriptionPrice: 'subscriptionPrice', inventory: 'inventory', variants: 'variants', includesVariants: "includesVariants", additionals: 'additionals', paymentType: 'paymentType', fulfillments: 'fulfillments', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'count', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'amounts.base', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                            { key: 'amounts.multiplayed', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    required: false,

                    showMain: false
                },

                { type: 'AddressInput', key: 'address', col: "12", information: { label: '{{lang}}Delivery address', required: false }, hideComponent: false },


                { type: 'PriceInput', key: 'amounts.totals.final', col: "6", information: { label: '{{lang}}Total amount', placeholder: '{{lang}}anount', required: false }, hideComponent: true },

                // { type: 'PriceInput', key: 'amounts.fulfillments.final', col: '6', information: { label: '{{lang}}Delivery amount', placeholder: '{{lang}}Delivery Price', required: true } },
                // { type: 'PriceInput', key: 'totalPrice', col: '6', information: { label: '{{lang}}Total', placeholder: '{{lang}}Total', required: false, disabled: true } },
                // { type: 'PriceInput', key: 'extraDiscount', col: '6', information: { label: '{{lang}}Extra Discount', placeholder: '{{lang}}Extra Discount', required: true } },

                // { type: 'PhoneInput', key: 'phone', col: "6", information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: true }, showMain: false },
                // { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },

                // { type: 'MultiSelectInput', key: 'lng', col: '12', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },


                { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'Confirmed' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
                { type: 'SelectInput', key: 'paymentStatus', col: '6', information: { label: '{{lang}}Payment Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}Payment Status', required: true }, showMain: true },
                // { type: 'SelectInput', key: 'deliveryStatus', col: '6', information: { label: '{{lang}}Delivery Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'delivered' }], isSearchable: true, placeholder: '{{lang}}Delivery Status', required: true }, showMain: true },
                // { type: 'SelectInput', key: 'transactionStatus', col: '6', information: { label: '{{lang}}Transaction Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}Transaction Status', required: true }, showMain: true },


                // { type: 'SectionInput', key: '*address', information: { label: '{{lang}}address' }, showMain: false },

                // { type: 'TextInput', key: 'address.province', col: '6', information: { label: '{{lang}}province / state', placeholder: '{{lang}}province / state', required: true }, showMain: false },
                // { type: 'TextInput', key: 'address.city', col: '6', information: { label: '{{lang}}city', placeholder: '{{lang}}city', required: true }, showMain: false },
                // { type: 'TextAreaInput', key: 'address.fullAddress', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: true }, showMain: false },
                // { type: 'MapLeafletInput', key: 'address.location', information: { label: '{{lang}}location', placeholder: '{{lang}}location', required: false, disabled: true }, showMain: false },

                // { type: 'SectionInput', key: '*recepient', information: { label: '{{lang}}recepient' }, showMain: false },

                // { key: 'addRecipient', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Add Recipient Info Manually', placeholder: '{{lang}}availableForAllProducts', default: false, required: false } },
                // {
                //     type: 'TextInput', key: 'recipient.name', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false },
                //     dependencies: [{
                //         refKey: 'addRecipient',
                //         targetKey: 'recipient.name',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.addRecipient' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     type: 'TextInput', key: 'recipient.family', col: '6', information: { label: '{{lang}}family', placeholder: '{{lang}}family', required: false },
                //     dependencies: [{
                //         refKey: 'addRecipient',
                //         targetKey: 'recipient.family',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.addRecipient' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }], showMain: false
                // },

                // {
                //     type: 'PhoneInput', key: 'recipient.phone', col: '6', information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: false },
                //     dependencies: [{
                //         refKey: 'addRecipient',
                //         targetKey: 'recipient.phone',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.addRecipient' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }], showMain: false
                // },
                // { type: 'TextInput', key: 'recepient.nationalId', col: '6', information: { label: '{{lang}}National Id', pattern: '[0-9]*', maxLength: 10, placeholder: '{{lang}}National Id', required: false }, showMain: false },


                { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },
                { key: 'remark', type: 'TextAreaInput', information: { label: '{{lang}}remark', placeholder: '{{lang}}remark', required: false }, showMain: false },
            ]
        },



        categories: {
            key: 'categories',
            title: '{{lang}}categories',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            model: 'productCategory',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        brands: {
            key: 'brands',
            title: '{{lang}}Brands',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getProductsBrands',
            addUrl: 'postBrand',
            editUrl: 'postBrand',
            removeUrl: 'removeProductbrand',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'productBrand',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            icon: '/assets/icons/applets/general/emotional.png',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
                { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                // { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: true } },
            ]
        },



        deliveryConfig: {
            key: 'deliveryConfig',
            title: '{{lang}}Fulfillment & delivery',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getDeliveryTypes',
            addUrl: 'postDeliveryType',
            editUrl: 'postDeliveryType',
            removeUrl: 'removeDeliveryType',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'fulfillments',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',

            formPages: [
                {
                    label: '{{lang}}Product Type', key: 'type',

                },
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-thirdparty', information: { label: '{{lang}}Third party', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-config', information: { label: '{{lang}}Configuration', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-limitations', information: { label: '{{lang}}Limitations (Optional)', fontSize: 16, color: '#000', fontWeight: '600' } },

                        // { key: 'sec-price', information: { label: '{{lang}}Pricing' } },
                        // { key: 'sec-inventory', information: { label: '{{lang}}Inventory' } },

                        // { key: 'sec-additional', information: { label: '{{lang}}Additional', fontSize: 16, color: '#000', fontWeight: '600' } },
                        // { key: 'sec-extra', information: { label: '{{lang}}Extra Information' } },
                        // { key: 'sec-selling', information: { label: '{{lang}}Selling Tools' } },

                        // { key: 'sec-custom', information: { label: '{{lang}}Custom Fields' } },

                    ]
                }],

            headers: [


                // { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the delivey type. Each type has its settings and configurations', fontSize: 16, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },

                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Delivery type', backgroundColor: '#fff', border: '1px solid #eee', col: 4, imageOnSide: false, type: 'local', inputClass: 'fake', items: [

                            { value: 'group', title: '{{lang}}Group', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/delivery.png' },

                            { value: 'pickup', title: '{{lang}}Pickup', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/delivery.png' },
                            { value: 'flatRate', title: '{{lang}}Flat rate', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/price-tag.png' },
                            { value: 'rateByWeight', title: '{{lang}}Rate by weight', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/weight.png' },
                            { value: 'schedule', title: '{{lang}}Schedule delivery', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/time-chart.svg' },

                            { value: 'UPS', title: '{{lang}}UPS', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/ups.svg' },
                            { value: 'USPS', title: '{{lang}}USPS', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/usps.svg' },

                            { value: 'EasyPost', title: '{{lang}}EasyPost', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/easypost.svg' },

                            { value: 'Fedex', title: '{{lang}}FedEx', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/fedex.svg' },
                            { value: 'DHL', title: '{{lang}}DHL', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/dhl.svg' },

                        ],


                        placeholder: '{{lang}}Select', required: true
                    }, showMain: true
                },


                {
                    key: 'thirdparty', type: 'ThirdPartyInput', col: '12', section: 'sec-thirdparty', pages: ['information'], information: { label: '{{lang}}Connect', refKey: "type", required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'thirdparty',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "pickup" } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "flatRate" } }, 3: { id: 3, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "rateByWeight" } }, 4: { id: 4, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "schedule" } }, 5: { id: 5, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                // { key: 'regions', type: 'RegionsInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Regions', placeholder: '{{lang}}International',hint:'If you do not want to have any limitations, you can leave this field empty.', required: false } },
                {
                    key: 'regions', type: 'RegionsInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Regions', address: 'getCountries', filter: {}, fields: { title: 'name', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: 'If you do not want to have any limitations, you can leave this field empty.', help: "{{lang}}You can limit the delivery address for customers in specific regions. You can leave this empty for no limitation.", placeholder: '{{lang}}International', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'regions',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                { key: 'name', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Name', placeholder: '{{lang}}e.g., Standard shipping, Free delivery', help: 'This will be visible to customers in their cart and at checkout process.', required: true } },


                {
                    type: 'SubformInput', key: 'list', col: '12', pages: ['information'], section: 'sec-config',
                    information: {
                        editInModal: true, defaultRow: true, label: '{{lang}}Fulfillments list',

                        // TO DO: Don't fetch the current delivery if is editing
                        headers: [
                            { key: 'fulfillment', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}Name', address: 'getDeliveryTypes', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Select ...', required: true } },
                        ],
                        required: true,
                    },

                    dependencies: [{
                        refKey: 'type', targetKey: 'list',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'group' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false

                },



                {
                    key: 'time', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Est. delivery time', placeholder: '{{lang}}e.g., 3 - 5 business days', required: false },

                    dependencies: [{
                        refKey: 'type', targetKey: 'time',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                },

                {
                    key: 'rate', type: 'PriceInput', col: '6', section: 'sec-config', pages: ['information'], information: {
                        label: '{{lang}}Rate', placeholder: '0', help: "Total rate for a customer's  order (not per product).", required: false
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'rate',
                        conditions: [{
                            root: {
                                id: 'root', action: 'and',
                                conditions: {
                                    // 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "pickup" } },
                                    2: { id: 2, action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "pickup" } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "flatRate" } }, 4: { id: 4, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "schedule" } } } }
                                },
                            },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                },



                {
                    key: 'markup', type: 'PriceInput', col: '6', section: 'sec-config', pages: ['information'], information: {
                        label: '{{lang}}Markup', placeholder: '0', help: "Markup over the delivery price after it is calculated by the thirdparty.",
                        unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}markupUnit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true },
                        required: false
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'markup',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "pickup" } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "flatRate" } }, 3: { id: 3, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "rateByWeight" } }, 4: { id: 4, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "schedule" } }, 5: { id: 5, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                {
                    type: 'SubformInput',
                    key: 'weightRanges',
                    section: 'sec-config',
                    pages: ['information'],
                    information: {
                        label: "{{lang}}Weight rate ranges",
                        help: "{{lang}}Depending on the total order weight, you can charge different amounts for shipping.",
                        headers: [
                            {
                                key: 'weight', type: 'PriceInput', col: '6', information: {
                                    label: '{{lang}}Weight', placeholder: '{{lang}}Unlimited', help: '{{lang}}Maximum weight for this range.', required: false, type: 'local',
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'lb', type: 'local', items: [{ value: 'lb', title: 'lb' }, { value: 'oz', title: 'oz' }, { value: 'g', title: 'g' }, { value: 'kg', title: 'kg' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            { key: 'rate', type: 'PriceInput', col: '6', information: { label: '{{lang}}Rate', placeholder: '0', required: false, } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        // hint: '{{lang}}If multiple conditions are valid, the biggest number will be considered.',
                        required: true
                    },

                    dependencies: [{
                        refKey: 'type', targetKey: 'weightRanges',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "rateByWeight" } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                {
                    key: 'dicountBasedOnPrice', type: 'SwitchInput', section: 'sec-config', pages: ['information'], col: '12', pages: ['information'], information: { label: '{{lang}}Discount based on price of order? ', default: false, required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'dicountBasedOnPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                {
                    type: 'SubformInput',
                    key: 'priceBasedDiscounts',
                    section: 'sec-config',
                    pages: ['information'],
                    information: {
                        label: "{{lang}}Discount on delivery",
                        help: "{{lang}}Automatic discounts on delivery rate can be considered, based on specific thresholds on delivery's total price of the items.",
                        headers: [
                            { key: 'price', type: 'PriceInput', col: '6', information: { label: '{{lang}}Price From', leftIndicator: '{{currency}}', placeholder: '0', help: '{{lang}}Total price of the items after discount in one delivery.', required: false, type: 'local' } },
                            // { key: 'to', type: 'PriceInput', col: '4', information: { label: '{{lang}}To', placeholder: '{{lang}}More than from', required: false, type: 'local' } },
                            {
                                key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                                    label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            // { key: 'maxDiscount', type: 'PriceInput', col: '3', information: { label: '{{lang}}Max Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        hint: '{{lang}}If multiple conditions are valid, the biggest discount will be applied.',
                        required: true
                    },

                    dependencies: [{
                        refKey: 'dicountBasedOnPrice', targetKey: 'priceBasedDiscounts',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.dicountBasedOnPrice' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                {
                    key: 'origin', type: 'SelectInput', col: '12', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Ship from', address: 'getMyAddresses', filter: { hub: "{{appletHub}}" }, fields: { title: 'nickname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Address ...', required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'origin',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                { type: 'MultiSelectInput', key: 'taxes', col: '6', pages: ['information'], section: 'sec-config', information: { label: '{{lang}}Taxes', address: 'getTaxes', groupBy: [{ key: 'type', options: [{ key: 'single', label: '{{lang}}Single rate' }, { key: 'group', label: '{{lang}}Taxes group' }] }], fields: { title: 'name', value: '_id', type: 'type' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default tax', required: false }, showMain: false },


                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },

                // { type: 'AddressInput', key: 'origin', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Delivery from', required: true } },

                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', pages: ['information'], information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // {
                //     key: 'products', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                //     dependencies: [{
                //         refKey: 'availableForAllProducts',
                //         targetKey: 'products',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                // },
                // {
                //     key: 'productCategories', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                //     dependencies: [{
                //         refKey: 'availableForAllProducts',
                //         targetKey: 'productCategories',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'pages: ['information'],information.filter.id', value: '@data.thing' },

                //     }],
                // },
                // { key: 'availableForAllHubs', type: 'SwitchInput', section: 'sec-config', col: '12', pages: ['information'], information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // {
                //     key: 'hubs', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                //     dependencies: [{
                //         refKey: 'availableForAllHubs',
                //         targetKey: 'hubs',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                // },


                { key: 'availableFor', type: 'SelectInput', section: 'sec-limitations', pages: ['information'], col: '12', fullCol: true, information: { label: '{{lang}}Available for', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}All hubs and groups", value: 'all' }, { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },

                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                // { key: 'countUnit', type: 'SelectInput', section: 'sec-limitations', fullCol: true, pages: ['information'], information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

                {
                    key: 'minItemsCount', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Minimum items count', help: "{{lang}}This option can be used if you want to make this delivery available only if the number of items for the delivery are more than a specific count.", placeholder: '1', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'minItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                {
                    key: 'maxItemsCount', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Maximum items count', help: "{{lang}}This option can be used if you want to make this delivery just for a maximum specific number of items in one delivey. If the number of items surpass this number, they will be moved to another delivery.", placeholder: '{{lang}}Unlimited', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'maxItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                // { key: 'extraDiscount', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false },showMain:false },
                // { key: 'minDays', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Min Days', placeholder: '{{lang}}minDays', required: false },showMain:false },
                // { key: 'maxDays', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Max Days', placeholder: '{{lang}}maxDays', required: false },showMain:false },

                {
                    key: 'minOrderPrice', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Minimum order price', help: "{{lang}}This option can be used if you want to make this delivery available for orders above an specific total price.", placeholder: '0', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'minOrderPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                {
                    key: 'maxOrderPrice', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Maximum order price', help: "{{lang}}This option can be used if you want to make this delivery unavailable for orders above an specific total price.", placeholder: '{{lang}}Unlimited', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'maxOrderPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                // { key: 'deliveryPrice', type: 'NumberInput', section: 'sec-config', col: '6', pages: ['information'], information: { label: '{{lang}}Delivery Price', placeholder: '{{lang}}Delivery Price', required: false } },
                // { key: 'paymentTypes', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Payment Types', address: 'getPaymentTypes', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },

        // priceList: {
        //     key: 'priceLists',
        //     title: '{{lang}}Price List',
        //     description: 'Price List',
        //     fetchUrl: 'getPriceLists',
        //     addUrl: 'postPriceList',
        //     editUrl: 'postPriceList',
        //     removeUrl: 'removePriceList',
        //     // helperKey: 'values',
        //     pageType: 'collection',
        //     section: 'main',
        //     actions: [{ type: 'edit' }, { type: 'remove' }],
        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
        //     icon: '/assets/icons/applets/general/events.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}name', required: false } },
        //         { key: 'priceListCode', type: 'TextInput', col: '6', information: { label: '{{lang}}Price List Code', placeholder: '{{lang}}Price List Code', required: false } },
        //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false } },
        //         { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
        //         {
        //             key: 'products', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
        //             dependencies: [{
        //                 refKey: 'availableForAllProducts',
        //                 targetKey: 'products',
        //                 conditions: {
        //                     root: {
        //                         id: 'root',
        //                         action: 'and',
        //                         conditions: {
        //                             1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

        //                         }
        //                     },
        //                 },
        //                 show: true,
        //                 init: true,
        //                 // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

        //             }],
        //         },
        //         {
        //             key: 'productCategories', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
        //             dependencies: [{
        //                 refKey: 'availableForAllProducts',
        //                 targetKey: 'productCategories',
        //                 conditions: {
        //                     root: {
        //                         id: 'root',
        //                         action: 'and',
        //                         conditions: {
        //                             1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

        //                         }
        //                     },
        //                 },
        //                 show: true,
        //                 init: true,
        //                 // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

        //             }],
        //         },
        //         { key: 'availableForAllHubs', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
        //         {
        //             key: 'hubs', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
        //             dependencies: [{
        //                 refKey: 'availableForAllHubs',
        //                 targetKey: 'hubs',
        //                 conditions: {
        //                     root: {
        //                         id: 'root',
        //                         action: 'and',
        //                         conditions: {
        //                             1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

        //                         }
        //                     },
        //                 },
        //                 show: true,
        //                 init: true,
        //                 // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

        //             }],
        //         },
        //         { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

        //         { key: 'minOrderPrice', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Price', placeholder: '{{lang}}minOrderPrice', required: false } },
        //         { key: 'minOrderCount', type: 'NumberInput', col: '6', information: { label: '{{lang}}Min Order Count', placeholder: '{{lang}}minOrderCount', required: false } },
        //         { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },

        //         // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
        //     ]
        // },
        // wallet: {
        //     key: 'wallet',
        //     title: '{{lang}}Wallet',
        //     description: 'Price list',
        //     fetchUrl: 'getProductsCategories',
        //     addUrl: 'postProductCategory',
        //     editUrl: 'postProductCategory',
        //     removeUrl: 'removeProductCategory',
        //     // helperKey: 'values',
        //     pageType: 'collection',
        //     section:'loyaltysystem',


        credits: {
            key: 'credits',
            title: '{{lang}}Credits',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'credits',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/events.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'parent', type: 'SelectInput', col: '6', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        vouchers: {
            key: 'vouchers',
            title: '{{lang}}Vouchers',
            fetchUrl: 'getVouchers',
            addUrl: 'postVoucher',
            editUrl: 'postVoucher',
            removeUrl: 'removeVoucher',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'vouchers',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ad-center.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            formPages: [
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-main', information: { label: '{{lang}}Main information', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-more', information: { label: '{{lang}}More information', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-usagelimitations', information: { label: '{{lang}}Usage Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-itemsLimitations', information: { label: '{{lang}}Items Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },




                    ]
                },

            ],
            headers: [
                { key: 'name', type: 'TextInput', section: 'sec-main', col: '12', information: { label: '{{lang}}Name', placeholder: "{{lang}}e.g. New year's discount", required: true }, showMain: true },
                { key: 'levelType', type: 'SelectInput', section: 'sec-main', col: '6', fullCol: true, information: { label: '{{lang}}Discount Type', required: false, type: 'local', default: 'single', items: [{ title: "{{lang}}Single value", value: 'single' }, { title: "{{lang}}Multi level", value: 'multi' }], help: 'Single: for one simple dicount value.\nMulti level: for multiple step discount based on total price or number of items.', required: true }, showMain: false, inExport: true },
                { key: 'code', type: 'CodeGeneratorInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Code', length: 7, placeholder: '{{lang}}e.g. LRK0EW2', required: true }, showMain: true },

                // { key: 'levelType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "first", value: 'first' }, { title: "second", value: 'second' }] }, showMain: true, inExport: true },
                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },

                { key: 'discountOn', type: 'SelectInput', section: 'sec-main', col: '6', fullCol: true, information: { label: '{{lang}}Discount on', type: 'local', default: 'items', items: [{ title: "{{lang}}Items in the cart", value: 'items' }, { title: "{{lang}}Delivey fee", value: 'delivery' }], required: true, }, showMain: false, inExport: true },

                {
                    key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                        label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                        unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                    },

                    dependencies: [

                        {
                            refKey: 'levelType', targetKey: 'discount',
                            conditions: [{
                                root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.levelType' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                                effect: { show: false, }
                            }],
                            else: { show: true },
                            init: true,

                        },
                        // {
                        //     refKey: 'discountOn', targetKey: 'discount.value',
                        //     conditions: [{
                        //         root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.discountOn' }, operator: { value: '==' }, target: { value: 'amount' } } }, },
                        //         effect: { changeHeader: [{ key: 'information.leftIndicator', value: '$' }, { key: 'information.max', value: null }] }
                        //     }],
                        //     else: { changeHeader: [{ key: 'information.leftIndicator', value: "%" }, { key: 'information.max', value: 100 }] },
                        //     init: true,

                        // }
                    ],
                    showMain: true
                },


                // {
                //     key: 'discount', type: 'PriceInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Discount value', min: 0, leftIndicator: '%', minusInfinity: 0, placeholder: '{{lang}}Discount value', required: true },
                //     dependencies: [

                //         {
                //             refKey: 'levelType', targetKey: 'discount',
                //             conditions: [{
                //                 root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                //                 effect: { show: false, }
                //             }],
                //             else: { show: true },
                //             init: true,

                //         },
                //         {
                //             refKey: 'discountOn', targetKey: 'discount',
                //             conditions: [{
                //                 root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.discountOn' }, operator: { value: '==' }, target: { value: 'amount' } } }, },
                //                 effect: { changeHeader: [{ key: 'information.leftIndicator', value: '$' }, { key: 'information.max', value: null }] }
                //             }],
                //             else: { changeHeader: [{ key: 'information.leftIndicator', value: "%" }, { key: 'information.max', value: 100 }] },
                //             init: true,

                //         }],
                //     showMain: true
                // },


                {
                    type: 'SubformInput',
                    key: 'levels',
                    section: 'sec-main',
                    information: {
                        label: "{{lang}}Discount levels",
                        headers: [
                            // { key: 'from', type: 'PriceInput', col: '4', information: { label: '{{lang}}From', placeholder: '0', required: false, type: 'local' } },
                            { key: 'to', type: 'PriceInput', col: '6', information: { label: '{{lang}}Items total up to', help: "The maximum order amount for this level. If you leave empty, there will to no maximum for this level.", placeholder: '{{lang}}No maximum', required: false, type: 'local' } },
                            // { key: 'discount', type: 'PriceInput', col: '4', information: { label: '{{lang}}Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}Discount', required: false } },
                            {
                                key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                                    label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: true,
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            // { key: 'maxDiscount', type: 'PriceInput', col: '3', information: { label: '{{lang}}Max Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        hint: '{{lang}}If multiple conditions are valid, the biggest discount will be applied.',
                        required: true
                    },
                    dependencies: [{
                        refKey: 'levelType', targetKey: 'levels',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.levelType' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                { key: 'usageCondition', type: 'SelectInput', section: 'sec-usagelimitations', col: '6', fullCol: true, information: { label: '{{lang}}Usage condition', required: false, type: 'local', default: 'any', items: [{ title: "{{lang}}No specific condition", value: 'any' }, { title: "{{lang}}Only on First purchase", value: 'firstPurchase' }] }, showMain: false, inExport: true },


                { key: 'availableFor', type: 'SelectInput', section: 'sec-usagelimitations', col: '6', fullCol: true, information: { label: '{{lang}}Available for', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}Any one with code", value: 'all' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },
                // { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' },
                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-usagelimitations', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-usagelimitations', information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },







                // { key: 'availableForAllHubs', type: 'SwitchInput', section: 'sec-usagelimitations', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false }, showMain: false },

                // { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },
                // { key: 'minimumOrder', type: 'SelectInput', section: 'sec-usagelimitations', fullCol: true, information: { label: '{{lang}}Set Minimum Order Point For', required: false, type: 'local', default: '0', items: [{ title: "{{lang}}Price", value: 'price' }, { title: "{{lang}}Piece", value: 'piece' }] }, showMain: false, inExport: true },


                { key: 'maxDiscount', type: 'PriceInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximum Discount amount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', help: 'Disount can not surpass this amount. This is useful if your are using percentages for discount and want to have a limitation for maximum discount.', required: false }, showMain: false },


                { key: 'minAmount', type: 'PriceInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Minimum Order amount', leftIndicator: '{{currency}}', placeholder: '0', help: 'The dicount will be applied if the order price be more than this amount.', required: false }, showMain: false },


                { key: 'maxHubsUsage', type: 'NumberInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximun usage / hub', default: 1, placeholder: '{{lang}}Unlimited', help: 'Each hub can not use this discount for more than this number.', required: false }, showMain: false },

                { key: 'maxTotalUsage', type: 'NumberInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximun usage / Total', placeholder: '{{lang}}Unlimited', help: 'Total number of times that this discount can be used is determined by this number. This is the total number of usage regardless of the person who is using it.', required: false }, showMain: false },





                { key: 'applyTo', type: 'SelectInput', section: 'sec-itemsLimitations', col: '12', fullCol: true, information: { label: '{{lang}}Applies to', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}Any order", value: 'all' }, { title: "{{lang}}Specific products and categories", value: 'productsAndCategories' },] }, showMain: false, inExport: true },
                // { title: "{{lang}}Specific products", value: 'products' }, { title: "{{lang}}Specific categories", value: 'categories' }
                {
                    key: 'products', type: 'MultiSelectInput', section: 'sec-itemsLimitations', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },

                    dependencies: [{
                        refKey: 'applyTo', targetKey: 'products',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.applyTo' }, operator: { value: '==' }, target: { value: 'productsAndCategories' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },
                {
                    key: 'categories', type: 'MultiSelectInput', section: 'sec-itemsLimitations', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Products categories', required: false },

                    dependencies: [{
                        refKey: 'applyTo', targetKey: 'categories',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.applyTo' }, operator: { value: '==' }, target: { value: 'productsAndCategories' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                { key: 'includesItemsConditions', type: 'SwitchInput', section: 'sec-itemsLimitations', col: '12', information: { label: '{{lang}}Includes specific conditions for items', default: false, required: false }, showMain: false },

                {
                    key: 'minItemsCount', type: 'NumberInput', section: 'sec-itemsLimitations', col: '6', information: { label: '{{lang}}Minimun Items Count', placeholder: '{{lang}}minItemsCount', required: false },
                    dependencies: [{
                        refKey: 'includesItemsConditions', targetKey: 'minItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.itemsConditions' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                // { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'discountPercentage', type: 'NumberInput',  section: 'sec-usagelimitations',col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },



                // { key: 'discountType', type: 'SelectInput', section: 'sec-usagelimitations', col: '12', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "{{lang}}multi level", value: 'multi' }, { title: "{{lang}}single level", value: 'single' }] }, showMain: false, inExport: true },

                // {
                //     key: 'singleLevelDiscount.unit', type: 'SelectInput', section: 'sec-usagelimitations', col: '4', information: { label: '{{lang}}unit', required: false, type: 'local', items: [{ title: "percentage", value: 'percentage' }, { title: "cash", value: 'cash' }] },
                //     dependencies: [{
                //         refKey: 'discountType',
                //         targetKey: 'singleLevelDiscount.unit',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.discountType' }, operator: { value: '==' }, target: { value: 'single' } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     key: 'singleLevelDiscount.discount', type: 'NumberInput', section: 'sec-usagelimitations', col: '4', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: false },
                //     dependencies: [{
                //         refKey: 'discountType',
                //         targetKey: 'singleLevelDiscount.discount',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.discountType' }, operator: { value: '==' }, target: { value: 'single' } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },



                { key: 'start', type: 'DateInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Start date', startOrEnd: 'start', placeholder: '{{lang}}From now', required: false }, showMain: true },

                { key: 'expiry', type: 'DateInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Expiry date', startOrEnd: 'end', placeholder: '{{lang}}Never expires', required: false }, showMain: true },

                { key: 'automaticApply', type: 'SwitchInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Automatic Apply', placeholder: '{{lang}}automaticApply', default: false, required: false } },


                { key: 'description', type: 'TextAreaInput', section: 'sec-more', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },




        offers: {
            key: 'offers',
            title: '{{lang}}Offers',
            description: 'offers list',
            fetchUrl: 'getVouchers',
            addUrl: 'postVoucher',
            editUrl: 'postVoucher',
            removeUrl: 'removeVoucher',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'records',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ad-center.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            formPages: [
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-main', information: { label: '{{lang}}Main information', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-more', information: { label: '{{lang}}More information', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-usagelimitations', information: { label: '{{lang}}Usage Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-itemsLimitations', information: { label: '{{lang}}Items Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },




                    ]
                },

            ],
            headers: [
                { key: 'name', type: 'TextInput', section: 'sec-main', col: '12', information: { label: '{{lang}}Name', placeholder: "{{lang}}e.g. New year's discount", required: true }, showMain: true },
                { key: 'levelType', type: 'SelectInput', section: 'sec-main', col: '6', fullCol: true, information: { label: '{{lang}}Discount Type', required: false, type: 'local', default: 'single', items: [{ title: "{{lang}}Single value", value: 'single' }, { title: "{{lang}}Multi level", value: 'multi' }], help: 'Single: for one simple dicount value.\nMulti level: for multiple step discount based on total price or number of items.', required: true }, showMain: false, inExport: true },
                { key: 'code', type: 'CodeGeneratorInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Code', length: 7, placeholder: '{{lang}}e.g. LRK0EW2', required: true }, showMain: true },

                // { key: 'levelType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "first", value: 'first' }, { title: "second", value: 'second' }] }, showMain: true, inExport: true },
                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },

                { key: 'discountOn', type: 'SelectInput', section: 'sec-main', col: '6', fullCol: true, information: { label: '{{lang}}Discount on', required: false, type: 'local', default: 'subtotal', items: [{ title: "{{lang}}Subtotal (After other discounts)", value: 'subtotal' }, { title: "{{lang}}Total before discount", value: 'beforeDiscount' }, { title: "{{lang}}Delivey fee", value: 'delivery' }, { title: "{{lang}}Total before tax", value: 'beforeTax' }, { title: "{{lang}}Total taxable", value: 'taxable' }] }, showMain: false, inExport: true },

                {
                    key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                        label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                        unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', default: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                    },

                    dependencies: [

                        {
                            refKey: 'levelType', targetKey: 'discount',
                            conditions: [{
                                root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                                effect: { show: false, }
                            }],
                            else: { show: true },
                            init: true,

                        },
                        // {
                        //     refKey: 'discountOn', targetKey: 'discount.value',
                        //     conditions: [{
                        //         root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.discountOn' }, operator: { value: '==' }, target: { value: 'amount' } } }, },
                        //         effect: { changeHeader: [{ key: 'information.leftIndicator', value: '$' }, { key: 'information.max', value: null }] }
                        //     }],
                        //     else: { changeHeader: [{ key: 'information.leftIndicator', value: "%" }, { key: 'information.max', value: 100 }] },
                        //     init: true,

                        // }
                    ],
                    showMain: true
                },


                // {
                //     key: 'discount', type: 'PriceInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Discount value', min: 0, leftIndicator: '%', minusInfinity: 0, placeholder: '{{lang}}Discount value', required: true },
                //     dependencies: [

                //         {
                //             refKey: 'levelType', targetKey: 'discount',
                //             conditions: [{
                //                 root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                //                 effect: { show: false, }
                //             }],
                //             else: { show: true },
                //             init: true,

                //         },
                //         {
                //             refKey: 'discountOn', targetKey: 'discount',
                //             conditions: [{
                //                 root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.discountOn' }, operator: { value: '==' }, target: { value: 'amount' } } }, },
                //                 effect: { changeHeader: [{ key: 'information.leftIndicator', value: '$' }, { key: 'information.max', value: null }] }
                //             }],
                //             else: { changeHeader: [{ key: 'information.leftIndicator', value: "%" }, { key: 'information.max', value: 100 }] },
                //             init: true,

                //         }],
                //     showMain: true
                // },


                {
                    type: 'SubformInput',
                    key: 'levels',
                    section: 'sec-main',
                    information: {
                        label: "{{lang}}Discount levels",
                        headers: [
                            { key: 'from', type: 'PriceInput', col: '4', information: { label: '{{lang}}From', placeholder: '0', required: false, type: 'local' } },
                            { key: 'to', type: 'PriceInput', col: '4', information: { label: '{{lang}}To', placeholder: '{{lang}}More than from', required: false, type: 'local' } },
                            // { key: 'discount', type: 'PriceInput', col: '4', information: { label: '{{lang}}Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}Discount', required: false } },
                            {
                                key: 'discount', section: 'sec-main', type: 'PriceInput', col: '4', information: {
                                    label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            // { key: 'maxDiscount', type: 'PriceInput', col: '3', information: { label: '{{lang}}Max Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        hint: '{{lang}}If multiple conditions are valid, the biggest discount will be applied.',
                        required: true
                    },
                    dependencies: [{
                        refKey: 'levelType', targetKey: 'levels',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                { key: 'usageCondition', type: 'SelectInput', section: 'sec-usagelimitations', col: '6', fullCol: true, information: { label: '{{lang}}Usage condition', required: false, type: 'local', default: 'any', items: [{ title: "{{lang}}No specific condition", value: 'any' }, { title: "{{lang}}Only on First purchase", value: 'firstPurchase' }] }, showMain: false, inExport: true },


                { key: 'availableFor', type: 'SelectInput', section: 'sec-usagelimitations', col: '6', fullCol: true, information: { label: '{{lang}}Available for', required: false, type: 'local', default: 'any', items: [{ title: "{{lang}}Any one with code", value: 'any' }, { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },

                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-usagelimitations', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-usagelimitations', information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },







                // { key: 'availableForAllHubs', type: 'SwitchInput', section: 'sec-usagelimitations', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false }, showMain: false },

                // { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },
                // { key: 'minimumOrder', type: 'SelectInput', section: 'sec-usagelimitations', fullCol: true, information: { label: '{{lang}}Set Minimum Order Point For', required: false, type: 'local', default: '0', items: [{ title: "{{lang}}Price", value: 'price' }, { title: "{{lang}}Piece", value: 'piece' }] }, showMain: false, inExport: true },


                { key: 'maxDiscount', type: 'PriceInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximum Discount amount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', help: 'Disount can not surpass this amount. This is useful if your are using percentages for discount and want to have a limitation for maximum discount.', required: false }, showMain: false },


                { key: 'minAmount', type: 'PriceInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Minimum Order Price', leftIndicator: '{{currency}}', placeholder: '0', help: 'The dicount will be applied if the order price be more than this amount.', required: false }, showMain: false },


                { key: 'maxHubsUsage', type: 'NumberInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximun usage / hub', default: 1, placeholder: '{{lang}}Unlimited', help: 'Each hub can not use this discount for more than this number.', required: false }, showMain: false },

                { key: 'maxTotalUsage', type: 'NumberInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximun usage / Total', placeholder: '{{lang}}Unlimited', help: 'Total number of times that this discount can be used is determined by this number. This is the total number of usage regardless of the person who is using it.', required: false }, showMain: false },





                { key: 'applyTo', type: 'SelectInput', section: 'sec-itemsLimitations', col: '12', fullCol: true, information: { label: '{{lang}}Applies to', required: false, type: 'local', default: 'any', items: [{ title: "{{lang}}Any order", value: 'any' }, { title: "{{lang}}Specific products", value: 'products' }, { title: "{{lang}}Specific categories", value: 'categories' }] }, showMain: false, inExport: true },

                {
                    key: 'products', type: 'MultiSelectInput', section: 'sec-itemsLimitations', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },

                    dependencies: [{
                        refKey: 'applyTo', targetKey: 'products',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.applyTo' }, operator: { value: '==' }, target: { value: 'products' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },
                {
                    key: 'categories', type: 'MultiSelectInput', section: 'sec-itemsLimitations', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Products categories', required: false },

                    dependencies: [{
                        refKey: 'applyTo', targetKey: 'categories',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.applyTo' }, operator: { value: '==' }, target: { value: 'categories' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                { key: 'includesItemsConditions', type: 'SwitchInput', section: 'sec-itemsLimitations', col: '12', information: { label: '{{lang}}Includes specific conditions for items', default: false, required: false }, showMain: false },

                {
                    key: 'minItemsCount', type: 'NumberInput', section: 'sec-itemsLimitations', col: '6', information: { label: '{{lang}}Minimun Items Count', placeholder: '{{lang}}minItemsCount', required: false },
                    dependencies: [{
                        refKey: 'includesItemsConditions', targetKey: 'minItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.itemsConditions' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                // { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'discountPercentage', type: 'NumberInput',  section: 'sec-usagelimitations',col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },



                // { key: 'discountType', type: 'SelectInput', section: 'sec-usagelimitations', col: '12', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "{{lang}}multi level", value: 'multi' }, { title: "{{lang}}single level", value: 'single' }] }, showMain: false, inExport: true },

                // {
                //     key: 'singleLevelDiscount.unit', type: 'SelectInput', section: 'sec-usagelimitations', col: '4', information: { label: '{{lang}}unit', required: false, type: 'local', items: [{ title: "percentage", value: 'percentage' }, { title: "cash", value: 'cash' }] },
                //     dependencies: [{
                //         refKey: 'discountType',
                //         targetKey: 'singleLevelDiscount.unit',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.discountType' }, operator: { value: '==' }, target: { value: 'single' } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     key: 'singleLevelDiscount.discount', type: 'NumberInput', section: 'sec-usagelimitations', col: '4', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: false },
                //     dependencies: [{
                //         refKey: 'discountType',
                //         targetKey: 'singleLevelDiscount.discount',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.discountType' }, operator: { value: '==' }, target: { value: 'single' } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },



                { key: 'start', type: 'DateInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Start date', placeholder: '{{lang}}From now', required: false }, showMain: true },

                { key: 'expiry', type: 'DateInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Expiry date', placeholder: '{{lang}}Never expires', required: false }, showMain: true },

                { key: 'automaticApply', type: 'SwitchInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Automatic Apply', placeholder: '{{lang}}automaticApply', default: false, required: false } },


                { key: 'description', type: 'TextAreaInput', section: 'sec-more', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        // settings: {
        //     key: 'settings',
        //     title: '{{lang}}Settings',
        //     description: 'Settings list',
        //     fetchUrl: 'getProductsCategories',
        //     addUrl: 'postProductCategory',
        //     editUrl: 'postProductCategory',
        //     removeUrl: 'removeExtraSection',
        //     // helperKey: 'values',
        //     pageType: 'settings',
        //     section: 'main',
        //     actions: [{ type: 'edit' }, { type: 'remove' }],
        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
        //     icon: '/assets/icons/applets/general/crisis.png',
        //     image: '/images/covers/settings.jpg',

        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         { key: 'connections', type: 'TextInput', col: '12', information: { label: '{{lang}}connections', placeholder: '{{lang}}name', required: false } },
        //         // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
        //     ]
        // },


        warehouses: {
            key: 'warehouses',
            title: '{{lang}}Warehouses',
            fetchUrl: 'getWarehouses',
            addUrl: 'postWarehouse',
            editUrl: 'postWarehouse',
            removeUrl: 'removeWarehouse',
            // helperKey: 'values',
            pageType: 'collection',
            model: "warehouses",
            section: 'inventory',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/climate.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'code', type: 'TextInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}code', required: false } },
                // { key: 'parent', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { col: '12', key: 'address', type: 'TextInput', information: { label: '{{lang}}address', updateAfterSelect: true, isSearchable: true, placeholder: '{{lang}}Enter Address', required: false }, showMain: false },


                { key: 'activateSections', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Activate sections', help: "Sections", required: false }, showMain: false },

                {
                    type: 'SubformInput',
                    key: 'sections',
                    information: {
                        headers: [
                            { key: 'name', type: 'TextInput', col: '4', information: { label: '{{lang}}Name', placeholder: '{{lang}}Name', required: false } },
                            { key: 'description', type: 'TextInput', col: '8', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false } },
                        ],

                        required: false
                    },
                    dependencies: [{
                        refKey: 'activateSections', targetKey: 'sections',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.activateSections' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                // { key: 'code', type: 'TextInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}code', required: false } },
                // { key: 'address', type: 'TextInput', col: '12', information: { label: '{{lang}}Address', placeholder: '{{lang}}address', required: false } },
                // { key: 'zipcode', type: 'TextInput', col: '12', information: { label: '{{lang}}Zip code', placeholder: '{{lang}}zip code', required: false } },
                // { key: 'country', type: 'TextInput', col: '12', information: { label: '{{lang}}Country', placeholder: '{{lang}}country', required: false } },
                // { key: 'provinces', type: 'TextInput', col: '12', information: { label: '{{lang}}Provinces', placeholder: '{{lang}}provinces', required: false } },
                // { key: 'city', type: 'TextInput', col: '12', information: { label: '{{lang}}City', placeholder: '{{lang}}city', required: false } },
                // { key: 'Phone', type: 'NumberInput', col: '12', information: { label: '{{lang}}Capacity', placeholder: '{{lang}}number', required: false } },

            ]
        },

        addresses: {
            key: 'addresses',
            title: '{{lang}}addresses',
            fetchUrl: 'getAddresses',
            addUrl: 'postAddress',
            editUrl: 'postAddress',
            removeUrl: 'removeAddress',
            // helperKey: 'values',
            pageType: 'collection',
            model: "addresses",
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/climate.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { col: '6', key: 'name', type: 'TextInput', information: { label: 'name', placeholder: '{{lang}}name', required: false, } },
                { col: '6', key: 'country', type: 'SelectInput', information: { label: '{{lang}}country', updateAfterSelect: true, isSearchable: true, address: 'getAllCountries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select state', required: false }, showMain: false },
                { col: '6', key: 'province', type: 'TextInput', information: { label: 'province/state', placeholder: '{{lang}}province/state', required: false, } },
                { col: '6', key: 'city', type: 'TextInput', information: { label: 'city', placeholder: '{{lang}}city', required: false, } },
                { col: "6", key: 'zipCode', type: 'TextInput', information: { label: 'Zip code', placeholder: '{{lang}}Zip code', required: false, } },
                { key: 'Phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Capacity', placeholder: '{{lang}}number', required: false } },
                { col: "12", key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: false, } },

                // { key: 'location', type: 'MapLeafletInput', information: { label: 'Location', placeholder: '', disabled: false, required: false, }, showMain: false },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Warehouse Code', placeholder: '{{lang}}Code', required: false } },


            ]
        },


        inventoryTransactions: {
            key: 'inventoryTransactions',
            title: '{{lang}}Inventory Transactions',
            description: 'inventoryTransactions list',
            fetchUrl: 'getInventoryTransactions',
            addUrl: 'postInventoryTransaction',
            editUrl: 'postInventoryTransaction',
            removeUrl: 'removeInventoryTransaction',
            // helperKey: 'values',
            pageType: 'collection',
            model: "inventoryTransactions",
            section: 'inventory',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/climate.png',
            image: '/images/covers/settings.jpg',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'type', type: 'SelectInput', col: '6', information: { label: '{{lang}}type', required: false, type: 'local', items: [{ title: "input", value: 'input' }, { title: "output", value: 'output' }] }, showMain: true, inExport: true },
                { key: 'status', type: 'SelectInput', col: '6', information: { label: '{{lang}}status', required: false, type: 'local', items: [{ title: "sold", value: 'sold' }, { title: "bought", value: 'bought' }] }, showMain: true, inExport: true },
                { key: 'name', type: 'TextInput', col: '12', information: { label: "{{lang}}transaction's title", placeholder: "{{lang}}transaction's title", required: false } },
                { key: 'transactionCode', type: 'TextInput', col: '12', information: { label: '{{lang}}transactionCode', placeholder: '{{lang}}transactionCode', required: false } },
                // { key: 'warehouse', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                // { key: 'source.warehouse', type: 'SelectInput', col: '6', information: { label: '{{lang}}Source Warehouse', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                // { key: 'source.warehouse', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'destination.otherSource', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'destination.otherDestination', type: 'SelectInput', col: '6', information: { label: '{{lang}}parent', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}parent', required: false }, showMain: false },
                { key: 'totalCount', type: 'TextInput', col: '12', information: { label: '{{lang}}Zip code', placeholder: '{{lang}}zip code', required: false } },
                { key: 'totalValue', type: 'TextInput', col: '12', information: { label: '{{lang}}Country', placeholder: '{{lang}}country', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Provinces', placeholder: '{{lang}}provinces', required: false } },
                { key: 'files', type: 'FileInput', col: '12', information: { label: '{{lang}}City', placeholder: '{{lang}}city', required: false } },

                {
                    type: 'SubformInput',
                    key: 'products',
                    information: {
                        headers: [
                            { key: 'product', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}product', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'count', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.count', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'value', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.price', placeholder: '{{lang}}useful.price', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    showMain: false
                },
            ]
        },
    },
    // inventory: {
    //     key: 'inventory',
    //     title: 'inventory',
    //     description: 'products inventory',
    //     fetchUrl: 'getInvenory',
    //     addUrl: 'postInventory',
    //     removeUrl: 'removeInventory',
    //     pageType: 'collection',
    //     options: {},
    //     sort: { 'cDate': -1 },
    //     icon: 'https://images.unsplash.com/photo-1616401784845-180882ba9ba8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80',
    //     description: '{{lang}}The descriptions of this module would be shown here',
    //     headers: [
    //         { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
    //         // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
    //     ]
    // }
}


const SettingsPages = {


    sections: {
        main: { key: 'main', name: '{{lang}}Main', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // inventory: { key: 'inventory', name: '{{lang}}Inventory', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // orders: { key: 'orders', name: '{{lang}}Orders', icon: '/images/applets-icons/accounting/063-cart.svg' },

        // purchases: { key: 'purchases', name: 'Purchases', icon: '/images/applets-icons/accounting/shopping-bag.svg' },
        // accountant: { key: 'accountant', name: 'Accountant', icon: '/images/applets-icons/accounting/book.svg' },
        // reports: { key: 'reports', name: 'Reports', icon: '/images/applets-icons/accounting/increasing.svg' },
        // settings: { key: 'settings', name: 'Settings', icon: '/images/settings-4.svg' },
    },


    pages: {

        connections: {
            key: 'connections',
            title: '{{lang}}connections',
            description: 'connections list',
            fetchUrl: 'getRelations',
            addUrl: 'hubinvitation',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'openConnectionModal', functionInput: 'addRule' },
            // customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [
                { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { hub: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: true }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },

        groups: {
            key: 'groups',
            title: '{{lang}}groups',
            description: 'groups list',
            fetchUrl: 'getConnectionGroups',
            addUrl: 'postConnectionGroup',
            editUrl: 'postConnectionGroup',
            removeUrl: 'yremoveConnectionGroup',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            // customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            // customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', hub: "{{targetId}}", type: 'G' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },
                { key: 'hubs', type: 'GlobalUserMultiInput', information: { label: '{{lang}}hubs', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: 'select hub', required: true, } },
            ]
        },



        requestsAndInvitations: {
            key: 'requestsAndInvitations',
            title: '{{lang}}Requests & invitations',
            description: 'Requests & invitations list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },

            ]
        },

        // connectionTypes: {
        //     key: 'connectionTypes',
        //     title: '{{lang}}connection Types',
        //     description: 'connectionTypes list',
        //     fetchUrl: 'DatabaseStage',
        //     addUrl: 'DiagramEditor',
        //     editUrl: 'editRelation',
        //     yremoveRelation: 'yremoveConnection',
        //     pageType: 'collection',
        //     options: {},
        //     sort: { 'cDate': -1 },
        //     customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
        //     customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: 'The descriptions of this module would be shown here',
        //     section: 'main',

        //     headers: [

        //         { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
        //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: true },

        //     ]
        // },



        permissions: {
            key: 'permissions',
            title: '{{lang}}permissions',
            description: 'permissions list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

            ]
        },


        automations: {
            key: 'automations',
            title: '{{lang}}automations',
            description: 'automations list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

            ]
        },



        collections: {
            key: 'collections',
            title: '{{lang}}collections',
            description: 'collections list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

            ]
        },
        pages: {
            key: 'pages',
            title: '{{lang}}pages',
            description: 'pages list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

            ]
        },
        variables: {
            key: 'variables',
            title: '{{lang}}variables',
            description: 'variables list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            headers: [

            ]
        },
    }
}



const FinanceAdminFrames = {

    sections: {
        sales: { key: 'sales', name: '{{lang}}Sales', icon: '/images/applets-icons/accounting/063-cart.svg' },
        purchases: { key: 'purchases', name: '{{lang}}Purchases', icon: '/images/applets-icons/accounting/shopping-bag.svg' },
        accountant: { key: 'accountant', name: '{{lang}}Accountant', icon: '/images/applets-icons/accounting/book.svg' },
        config: { key: 'config', name: '{{lang}}Configuration', icon: '/images/settings-4.svg' },

        reports: { key: 'reports', name: '{{lang}}Reports', icon: '/images/applets-icons/accounting/increasing.svg' },
    },

    pages: {

        invoice: {
            key: 'invoices/[var]',
            title: '{{lang}}applets.accounting.newInvoice',
            description: 'New Invoice',
            fetchUrl: 'getInvoice',
            addUrl: 'postInvoice',
            removeUrl: 'removeInvoice',
            pageType: 'invoice',
            hideInDashboard: true,
            // hideFromMenu: true,
            options: {},
            section: 'sales',
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/text.png',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [

                { key: 'hub', type: 'SelectInput', col: '12', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'hub.fullname', image: 'hub.image', value: 'hub._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },
                { key: 'salesperson', type: 'SelectInput', col: '12', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'hub.fullname', image: 'hub.image', value: 'hub._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },
                // { key: 'customer', type: 'UserFinanceInput', col: '12', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false ,inputClass:'aa'}, showMain: false },
                // { key: '_fake', type: 'FakeCol', col: '6', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingConnections', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },

                // { key: 'number', type: 'TextInput', col: '6', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: false }, showMain: true },
                // { key: 'salesperson', type: 'TextInput', col: '6', information: { label: '{{lang}}Sales person', placeholder: '{{lang}}Sales person', required: false, disabled: true }, showMain: false },


                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: false } },
                { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false } },
                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: false }, showMain: true },
                // { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: false },

                // { key: '_fake', type: 'FakeCol', col: '6', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingConnections', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },

                { key: 'commission', type: 'PriceInput', col: '6', information: { label: '{{lang}}commission', hint: '{{lang}}Insert the percentage %', disabled: false, placeholder: '{{lang}}commission', required: false } },

                { key: '_fake', type: 'FakeCol', col: '3', information: { label: '{{lang}}applets.accounting.customer', type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },


                {
                    type: 'InvoiceInput',
                    key: 'items',
                    information: {
                        inputClass: 'mt-2 p-0',
                        // label: '{{lang}}applets.accounting.items',
                        headers: [
                            { key: 'product', type: 'AdvancedSelectInput', col: '5', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, allFields: true, fields: { title: 'name', image: 'media', value: '_id', price: 'price', unit: 'unit', includesVariants: "includesVariants", }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'count', type: 'NumberInput', col: '2', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                            { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },

                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    required: false,

                    showMain: false
                },



                // { key: 'discount', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.discount', placeholder: '{{lang}}useful.discount', required: false } },
                // { key: 'tax', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.tax', placeholder: '{{lang}}useful.tax', required: false } },



                { type: 'FileInput', key: 'attachments', col: '12', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: true },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', rows: 6, placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },


        invoices: {
            key: 'invoices',
            title: '{{lang}}Invoices',
            description: 'Invoices list',
            fetchUrl: 'getInvoices',
            addUrl: 'postInvoice',
            editUrl: 'editInvoice',

            removeUrl: 'removeInvoice',
            pageType: 'collection',
            section: 'sales',

            options: {},
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/text.png',

            customAdd: 'invoice',
            customEdit: 'invoice',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [


                { key: 'id', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },

                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: false }, showMain: true },

                { key: 'hub', type: 'SelectInput', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'fullname', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: true },
                // { key: 'customerType', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}{{lang}}applets.accounting.customerType', required: false, type: 'local', default: '0', items: [{ title: "{{lang}}applets.accounting.YonnectCustomer", value: 'yonnect' }, { title: "{{lang}}applets.accounting.Mycustomer", value: 'mine' }, { title: "{{lang}}applets.accounting.CustomerInPerson", value: 'person' }] }, showMain: true, inExport: true },
                // {
                //     key: 'hub', type: 'SelectInput', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'fullname', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false },
                //     dependencies: [{
                //         refKey: 'customerType', targetKey: 'hub',
                //         conditions: [{
                //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customerType' }, operator: { value: '==' }, target: { value: 'yonnect' } } }, },
                //             effect: { show: true, },
                //             init: true,
                //         }],
                //         else: { show: false },

                //     }],
                //     showMain: true
                // },
                // // {
                // //     key: 'personalCustomer', type: 'SelectInput', information: { label: '{{lang}}applets.accounting.customer', address: 'getMyCustomers', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'fullname', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false },
                // //     dependencies: [{
                // //         refKey: 'customerType', targetKey: 'personalCustomer',
                // //         conditions: [{
                // //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customerType' }, operator: { value: '==' }, target: { value: 'mine' } } }, },
                // //             effect: { show: true, },
                // //             init: true,
                // //         }],
                // //         else: { show: false },

                // //     }],
                // //     showMain: true
                // // },
                // {
                //     key: 'personalCustomerfullname', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}Name', required: false, disabled: true },
                //     dependencies: [{
                //         refKey: 'customerType', targetKey: 'personalCustomerfullname',
                //         conditions: [{
                //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customerType' }, operator: { value: '==' }, target: { value: 'person' } } }, },
                //             effect: { show: true, }
                //         }],
                //         else: { show: false },
                //         // init: true,

                //     }],
                //     showMain: true
                // },
                // {
                //     key: 'personalCustomerphone', type: 'TextInput', col: '6', information: { label: '{{lang}}Phone', placeholder: '{{lang}}Phone', required: false, disabled: true },
                //     dependencies: [{
                //         refKey: 'customerType', targetKey: 'personalCustomerphone',
                //         conditions: [{
                //             root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customerType' }, operator: { value: '==' }, target: { value: 'person' } } }, },
                //             effect: { show: true, }
                //         }],
                //         else: { show: false },
                //         // init: true,

                //     }],
                //     showMain: true
                // },

                // { key: 'salesperson', type: 'TextInput', col: '6', information: { label: '{{lang}}Sales person', placeholder: '{{lang}}Sales person', required: false, disabled: true }, showMain: false },
                // { key: 'status', type: 'TextInput', col: '12', information: { label: '{{lang}}status', placeholder: '{{lang}}status', required: false, disabled: true }, showMain: true },
                { key: 'status', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}status', required: false, type: 'local', default: '0', items: [{ title: "Unpaid", value: 'U', color: '#789' }, { title: "Paid", value: 'P', color: '#00CD74' }, { title: "{{lang}}Partially Paid", value: 'PP', color: '#00CD74' }, { title: "{{lang}}Draft", value: 'D', color: '#789' },] }, showMain: true, inExport: true },

                { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: true },




                {
                    type: 'InvoiceInput',
                    key: 'items',
                    information: {
                        inputClass: 'mt-2 p-0',
                        // label: '{{lang}}applets.accounting.items',
                        headers: [
                            { key: 'item', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'quantity', type: 'NumberInput', col: '3', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                            { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },

                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    required: false,

                    showMain: false
                },


                { key: 'amounts.totals.final', type: 'PriceInput', col: '12', information: { label: '{{lang}}amount', placeholder: '{{lang}}amount', required: false, disabled: true }, showMain: true },

                { key: 'balanceDue', type: 'PriceInput', col: '12', information: { label: '{{lang}}balance due', placeholder: '{{lang}}balance due', required: false, disabled: true }, showMain: true },

                // {
                //     type: 'SubformInput',
                //     key: 'items',
                //     information: {
                //         // label: '{{lang}}applets.accounting.items',
                //         headers: [
                //             { key: 'product', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                //             { key: 'count', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.count', placeholder: '{{lang}}useful.count', required: false } },
                //             { key: 'price', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.price', placeholder: '{{lang}}useful.price', required: false } },
                //         ],

                //         placeholder: '{{lang}}placeholders.insertInformation',
                //         required: false
                //     },
                //     showMain: false
                // },

                // { key: 'discount', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.discount', placeholder: '{{lang}}useful.discount', required: false }, showMain: false },
                // { key: 'tax', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.tax', placeholder: '{{lang}}useful.tax', required: false }, showMain: false },
                { key: 'list.total', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.total', placeholder: '{{lang}}useful.total', required: false }, showMain: false },

                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
                { type: 'FileInput', key: 'attachments', col: '12', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: false },

            ]
        },
        myCustomers: {
            key: 'myCustomers',
            title: '{{lang}}applets.accounting.mycustomers',
            description: '{{lang}}applets.accounting.mycustomerslist',
            fetchUrl: 'getMyCustomers',
            addUrl: 'postMyCustomers',
            editUrl: 'postMyCustomers',

            removeUrl: 'removeMyCustomers',
            pageType: 'collection',
            section: 'sales',

            options: {},
            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/text.png',

            customAdd: 'invoice',
            customEdit: 'invoice',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [



                { key: 'fullname', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Name', required: false, disabled: false }, showMain: true },
                { key: 'phone', type: 'TextInput', col: '12', information: { label: '{{lang}}Phone', placeholder: '{{lang}}Phone', required: false, disabled: false }, showMain: true },
                { key: 'address', type: 'TextInput', col: '12', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: false, disabled: false }, showMain: true },


            ]
        },




        payment: {
            key: 'payments/[var]',
            title: '{{lang}}New Payment',
            description: 'Payment Received',
            fetchUrl: 'getReceivedPayment',
            addUrl: 'postReceivedPayment',
            removeUrl: 'removeReceivedPayment',
            pageType: 'payment',
            // pageType: "recordViewer",
            hideInDashboard: true,
            // hideFromMenu: true,
            options: {},
            section: 'sales',
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',


            description: '{{lang}}The descriptions of this module would be shown here',

            formPages: [

                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-customer', information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-info', information: { label: '{{lang}}Images and Videos', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-invoices', information: { label: '{{lang}}Pricing' } },

                    ]
                },
                // { label: '{{lang}}Membership', key: 'membership', isLastPage: true }
            ],

            headers: [

                // { key: 'customer', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },
                // { key: '_fake', type: 'FakeCol', col: '6', information: { label: '{{lang}}applets.accounting.customer', type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },
                { key: 'customer', type: 'SelectInput', section: 'sec-customer', col: '12', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'hub.fullname', image: 'hub.image', value: 'hub._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: true }, showMain: false },

                {
                    key: 'fullAmount', type: 'RecieveFullAmountInput', section: 'sec-customer', col: '12', information: { triggerKey: 'customer', targetKey: 'amount', inputClass: 'blank' }, showMain: false,
                    dependencies: [{
                        refKey: 'customer', targetKey: 'fullAmount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customer' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { show: false, }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                },
                { key: 'lineSeperator', type: 'lineSeperator', section: 'sec-customer', col: '12', showMain: false, },


                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}Payment Date', placeholder: '{{lang}}Payment Date', required: false }, showMain: true },
                { key: 'number', type: 'TextInput', col: '6', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },

                {
                    key: 'amount', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.amount', disabled: false, placeholder: '{{lang}}useful.amount', required: false },
                    dependencies: [{
                        refKey: 'customer', targetKey: 'amount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customer' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { disabled: true, }
                        }],
                        else: { disabled: false },
                        init: true,

                    }],
                },




                // { key: 'dueDate', type: 'DateInput', col: '3', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: false },
                { key: 'mode', type: 'SelectInput', col: '6', information: { label: '{{lang}}Payment Mode', type: 'local', items: [{ value: 'cash', title: '{{lang}}Cash' }, { value: 'check', title: '{{lang}}Check' }, { value: 'bank_transfer', title: '{{lang}}Bank transfer' }, { value: 'credit_card', title: '{{lang}}Credit Card' }], placeholder: '{{lang}}type', required: false } },


                // {
                //     type: 'InvoiceInput',
                //     key: 'list',
                //     information: {
                //         inputClass: 'mt-2 p-0',
                //         headers: [
                //             { key: 'item', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                //             { key: 'quantity', type: 'NumberInput', col: '3', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                //             { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                //             { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },

                //         ],

                //         placeholder: '{{lang}}placeholders.insertInformation',
                //         required: false
                //     },
                //     required: false,

                //     showMain: false
                // },


                {
                    key: 'invoices', type: 'UnpaidInvoicesInput', section: 'sec-customer', col: '12', information: { label: "{{lang}}Unpaid invoices", triggerKey: 'customer', targetKey: 'amount', inputClass: 'blank' }, showMain: false,
                    dependencies: [{
                        refKey: 'customer', targetKey: 'invoices',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customer' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { show: false, }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                },




                { key: 'bankCharges', type: 'PriceInput', col: '6', information: { label: '{{lang}}Bank Charges (If any)', disabled: false, placeholder: '{{lang}}Bank Charges', required: false } },
                { key: 'depositTo', type: 'SelectInput', col: '6', information: { label: '{{lang}}Deposit To', address: 'getAccounts', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Deposit to', required: false }, showMain: false },



                { type: 'FileInput', key: 'attachments', col: '12', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: true },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', rows: 6, placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },




        payments: {
            key: 'payments',
            title: '{{lang}}applets.accounting.paymentsReceived',
            description: 'payments list',
            fetchUrl: 'getPayments',
            addUrl: 'postPayment',
            removeUrl: 'removePayment',
            pageType: 'collection',
            section: 'sales',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            customAdd: '../paymentReceived',
            customEdit: '../paymentReceived',

            filter: { applet: '{{appletId}}' },
            actions: {
                view: { key: "view", label: '{{lang}}view', color: '#677dc4', function: "openEditModal" },
                remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal" }
            },


            formPages: [

                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-customer', information: { label: '{{lang}}Customer', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-info', information: { label: '{{lang}}Information', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-extra-info', information: { label: '{{lang}}Extra Information', fontSize: 16, color: '#000', fontWeight: '600' } },

                        // { key: 'sec-invoices', information: { label: '{{lang}}Pricing' } },

                    ]
                },
            ],

            headers: [


                { key: 'customer', type: 'SelectInput', section: 'sec-customer', col: '12', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'hub.fullname', image: 'hub.image', value: 'hub._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: true }, showMain: false },

                {
                    key: 'fullAmount', type: 'RecieveFullAmountInput', section: 'sec-customer', col: '12', information: { triggerKey: 'customer', targetKey: 'amount', inputClass: 'blank' }, showMain: false,
                    dependencies: [{
                        refKey: 'customer', targetKey: 'fullAmount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customer' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { show: false, }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                },
                // { key: 'lineSeperator', type: 'lineSeperator', section: 'sec-customer', col: '12', showMain: false, },


                { key: 'date', type: 'DateInput', col: '6', section: 'sec-info', information: { label: '{{lang}}Payment Date', placeholder: '{{lang}}Payment Date', required: false }, showMain: true },
                { key: 'number', type: 'TextInput', col: '6', section: 'sec-info', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },

                {
                    key: 'amount', type: 'PriceInput', col: '6', section: 'sec-info', information: { label: '{{lang}}useful.amount', disabled: false, placeholder: '{{lang}}useful.amount', required: false },
                    dependencies: [{
                        refKey: 'customer', targetKey: 'amount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customer' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { disabled: true, }
                        }],
                        else: { disabled: false },
                        init: true,

                    }],
                },




                // { key: 'dueDate', type: 'DateInput', col: '3',section:'sec-info', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: false },
                { key: 'mode', type: 'SelectInput', col: '6', section: 'sec-info', information: { label: '{{lang}}Payment Mode', type: 'local', items: [{ value: 'cash', title: '{{lang}}Cash' }, { value: 'check', title: '{{lang}}Check' }, { value: 'bank_transfer', title: '{{lang}}Bank transfer' }, { value: 'credit_card', title: '{{lang}}Credit Card' }], placeholder: '{{lang}}type', required: false } },


                // {
                //     type: 'InvoiceInput',
                //     key: 'list',
                //     information: {
                //         inputClass: 'mt-2 p-0',
                //         headers: [
                //             { key: 'item', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                //             { key: 'quantity', type: 'NumberInput', col: '3', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                //             { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                //             { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },

                //         ],

                //         placeholder: '{{lang}}placeholders.insertInformation',
                //         required: false
                //     },
                //     required: false,

                //     showMain: false
                // },


                {
                    key: 'invoices', type: 'UnpaidInvoicesInput', section: 'sec-info', col: '12', information: { label: "{{lang}}Unpaid invoices", triggerKey: 'customer', targetKey: 'amount', inputClass: 'blank' }, showMain: false,
                    dependencies: [{
                        refKey: 'customer', targetKey: 'invoices',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.customer' }, operator: { value: '==' }, target: { value: null } } }, },
                            effect: { show: false, }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                },




                { key: 'bankCharges', type: 'PriceInput', col: '6', section: 'sec-extra-info', information: { label: '{{lang}}Bank Charges (If any)', disabled: false, placeholder: '{{lang}}Bank Charges', required: false } },
                { key: 'depositTo', type: 'SelectInput', col: '6', section: 'sec-extra-info', information: { label: '{{lang}}Deposit To', address: 'getAccounts', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Deposit to', required: false }, showMain: false },



                { type: 'FileInput', key: 'attachments', col: '12', section: 'sec-extra-info', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: true },
                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-extra-info', information: { label: '{{lang}}description', rows: 6, placeholder: '{{lang}}description', required: false }, showMain: false },





                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}Payment date', placeholder: '{{lang}}payment date', required: false }, showMain: true },

                // { key: 'bankCharges', type: 'PriceInput', col: '6', information: { label: '{{lang}}Bank Charges (If any)', disabled: false, placeholder: '{{lang}}Bank Charges', required: false }, showMain: false },

                // { key: 'number', type: 'TextInput', col: '6', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },

                // { key: 'customer', type: 'SelectInput', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'fullname', image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: true },

                // { key: 'mode', type: 'SelectInput', col: '6', information: { label: '{{lang}}Payment Mode', type: 'local', items: [{ value: 'cash', title: '{{lang}}Cash' }, { value: 'check', title: '{{lang}}Check' }, { value: 'bank_transfer', title: '{{lang}}Bank transfer' }, { value: 'credit_card', title: '{{lang}}Credit Card' }], placeholder: '{{lang}}type', required: false } },
                // { key: 'depositTo', type: 'SelectInput', col: '6', information: { label: '{{lang}}Deposit To', address: 'getAccounts', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Deposit to', required: false }, showMain: false },




                // { key: 'amount', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.amount', disabled: false, placeholder: '{{lang}}useful.amount', required: false } },
                // { key: 'withoutInvoiceAmount', type: 'PriceInput', col: '6', information: { label: '{{lang}}Unused Amount', disabled: false, placeholder: '{{lang}}Unused Amount', required: false },showMain: false },

                // { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}description', rows: 6, placeholder: '{{lang}}description', required: false }, showMain: false },
                // { type: 'FileInput', key: 'attachments', col: '6', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: false },

            ]
        },




        purchaseOrder: {
            key: 'purchaseOrder',
            title: '{{lang}}applets.accounting.purchaseOrder',
            description: 'Invoices list',
            fetchUrl: 'getInvoices',
            addUrl: 'postInvoice',
            removeUrl: 'removeInvoice',
            pageType: 'commingSoon',
            section: 'purchases',
            options: {},
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/text.png',

            customAdd: '../newinvoice',
            customEdit: '../newinvoice',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'number', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
                { key: 'customer', type: 'SelectInput', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingConnections', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'userId.name', image: 'userId.image', value: 'userId._id' }, type: 'api', isSearchable: true, icon: '/images/search.svg', placeholder: '{{lang}}', required: false }, showMain: true },
                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: false }, showMain: true },
                { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: false },
                {
                    type: 'SubformInput',
                    key: 'items',
                    information: {
                        headers: [
                            { key: 'product', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'count', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.count', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'price', type: 'PriceInput', col: '4', information: { label: '{{lang}}useful.price', placeholder: '{{lang}}useful.price', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    showMain: false
                },

                { key: 'discount', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.Discount', placeholder: '{{lang}}useful.Discount', required: false }, showMain: false },
                { key: 'tax', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.tax', placeholder: '{{lang}}useful.tax', required: false }, showMain: false },
                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },
                { type: 'FileInput', key: 'attachments', col: '12', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: false },

            ]
        },



        paymentsMade: {
            key: 'paymentsMade',
            title: '{{lang}}applets.accounting.paymentsMade',
            description: 'payments list',
            fetchUrl: 'getInvoices',
            addUrl: 'postValue',
            removeUrl: 'removeValue',
            helperKey: 'values',
            pageType: 'commingSoon',
            section: 'purchases',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                { key: 'customer', type: 'TextInput', col: '6', information: { label: '{{lang}}customer', placeholder: '{{lang}}customer', required: false } },

            ]
        },




        expenses: {
            key: 'expenses',
            title: '{{lang}}applets.accounting.expenses',
            description: 'expenses list',
            fetchUrl: 'getInvoices',
            addUrl: 'postValue',
            removeUrl: 'removeValue',
            helperKey: 'values',
            pageType: 'commingSoon',
            section: 'purchases',

            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                { key: 'customer', type: 'TextInput', col: '6', information: { label: '{{lang}}customer', placeholder: '{{lang}}customer', required: false } },

            ]
        },




        manualJournals: {
            key: 'manualJournals',
            title: '{{lang}}applets.accounting.manualJournals',
            description: 'Manual journals list',
            fetchUrl: 'getExtraSection',
            addUrl: 'ypostExtraSection',
            removeUrl: 'yremoveExtraSection',
            pageType: 'commingsoon',
            section: 'accountant',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', section: 'accountingAccounts' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingAccounts' },

            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },

            ]
        },



        accounts: {
            key: 'accounts',
            title: '{{lang}}Chart of accounts',
            description: 'accounts list',
            fetchUrl: 'getAccounts',
            addUrl: 'postAccount',
            removeUrl: 'removeAccount',
            pageType: 'collection',
            section: 'accountant',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },

            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },

                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'code', type: 'TextInput', col: '12', information: { label: '{{lang}}Code', placeholder: '{{lang}}Code', required: false } },
                { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', type: 'local', items: [{ value: 'Income', title: '{{lang}}Income' }, { value: 'Expense', title: '{{lang}}Expense' }], placeholder: '{{lang}}type', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { label: '{{lang}}parent', address: 'getAccounts', filter: {}, fields: { title: 'name', description: "type", value: '_id' }, type: 'api', placeholder: '{{lang}}parent', required: false } },
                { key: 'lock', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Locked', placeholder: '{{lang}}name', required: false, hideFromMenu: true }, hideComponent: true },

                { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },


        accountReport: {
            key: "accountReport",
            title: '{{lang}}Account report',
            description: 'Reports',
            fetchUrl: 'getReports',
            addUrl: 'postReports',
            removeUrl: 'AccountingReports',
            pageType: 'accountReport',
            // hideFromMenu: true,
            options: {},
            section: 'accountant',
            filter: { applet: '{{appletId}}' },
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/text.png',

            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [

                { key: 'customer', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },
                // { key: '_fake', type: 'FakeCol', col: '6', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingConnections', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },

                // { key: 'number', type: 'TextInput', col: '6', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: false }, showMain: true },
                // { key: 'salesperson', type: 'TextInput', col: '6', information: { label: '{{lang}}Sales person', placeholder: '{{lang}}Sales person', required: false, disabled: true }, showMain: false },


                { key: 'date', type: 'DateInput', col: '3', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: false }, showMain: true },
                { key: 'dueDate', type: 'DateInput', col: '3', information: { label: '{{lang}}applets.accounting.dueDate', placeholder: '{{lang}}applets.accounting.dueDate', required: false }, showMain: false },

                // { key: '_fake', type: 'FakeCol', col: '6', information: { label: '{{lang}}applets.accounting.customer', address: 'getAccountingConnections', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },

                { key: 'salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },
                { key: 'commission', type: 'PriceInput', col: '3', information: { label: '{{lang}}commission', hint: '{{lang}}Insert the percentage %', disabled: false, placeholder: '{{lang}}commission', required: false } },

                { key: '_fake', type: 'FakeCol', col: '3', information: { label: '{{lang}}applets.accounting.customer', type: 'api', isSearchable: true, placeholder: '{{lang}}customer', required: false }, showMain: false },


                {
                    type: 'InvoiceInput',
                    key: 'list',
                    information: {
                        inputClass: 'mt-2 p-0',
                        // label: '{{lang}}applets.accounting.items',
                        headers: [
                            { key: 'item', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'quantity', type: 'NumberInput', col: '3', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                            { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },

                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    required: false,

                    showMain: false
                },



                // { key: 'discount', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.discount', placeholder: '{{lang}}useful.discount', required: false } },
                // { key: 'tax', type: 'PriceInput', col: '6', information: { label: '{{lang}}useful.tax', placeholder: '{{lang}}useful.tax', required: false } },



                { key: 'description', type: 'TextAreaInput', col: '6', information: { label: '{{lang}}description', rows: 6, placeholder: '{{lang}}description', required: false }, showMain: false },
                { type: 'FileInput', key: 'attachments', col: '6', information: { label: '{{lang}}useful.attachments', single: false, placeholder: '{{lang}}useful.attachments', required: false }, showMain: true },

            ]
        },



        banks: {
            key: 'banks',
            title: '{{lang}}applets.accounting.banks',
            description: 'Banks list',
            fetchUrl: 'getExtraSection',
            addUrl: 'ypostExtraSection',
            removeUrl: 'yremoveExtraSection',
            pageType: 'commingsoon',
            section: 'accountant',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', section: 'accountingBanks' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingBanks' },

            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
                { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'values.balance', type: 'NumberInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },

            ]
        },



        commissions: {
            key: 'commissions',
            title: '{{lang}}Commissions',
            description: 'Commissions list',
            fetchUrl: 'getExtraSection',
            addUrl: 'ypostExtraSection',
            removeUrl: 'yremoveExtraSection',
            pageType: 'commingsoon',
            section: 'accountant',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', section: 'accountingBanks' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingBanks' },

            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
                { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'values.balance', type: 'NumberInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },

            ]
        },



        payouts: {
            key: 'payouts',
            title: '{{lang}}Payouts',
            description: 'Payouts list',
            fetchUrl: 'getExtraSection',
            addUrl: 'ypostExtraSection',
            removeUrl: 'yremoveExtraSection',
            pageType: 'commingsoon',
            section: 'accountant',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}', section: 'accountingBanks' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingBanks' },

            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                // { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
                { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                { key: 'values.balance', type: 'NumberInput', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },

            ]
        },



        paymentGateways: {
            key: 'paymentGateways',
            title: '{{lang}}Payment gateways',
            fetchUrl: 'getPaymentTypes',
            addUrl: 'postPaymentType',
            editUrl: 'postPaymentType',
            removeUrl: 'removePaymentType',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'config',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            formPages: [
                {
                    label: '{{lang}}Product Type', key: 'type',

                },
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-thirdparty', information: { label: '{{lang}}Third party', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-config', information: { label: '{{lang}}Configuration', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-limitations', information: { label: '{{lang}}Limitations (Optional)', fontSize: 16, color: '#000', fontWeight: '600' } },

                    ]
                }],


            headers: [


                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the delivey type. Each type has its settings and configurations', fontSize: 16, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },

                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Payment type', backgroundColor: '#fff', border: '1px solid #eee', col: 4, imageOnSide: false, type: 'local', inputClass: 'fake', items: [
                            { value: 'manual', title: '{{lang}}Manual Payment', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/manual.svg' },
                            { value: 'Stripe', title: '{{lang}}Stripe', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/stripe.png' },
                            { value: 'PayPal', title: '{{lang}}PayPal', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/PayPal.jpg' },
                            { value: 'Authorize', title: '{{lang}}Authorize.net', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/Authorize.net.svg' },

                            { value: 'Afterpay', title: '{{lang}}Afterpay', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/afterpay.svg' },

                            { value: 'Affirm', title: '{{lang}}Affirm', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/affirm.svg' },
                            { value: 'Bankful', title: '{{lang}}Bankful', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/bankful.svg' },

                            { value: 'POS', title: '{{lang}}Point of Sale (POS)', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/pos.svg' },

                        ],


                        placeholder: '{{lang}}Select', required: true
                    }, showMain: true
                },


                {
                    key: 'thirdparty', type: 'ThirdPartyInput', col: '12', section: 'sec-thirdparty', pages: ['information'], information: { label: '{{lang}}Connect', refKey: "type", required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'thirdparty',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "manual" } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                { key: 'name', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Name', placeholder: '{{lang}}e.g., Standard shipping, Free delivery', help: 'This will be visible to customers in their cart and at checkout process.', required: false } },


                { key: 'description', type: 'TextAreaInput', section: 'sec-config', pages: ['information'], col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false } },


                { key: 'proofUpload', type: 'SwitchInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Customer needs to upload proof of payment?', help: 'If you activate this option, customers will see the option to upload their proof of payment.', required: false } },



                { key: 'regions', type: 'RegionsInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Regions', address: 'getCountries', filter: {}, fields: { title: 'name', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: 'If you do not want to have any limitations, you can leave this field empty.', help: "{{lang}}You can make payment available only for customers in specific regions. You can leave this empty for no limitation.", placeholder: '{{lang}}International', required: false }, showMain: false },


                { key: 'availableFor', type: 'SelectInput', section: 'sec-limitations', pages: ['information'], col: '12', fullCol: true, information: { label: '{{lang}}Available for', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}All hubs and groups", value: 'all' }, { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },

                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },




                // { key: 'haveConditions', type: 'SwitchInput', col: '12', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Have Conditions', placeholder: '{{lang}}haveConditions', default: false, required: false }, showMain: false },
                // {
                //     key: 'conditions.prePayType', type: 'SelectInput', col: '6', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Pre Pay Type', required: false, type: 'local', items: [{ title: "const", value: 'const' }, { title: "percentage", value: 'percentage' }] },
                //     dependencies: [{
                //         refKey: 'haveConditions',
                //         targetKey: 'conditions.prePayType',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.haveConditions' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,

                //     }], showMain: false, inExport: true
                // },
                // {
                //     key: 'conditions.prePay', type: 'NumberInput', col: '6', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Pre Pay', placeholder: '{{lang}}prePay', required: false },
                //     dependencies: [{
                //         refKey: 'haveConditions',
                //         targetKey: 'conditions.prePay',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.haveConditions' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'section: 'sec-limitations', pages: ['information'], information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     key: 'conditions.timingType', type: 'SelectInput', col: '6', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Timing Type', required: false, type: 'local', items: [{ title: "week", value: 'week' }, { title: "month", value: 'month' }, { title: "year", value: 'year' }] },
                //     dependencies: [{
                //         refKey: 'haveConditions',
                //         targetKey: 'conditions.timingType',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.haveConditions' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'section: 'sec-limitations', pages: ['information'], information.filter.id', value: '@data.thing' },

                //     }], showMain: false, inExport: true
                // },
                // {
                //     key: 'conditions.timing', type: 'NumberInput', col: '6', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Timing', placeholder: '{{lang}}timing', required: false },
                //     dependencies: [{
                //         refKey: 'haveConditions',
                //         targetKey: 'conditions.timing',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.haveConditions' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'section: 'sec-limitations', pages: ['information'], information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     key: 'conditions.extraChargeType', type: 'SelectInput', col: '6', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Extra Charge Type', required: false, type: 'local', items: [{ title: "on total", value: 'on total' }, { title: "on remaining", value: 'on remaining' }] },
                //     dependencies: [{
                //         refKey: 'haveConditions',
                //         targetKey: 'conditions.extraChargeType',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.haveConditions' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'section: 'sec-limitations', pages: ['information'], information.filter.id', value: '@data.thing' },

                //     }], showMain: false, inExport: true
                // },
                // {
                //     key: 'conditions.extraCharge', type: 'NumberInput', col: '6', section: 'sec-limitations', pages: ['information'], information: { label: '{{lang}}Extra Charge%', placeholder: '{{lang}}extracharge%', required: false },
                //     dependencies: [{
                //         refKey: 'haveConditions',
                //         targetKey: 'conditions.extraCharge',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.haveConditions' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },






        taxes: {
            key: 'taxes',
            title: '{{lang}}Tax configuration',
            fetchUrl: 'getTaxes',
            addUrl: 'postTax',
            editUrl: 'postTax',
            removeUrl: 'removeTax',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'config',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            formPages: [

                {
                    label: '{{lang}}Tax Type', key: 'type',
                },

                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-config', information: { label: '{{lang}}Configuration', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-limitations', information: { label: '{{lang}}Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-extra', information: { label: '{{lang}}Extra information (Optional)', fontSize: 16, color: '#000', fontWeight: '600' } },

                    ]
                }],


            headers: [


                // { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the tax type.', fontSize: 16, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },

                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Type', backgroundColor: '#fff', border: '1px solid #eee', col: 2, imageOnSide: false, type: 'local', inputClass: 'fake', items: [
                            { value: 'single', title: '{{lang}}Single rate', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/delivery.png' },
                            { value: 'group', title: '{{lang}}Taxes Group', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/price-tag.png' },
                        ],


                        placeholder: '{{lang}}Select', required: true
                    }, showMain: true
                },


                { key: 'regions', type: 'RegionsInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Regions', singleCountry: true, address: 'getCountries', filter: {}, fields: { title: 'name', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', help: "{{lang}}You can make payment available only for customers in specific regions. You can leave this empty for no limitation.", placeholder: '{{lang}}Select the country', required: true }, showMain: true },

                { key: 'name', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Name', placeholder: '{{lang}}e.g., Federal tax, State tax, etc', required: true } },

                { key: 'code', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Code', placeholder: '{{lang}}Tax code for internal use', required: false } },


                {
                    type: 'SubformInput',
                    key: 'list',
                    col: '12',
                    // tab: 'specifications',
                    pages: ['information'],
                    section: 'sec-config',
                    information: {
                        editInModal: true,
                        defaultRow: true,
                        label: '{{lang}}Taxes list',
                        help: '{{lang}}The combination of this taxes will be applied to the items which this group is considered as their tax reference. The limitation of region will also be considered based on the region of this taxes. For example if you add multiple taxes with different regions, only the taxes in this group which fulfill the region restrictions will be applied.',


                        // TO DO: Don't fetch the current tax if is editing
                        headers: [
                            { key: 'tax', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}Tax name', address: 'getTaxes', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Select ...', required: true } },
                        ],
                        placeholder: '{{lang}}specifications',
                        required: true,
                    },

                    dependencies: [{
                        refKey: 'type', targetKey: 'list',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'group' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false

                },

                // { key: 'country', type: 'SelectInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}country', updateAfterSelect: true, isSearchable: true, address: 'getCountries', filter: { page: 'form' }, fields: { title: 'name', value: '_id', image: 'emogi' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select country', required: false }, showMain: false },

                // { key: 'group', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Group', placeholder: '{{lang}}e.g., GST, VAT, PST, etc', help: "{{lang}}Tax groups can be assigned to goods, services, shipping, and any place you need to assign taxes. Groups help combining taxes.", required: true } },


                {
                    key: 'rate', type: 'PriceInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Rate', max: 100, placeholder: '0', rightIndicator: '%', required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'rate',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'group' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                },


                {
                    key: 'due', type: 'PriceInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Payment due', placeholder: '0', rightIndicator: '{{currency}}', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'due',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'group' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                },


                {
                    key: 'compound', type: 'SwitchInput', col: '12', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Compound tax', help: "{{lang}}This will charge a second tax in addition to the primary tax.", required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'compound',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'group' } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: true
                },


                { key: 'description', type: 'TextAreaInput', section: 'sec-config', pages: ['information'], col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },




                { key: 'applicableTo', type: 'SelectInput', section: 'sec-limitations', pages: ['information'], col: '12', fullCol: true, information: { label: '{{lang}}Applicable To', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}All hubs and groups", value: 'all' }, { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },

                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'applicableTo', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.applicableTo' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.applicableTo' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'applicableTo', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.applicableTo' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.applicableTo' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                {
                    key: 'frequency', type: 'SelectInput', section: 'sec-extra', pages: ['information'], col: '12', fullCol: true, information: { label: '{{lang}}Filing frequency', required: false, type: 'local', default: 'Annual', items: [{ title: "{{lang}}Semiweekly", value: 'Semiweekly' }, { title: "{{lang}}Monthly", value: 'Monthly' }, { title: "{{lang}}Quarterly", value: 'Quarterly' }, { title: "{{lang}}Semi-Annual", value: 'groups' }, { title: "{{lang}}Annual", value: 'Annual' }] },
                    dependencies: [{
                        refKey: 'type', targetKey: 'frequency',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.list' }, operator: { value: '!=' }, target: { value: 'group' } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false, inExport: true
                },

            ]


        },




        reports: {
            key: 'reports',
            title: '{{lang}}reports',
            description: 'Reports list',
            fetchUrl: 'getInvoices',
            addUrl: 'postValue',
            removeUrl: 'removeValue',
            helperKey: 'values',
            pageType: 'report',
            section: 'reports',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: false } },
                { key: 'customer', type: 'TextInput', col: '6', information: { label: '{{lang}}customer', placeholder: '{{lang}}customer', required: false } },

            ]
        },

        // settings: {
        //     key: 'settings',
        //     title: 'Settings',
        //     description: 'Settings list',
        //     fetchUrl: 'getProductsCategories',
        //     addUrl: 'ypostProductCategory',
        //     editUrl: 'ypostProductCategory',
        //     removeUrl: 'yremoveExtraSection',
        //     // helperKey: 'values',
        //     pageType: 'settings',

        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
        //     icon: '/images/covers/settings.jpg',
        //     image: '/images/covers/settings.jpg',

        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         { key: 'main', type: 'SectionIndicator', col: '12', information: { label: '{{lang}}main' } },
        //         { key: 'connections', type: 'PageIndicator', col: '12', information: { function: 'changePage', inputData: 'connections', label: '{{lang}}connections', placeholder: '{{lang}}name' } },
        //         // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
        //     ]
        // },



        // general: {
        //     key: 'general',
        //     title: '{{lang}}General',
        //     description: 'General Settings',
        //     // fetchUrl: 'getgeneral',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremoveConnection',
        //     pageType: 'commingSoon',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [


        //     ]
        // },




        // connections: {
        //     key: 'connections',
        //     title: '{{lang}}Connections',
        //     description: 'Connections list',
        //     fetchUrl: 'getConnections',
        //     addUrl: 'yaddConnection',
        //     editUrl: 'yeditConnection',

        //     removeUrl: 'yremoveConnection',
        //     pageType: 'collection',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     addNew: { title: '{{lang}}Invite User', function: 'openInviteUser', },
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/images/covers/users.jpeg',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [

        //         { type: 'GlobalUserInput', key: 'userId', information: { label: '{{lang}}Global User', address: 'ysearchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false } },
        //         { key: 'status', type: 'TextInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, showMain: true },

        //     ]
        // },



        // permissions: {
        //     key: 'permissions',
        //     title: '{{lang}}Permissions',
        //     description: 'Permissions list',
        //     fetchUrl: 'getPermissions',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremovePermission',
        //     pageType: 'collection',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },
        //     customAdd: { title: '{{lang}}Add permission', page: '/m_permission', },
        //     customEdit: { title: '{{lang}}Add permission', page: '/m_permission', },

        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [

        //         // { type: 'GlobalUserInput', key: 'userId', information: { label: '{{lang}}Global User', address: 'ysearchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false } },

        //         { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
        //         { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true }, showMain: true },

        //         { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}useful.description', placeholder: '{{lang}}useful.description', required: false, disabled: true }, showMain: true },

        //     ]
        // },



        // m_permission: {
        //     key: 'm_permission',
        //     title: '{{lang}}Permissions',
        //     // description: 'Permissions list',
        //     fetchUrl: 'getPermission',
        //     addUrl: 'ypostPermission',
        //     editUrl: 'ypostPermission',

        //     // removeUrl: 'yremoveConnection',
        //     pageType: 'permission',
        //     // section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     // sort: { 'cDate': -1 },

        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [

        //         // { type: 'GlobalUserInput', key: 'userId', information: { label: '{{lang}}Global User', address: 'ysearchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false } },
        //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}useful.description', placeholder: '{{lang}}useful.description', required: false, }, showMain: true },

        //     ]
        // },




        // automation: {
        //     key: 'automation',
        //     title: '{{lang}}Automation',
        //     description: 'automation Settings',
        //     // fetchUrl: 'getcustomization',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremoveConnection',
        //     pageType: 'commingSoon',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: []
        // },




        // customization: {
        //     key: 'customization',
        //     title: '{{lang}}Customization',
        //     description: 'customization Settings',
        //     // fetchUrl: 'getcustomization',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremoveConnection',
        //     pageType: 'commingSoon',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [


        //     ]
        // },




        // numberSeries: {
        //     key: 'numberSeries',
        //     title: '{{lang}}Number Series',
        //     description: 'numberSeries Settings',
        //     // fetchUrl: 'getcustomization',
        //     // addUrl: 'yaddConnection',
        //     // editUrl: 'yeditConnection',

        //     removeUrl: 'yremoveConnection',
        //     pageType: 'commingSoon',
        //     section: 'settings',

        //     options: {},
        //     hideFromMenu: true,
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetId: "{{targetId}}" },
        //     icon: '/assets/icons/applets/general/shop.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [


        //     ]
        // },


    },

    settingsSections: {
        main: { key: 'main', noChildren: false, name: '{{lang}}Main' },
    },

    settings: {

        automation: {
            key: 'automation',
            title: '{{lang}}automation',
            description: 'automation list',
            fetchUrl: 'DatabaseStage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'DatabaseStage',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                // { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },
        newform: {
            key: 'newform',
            title: '{{lang}}new form',
            description: 'newform list',
            fetchUrl: 'newform',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'newform',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                // { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },
        newPage: {
            key: 'newPage',
            title: '{{lang}}new page',
            description: 'newpage list',
            fetchUrl: 'newpage',
            addUrl: 'DiagramEditor',
            editUrl: 'editRelation',
            yremoveRelation: 'yremoveConnection',
            pageType: 'newpage',
            options: {},
            sort: { 'cDate': -1 },
            customAdd: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changeStage', functionInput: 'addRule' },

            filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: 'The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [

                // { type: 'GlobalUserInput', key: 'hub', information: { label: '{{lang}}Global User', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', placeholder: '{{lang}}Select', required: false, }, hideComponent: true },

                // { key: 'userId', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Yonnect User', placeholder: '{{lang}}Yonnect User', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // // { type: 'ImageInput', key: 'images', col: '12', information: { label: '{{lang}}images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },


                // { key: 'extraSection', type: 'FormSection', col: '12', information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Custom Fields' }, { key: 'remark', label: '{{lang}}Remark' }], required: false }, showMain: false },


                // { key: '*extra.name', type: 'TextInput', col: '12', section: 'extra', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false }, showMain: false },
                // { key: '*extra.phone', type: 'PhoneInput', col: '6', section: 'extra', information: { label: '{{lang}}phone', hint: 'International standard book number', placeholder: '{{lang}}phone', required: false }, showMain: false },
                // { key: '*extra.email', type: 'TextInput', col: '6', section: 'extra', information: { label: '{{lang}}email', hint: 'Universal product code', placeholder: '{{lang}}email', required: false }, showMain: false },
                // // { key: '*extra.registerDate', type: 'DateInput', col: '6',section:'extra', information: { label: '{{lang}}applets.connections.registerDate', placeholder: '{{lang}}applets.connections.registerDate', required: false }, showMain: true },

                // { key: '*extra.commission', type: 'NumberInput', col: '6', section: 'extra', information: { label: '{{lang}}commission (%)', placeholder: '{{lang}}commission', required: false }, showMain: false },
                // { key: '*extra.salesperson', type: 'SelectInput', col: '6', information: { label: '{{lang}}applets.accounting.salesperson', address: 'getAccountingRelations', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}", section: 'accountingCustomers' }, fields: { title: 'user.name', image: 'user.image', value: 'user._id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false }, showMain: false },

                // { key: '*extra.address', type: 'TextAreaInput', col: '12', section: 'extra', information: { label: '{{lang}}address', hint: 'Manufacturing Part Number', placeholder: '{{lang}}address', required: false }, showMain: false },
                // { key: '*extra.description', type: 'TextAreaInput', col: '12', section: 'remark', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

            ]
        },

    }

}









const BookingPages = {


    sections: {
        reservations: { key: 'reservations', name: '{{lang}}Reservations', icon: '/images/applets-icons/accounting/063-cart.svg' },
        manage: { key: 'manage', name: '{{lang}}Manage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // orders: { key: 'orders', name: '{{lang}}Orders', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // loyaltySystem: { key: 'loyaltysystem', name: '{{lang}}Loyalty System', icon: '/images/applets-icons/accounting/063-cart.svg' },
    },


    pages: {

        reservations: {
            key: 'reservations',
            title: '{{lang}}Reservations',
            description: 'products reservations',
            fetchUrl: 'getProducts',
            addUrl: 'postProduct',
            editUrl: 'postProduct',
            removeUrl: 'removeProduct',

            section: 'reservations',
            pageType: 'collection',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            headers: [

                { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
                { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
                { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                { type: 'ImageInput', key: 'images', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'description', type: 'EditorInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                { key: 'special', type: 'SwitchInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
                { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

                { key: 'available', type: 'SwitchInput', col: "12", pages: ['information'], information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },

                { key: 'priceSttings.priceBeforeDiscount', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Selling Price', placeholder: '{{lang}}Selling Price', required: false } },

                { key: 'cprice', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Cost Price', placeholder: '{{lang}}Cost Price', required: false }, showMain: false },
                { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },
            ]
        },



        services: {
            key: 'services',
            title: '{{lang}}Services',
            description: 'Services list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'manage',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },




        providers: {
            key: 'providers',
            title: '{{lang}}Providers',
            description: 'Providers list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'manage',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/pic.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },




        clients: {
            key: 'clients',
            title: '{{lang}}Clients',
            description: 'Clients list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'manage',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/news-feed.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        products: {
            key: 'products',
            title: '{{lang}}Products & Services',
            fetchUrl: 'getProducts',
            addUrl: 'postProduct',
            editUrl: 'postProduct',
            section: 'main',
            removeUrl: 'removeProduct',
            pageType: 'collection',
            model: 'products',
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            actions: [{ type: 'edit' }, { type: 'remove' }],
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            formPages: [
                {
                    label: '{{lang}}Product Type', key: 'type',
                    // changeConditions: [
                    //     {
                    //         nextPage: 'information',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "physical" } }
                    //                 }
                    //             },
                    //         },
                    //     },
                    //     {
                    //         nextPage: 'membership',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "membership" } }
                    //                 }
                    //             },
                    //         },
                    //     },
                    //     {
                    //         nextPage: 'service',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "service" } }
                    //                 }
                    //             },
                    //         },
                    //     },
                    //     {
                    //         nextPage: 'digital',
                    //         conditions: {
                    //             root: {
                    //                 id: 'root',
                    //                 action: 'and',
                    //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "digital" } }
                    //                 }
                    //             },
                    //         },
                    //     }
                    // ]
                },
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-main', information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-media', information: { label: '{{lang}}Images and Videos', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-price', information: { label: '{{lang}}Pricing' } },
                        { key: 'sec-inventory', information: { label: '{{lang}}Inventory' } },

                        { key: 'sec-delivery-financial', information: { label: '{{lang}}Delivery & Financial' } },


                        { key: 'sec-additional', information: { label: '{{lang}}Additional', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-extra', information: { label: '{{lang}}Extra Information' } },
                        { key: 'sec-selling', information: { label: '{{lang}}Selling Tools' } },

                        { key: 'sec-custom', information: { label: '{{lang}}Custom Fields' } },

                    ]
                },
                // { label: '{{lang}}Membership', key: 'membership', isLastPage: true }
            ],


            headers: [

                { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },

                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Type', backgroundColor: '#f8f8f8', border: '1px solid #eee', col: 4, imageOnSide: false, type: 'local', inputClass: 'fake', items: [
                            { value: 'physical', title: '{{lang}}Physical', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/price-tag.png' },
                            { value: 'service', title: '{{lang}}Service', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/useful/bot.png' },
                            { value: 'digital', title: '{{lang}}Digital download', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/useful/stack1.png' },
                            { value: 'membership', title: '{{lang}}Membership', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/useful/key.png' }],

                        placeholder: '{{lang}}Select', required: true
                    }, showMain: false
                },

                // { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', maxWidth: '50%', pages: ['information'], information: { label: '{{lang}}Name', autoFocus: true, placeholder: '{{lang}}Insert product name', required: true } },
                // { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Short description', rows: 4, showToolbar: true, placeholder: '{{lang}}Write a short description about this product / service.\nIf you need to add more information, you can use the additionals section.', required: false, style: { minHeight: 100, } }, showMain: false },

                // { key: 'additional', type: 'SubFormInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', showToolbar: true, placeholder: '{{lang}}description', required: false, style: { minHeight: 100, } }, showMain: false },




                { key: 'category', type: 'MultiLevelSelect', col: '6', section: 'sec-main', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Category', address: 'getProductsCategories', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}category', required: false } },

                {
                    key: 'unit', type: 'SelectInput', col: '6', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Unit', type: 'local', items: [{ value: 'piece', title: 'piece' }, { value: 'box', title: 'box' }, { value: 'kg', title: 'kg' }, { value: 'cm', title: 'cm' }], placeholder: '{{lang}}Select', required: false },
                    dependencies: [{
                        refKey: 'type',
                        targetKey: 'unit',
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'physical' } }
                                }
                            },
                        },
                        show: true,
                        init: true,
                        // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                    }],
                    showMain: false
                },



                // { key: 'sec-media', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Images and Videos', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },

                { type: 'ImageInput', key: 'media', col: '12', section: 'sec-media', pages: ['information'], information: { label: 'Media', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },

                // { key: 'productsCode', type: 'TextInput', col: '6',page:'informaton', information: { label: '{{lang}}Products Code', placeholder: '{{lang}}productsCode', required: false } },




                // { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

                //   {
                //     type: 'SelectInput', key: 'priceType', col: '6', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Pricing type', type: 'local', items: [{ value: 'fixed', title: 'Fixed amount' }, { value: 'subscription', title: 'Subscription' }, { value: 'free', title: 'Free' }, { value: 'config', title: 'Based on config' }, { value: 'contact', title: 'Contact' }], isSearchable: true, placeholder: '{{lang}}type', required: true },
                //     dependencies: [{
                //       refKey: 'type', targetKey: 'priceType',
                //       conditions: [{
                //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                //         effect: { show: true }
                //       }],
                //       else: { show: false },
                //       init: true,

                //     }],
                //     showMain: false
                //   },
                {
                    type: 'SelectInput', key: 'duration', col: '6', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Duration', type: 'local', items: [{ value: 'year', title: 'Annual' }, { value: 'month', title: 'monthly' }, { value: 'week', title: 'weekly' }], isSearchable: true, placeholder: '{{lang}}type', required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'duration',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },




                // {
                //   type: 'SubformInput',
                //   key: 'subscriptionPrice',
                //   col: '12',
                //   section: 'sec-price',

                //   // tab: 'specifications',
                //   pages: ['information'],
                //   information: {
                //     label: '{{lang}}Pricing options',
                //     help: '{{lang}}You can create different prices for different subscription durations.',
                //     // formType: 'modal',
                //     headers: [
                //       { key: 'price', type: 'PriceInput', col: '4', information: { label: '{{lang}}Price', autoFocus: true, placeholder: '{{lang}}0', required: true }, showMain: true },

                //       {
                //         key: 'repeat', type: 'componentSwitcher', col: '4',
                //         information: {
                //           label: '{{lang}}Repeats every', required: true,
                //         },
                //         states: [

                //           {
                //             conditions: [{
                //               root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.duration' }, operator: { value: '==' }, target: { value: 'week' } } }, },
                //               effect: { show: false }
                //             }],

                //             header: { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }, { value: 2, title: '2' }, { value: 3, title: '3' }, { value: 4, title: '4' }, { value: 5, title: '5' }, { value: 6, title: '6' }, { value: 7, title: '7' }, { value: 8, title: '8' }, { value: 9, title: '9' }, { value: 10, title: '10' }, { value: 11, title: '11' }, { value: 12, title: '12' }], isSearchable: true, placeholder: '{{lang}}Type', required: true, disabled: true }, showMain: true, disabled: true },

                //           },

                //           {
                //             conditions: [{
                //               root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.duration' }, operator: { value: '==' }, target: { value: "month" } } }, },
                //               effect: { show: false }
                //             }],

                //             header: { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }, { value: 2, title: '2' }, { value: 3, title: '3' }, { value: 4, title: '4' }, { value: 5, title: '5' }, { value: 6, title: '6' }, { value: 7, title: '7' }, { value: 8, title: '8' }, { value: 9, title: '9' }, { value: 10, title: '10' }, { value: 11, title: '11' }, { value: 12, title: '12' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },


                //           },

                //           {
                //             conditions: [{
                //               root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.duration' }, operator: { value: '==' }, target: { value: 'year' } } }, },
                //               effect: { show: false }
                //             }],

                //             header: { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }], isSearchable: true, placeholder: '{{lang}}Type', required: true, disabled: true }, showMain: true, disabled: true },
                //           },


                //         ]
                //         , showMain: true
                //       },
                //       // { key: 'repeat', type: 'SelectInput', col: '4', information: { label: '{{lang}}Repeats every', type: 'local', default: 1, items: [{ value: 1, title: '1' }, { value: 2, title: '2' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },
                //       { key: 'duration', type: 'SelectInput', col: '4', information: { label: '{{lang}}Duration', type: 'local', default: 'month', items: [{ value: 'week', title: '{{lang}}Week(s)' }, { value: 'month', title: '{{lang}}Month(s)' }, { value: 'year', title: '{{lang}}Year' }], isSearchable: false, placeholder: '{{lang}}Duration', required: true }, showMain: true },
                //     ],
                //     placeholder: '{{lang}}specifications',
                //     required: false,
                //   },
                //   dependencies: [{
                //     refKey: ['type', 'priceType'], targetKey: 'subscriptionPrice',
                //     conditions: [{
                //       root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } }, 2: { id: 2, source: { value: '@data.priceType' }, operator: { value: '==' }, target: { value: 'subscription' } } }, },
                //       effect: { show: true }
                //     }],
                //     else: { show: false },
                //     init: true,

                //   }],
                //   showMain: false

                // },



                {
                    key: 'price', type: 'PriceInput', col: '12', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Selling Price', withDiscount: true, placeholder: '{{lang}}Selling Price', required: false },
                    // dependencies: [{
                    //   refKey: 'type', targetKey: 'price',
                    //   conditions: [{
                    //     root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                    //     effect: { show: true }
                    //   }],
                    //   else: { show: false },
                    //   init: true,

                    // }],
                },

                {
                    key: 'hasCountryPrice', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Has Country Price', required: false, default: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'priceType',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: true
                },
                {
                    type: 'SubformInput',
                    key: 'subscriptionPrice',
                    col: '12',
                    section: 'sec-price',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Pricing options',
                        help: '{{lang}}You can create different prices for different countries.',
                        // formType: 'modal',
                        headers: [
                            { key: 'price', type: 'PriceInput', col: '4', information: { label: '{{lang}}Price', autoFocus: true, placeholder: '{{lang}}0', required: true }, showMain: true },
                            { key: 'regions', type: 'RegionsInput', col: '4', information: { isSearchable: true, label: '{{lang}}Regions', address: 'getCountries', filter: {}, fields: { title: 'name', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: '', help: "", placeholder: '{{lang}}International', required: false }, showMain: true },
                            { key: 'currency', type: 'RegionsInput', col: '4', information: { isSearchable: true, label: '{{lang}}Currency', address: 'getCountries', filter: {}, fields: { title: 'currency', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: '', help: "", placeholder: '{{lang}}International', required: false }, showMain: true },


                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: ['hasCountryPrice'], targetKey: 'subscriptionPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.hasCountryPrice' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false

                },


                {
                    key: 'inventory.cost', type: 'PriceInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Cost of good', leftIndicator: '{{currency}}', placeholder: '0', required: false, help: 'The amount you’re spending to produce and sell this product. Your customers won’t see this.' },
                    dependencies: [{
                        refKey: 'type', targetKey: 'inventory.cost',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                {
                    key: 'profit', type: 'FormulaInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Profit', formula: '{{price.final}} - {{inventory.cost}}', placeholder: '{{lang}}Profit', help: 'The price of the product minus your cost of goods.', required: false, disabled: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'profit',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                {
                    key: 'margin', type: 'FormulaInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Margin', rightIndicator: '%', minusInfinity: -100, formula: '(({{price.final}} - {{inventory.cost}}) / {{price.final}}) * 100', placeholder: '{{lang}}Margin', help: 'The percentage of the price that’s left after deducting your cost of goods.', required: false, disabled: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'margin',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },







                {
                    key: 'isPhysical', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Item is physical', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'isPhysical',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                {
                    type: 'MultiSelectInput', key: 'fulfillments', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Available Fulfillments', address: 'getDeliveryTypes', groupBy: [{ key: 'type', options: [{ key: '*', label: '{{lang}}Fulfillments' }, { key: 'group', label: '{{lang}}Groups' }] }], fields: { title: 'name', value: '_id', type: 'type' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default option', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'fulfillments',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                { type: 'MultiSelectInput', key: 'taxes', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Taxes', address: 'getTaxes', groupBy: [{ key: 'type', options: [{ key: 'single', label: '{{lang}}Single rate' }, { key: 'group', label: '{{lang}}Taxes group' }] }], fields: { title: 'name', value: '_id', type: 'type' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default tax', required: false }, showMain: false },

                { type: 'SelectInput', key: 'salesAccount', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Sales account', address: 'getAccounts', groupBy: [{ key: 'type', options: [{ key: 'income', label: '{{lang}}Income' }, { key: 'expense', label: '{{lang}}Expense' }] }], fields: { title: 'name', value: '_id', type: 'type', }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default sales account', required: false }, showMain: false },

                {
                    type: 'SelectInput', key: 'purchasesAccount', col: '6', pages: ['information'], section: 'sec-delivery-financial', information: { label: '{{lang}}Purchase account', address: 'getAccounts', groupBy: [{ key: 'type', options: [{ key: 'income', label: '{{lang}}Income' }, { key: 'expense', label: '{{lang}}Expense' }] }], fields: { title: 'name', value: '_id', type: 'type', }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default purchases account', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'purchasesAccount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                // {
                //     key: 'priceSttings.discount.value', type: 'PriceInput', col: '6', pages: ['information'], section: 'sec-price',
                //     information: {
                //         label: '{{lang}}Discount', help: 'Discount based on percentage or amount', placeholder: '{{lang}}Discount', required: false,
                //         unit: { key: 'priceSttings.discount.type', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}Select', required: true }, showMain: true }

                //     },
                //     showMain: true
                // },

                // {
                //     key: 'priceSttings.discount', type: 'CombinedInput', col: '6', pages: ['information'], section: 'sec-price',
                //     information: {
                //         label: '{{lang}}Discount', headers: [
                //             { key: 'priceSttings.discount.value', type: 'PriceInput', col: '9', information: { label: '{{lang}}Discount', hint: 'Discount based on percentage or cash', placeholder: '{{lang}}Discount', required: false } },
                //             { key: 'priceSttings.discount.type', type: 'SelectInput', col: '3', information: { label: '{{lang}}type', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}Select', required: false }, showMain: true },
                //         ], showMain: true
                //     }
                // },





                // { key: 'sec-selling', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Selling Tools' } },







                // { key: 'priceSttings.discount.type', type: 'SelectInput', col: '6', pages: ['information'], information: { label: '{{lang}}type', type: 'local', items: [{ value: 'percent', title: 'percentage' }, { value: 'cash', title: 'cash' }], placeholder: '{{lang}}Select', required: false }, showMain: true },

                // { key: 'priceSttings.discount.value', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Discount', hint: 'Discount based on percentage or cash', placeholder: '{{lang}}Discount', required: false } },

                // { key: 'priceSttings.currency', type: 'SelectInput', col: '6',page:'informaton', information: { label: '{{lang}}Choose currency', type: 'local', items: [{ value: 'USD', title: 'USD' }, { value: 'IRR', title: 'IRR' }], placeholder: '{{lang}}Select', required: false }, showMain: false },
                // { type: 'SelectInput', key: 'status', col: '6',page:'informaton', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: false }, showMain: true },
                // { key: 'sec-inventory', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Inventory' }, showMain: false },

                {
                    key: 'inventory.dimensions', type: 'DimensionsInput', col: '6', pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Dimensions', placeholder: 'Insert ...', required: false, disabled: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'inventory.dimensions',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: true
                },


                {
                    key: 'includesVariants', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Includes variants', placeholder: '{{lang}}Includes variants', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'includesVariants',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

              

                {
                    key: 'available', type: 'SwitchInput', col: "4", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false },
                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'available',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: true
                },


                {
                    key: 'track', type: 'SwitchInput', col: "4", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Unlimited stock', placeholder: '{{lang}}Unlimited stock', default: true, required: false },
                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'track',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: true
                },


                {
                    type: 'SubformInput',
                    key: 'variants',
                    col: '12',
                    // tab: 'specifications',
                    pages: ['information'],
                    section: 'sec-inventory',
                    information: {
                        editInModal: true,
                        defaultRow: true,
                        label: '{{lang}}Variants List',
                        help: 'Product variants allow you to list different versions of the same product, like clothes in different colors or sizes.',

                        headers: [
                            { key: 'name', type: 'TextInput', col: '4', information: { label: '{{lang}}Name', autoFocus: true, updateAfterSelect: true, isSearchable: true, placeholder: '{{lang}}e.g., Size, Color', required: true }, showMain: true },
                            { key: 'options', type: 'TagInput', col: '8', information: { label: '{{lang}}Options', placeholder: '{{lang}}Seperate choises with commas e.g., Small, Medium', required: true }, showMain: true },
                            // { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },

                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'variants',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '!=' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false

                },





                {
                    type: 'VariantsInventory',
                    key: 'inventory.variants',
                    col: '12',
                    // tab: 'specifications',
                    pages: ['information'],
                    section: 'sec-inventory',
                    information: {
                        variantsKey: 'variants',
                        editInModal: true,
                        addDisabled: true,
                        removeDisabled: true,
                        label: '{{lang}}Manage Variants',
                        help: 'Product variants allow you to list different versions of the same product, like clothes in different colors or sizes.',

                        headers: [
                            { key: 'name', type: 'TextInput', col: '4', information: { label: '{{lang}}Name', updateAfterSelect: true, isSearchable: true, placeholder: '{{lang}}e.g., Size, Color', required: true }, showMain: false },
                            { key: 'options', type: 'TagInput', col: '8', information: { label: '{{lang}}Options', placeholder: '{{lang}}Seperate choises with commas e.g., Small, Medium', required: true }, showMain: true },
                            // { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },

                    dependencies: [{
                        refKey: 'includesVariants', targetKey: 'inventory.variants',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '!=' }, target: { value: true } } }, },
                            effect: { show: false }
                        }],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false

                },







                {
                    key: 'SKU', type: 'TextInput', col: '12', maxWidth: '50%', section: 'sec-inventory', pages: ['information'], information: {
                        label: '{{lang}}SKU', hint: 'Stock keeping unit', placeholder: '{{lang}}SKU',


                        required: false
                    },
                    // dependencies: [{
                    //     refKey: 'type',
                    //     targetKey: 'SKU',
                    //     conditions: {
                    //         root: {
                    //             id: 'root',
                    //             action: 'and',
                    //             conditions: {
                    //                 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'physical' } }
                    //             }
                    //         },
                    //     },
                    //     show: true,
                    //     init: true,
                    // }],

                    // dependencies: [{
                    //     refKey: 'type', targetKey: 'SKU',
                    //     conditions: [{
                    //         root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                    //         effect: { show: true }
                    //     }],
                    //     else: { show: false },
                    //     init: true,

                    // }],

                    dependencies: [{
                        refKey: ['includesVariants', 'type'], targetKey: 'SKU',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.includesVariants' }, operator: { value: '==' }, target: { value: true } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: false }
                        },],
                        else: { show: true },
                        init: true,

                    }],
                    showMain: false
                },



                // { key: 'cprice', type: 'PriceInput', col: '4', pages: ['information'], section: 'sec-price', information: { label: '{{lang}}Opening stock value', leftIndicator: '{{currency}}', placeholder: '{{lang}}Opening stock value', required: false, help: 'The amount you’re spending to produce and sell this product. Your customers won’t see this.' }, showMain: false },






                // { key: 'inventory.allWarehousesAvailable', type: 'SwitchInput', col: "12", pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}All Warehouses Available', placeholder: '{{lang}}allWarehousesAvailable', default: true, required: false }, showMain: true },
                // { type: 'MultiSelectInput', key: 'inventory', section: 'sec-main', col: '6', pages: ['information'], information: { label: '{{lang}}Special', type: 'localSelect', fields: { title: 'warehouseName', value: 'warehouse' }, isSearchable: true, placeholder: '{{lang}}Special', required: false },
                // dependencies: [{
                //     refKey: 'allWarehousesAvailable',
                //     targetKey: 'availableWarehouses',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'and',
                //             conditions: {
                //                 1: { id: 1, source: { value: '@data.allWarehousesAvailable' }, operator: { value: '==' }, target: { value: false } }
                //             }
                //         },
                //     },
                //     show: true,
                //     init: true,
                // }], showMain: true },

                // { key: 'changeProductStatusWhenOrderd', type: 'SwitchInput', col: "6",page:'informaton', information: { label: '{{lang}}Change Product Status When Ordered', placeholder: '{{lang}}changeProductStatusWhenOrdered', default: true, required: false }, showMain: true },
                // { key: 'maxOrderCount', type: 'NumberInput', col: '6', pages: ['information'], section: 'sec-inventory', information: { label: '{{lang}}Max Order Count', placeholder: '{{lang}}maxOrderCount', required: false }, showMain: true },
                // {
                //     type: 'ExtraSettingsInput',
                //     key: 'inventory',
                //     col: '12',
                //     pages: ['information'], section: 'sec-inventory', information: {
                //         // label: '{{lang}}inventory',
                //         headers: [
                //             { col: '4', type: 'TextInput', key: 'warehouseName', information: { label: '{{lang}}warehouse', updateAfterSelect: true, isSearchable: true, address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}warehouse', required: false }, showMain: false },
                //             { col: '4', type: 'SelectInput', key: 'warehouse', information: { label: '{{lang}}warehouse', updateAfterSelect: true, isSearchable: true, address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}warehouse', required: false }, showMain: false },
                //             {
                //                 key: 'defaultWarehouse', type: 'SwitchInput', col: '12', information: { label: '{{lang}}defaultWarehouse', placeholder: '{{lang}}defaultWarehouse', default: false, required: false },
                //                 dependencies: [{
                //                     refKey: 'inventory.allWarehousesAvailable',
                //                     targetKey: 'inventory.defaultWarehouse',
                //                     conditions: {
                //                         root: {
                //                             id: 'root',
                //                             action: 'and',
                //                             conditions: {
                //                                 1: { id: 1, source: { value: '@data.allWarehousesAvailable' }, operator: { value: '==' }, target: { value: false } }
                //                             }
                //                         },
                //                     },
                //                     show: true,
                //                     init: true,
                //                 }],
                //                 showMain: false
                //             },
                //             // { key: 'priority', type: 'NumberInput', col: "6", information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false }, showMain: false },
                //             { key: 'count', type: 'NumberInput', col: "6", information: { label: '{{lang}}stock', placeholder: '{{lang}}stock', required: false }, showMain: true },
                //             // { key: 'capacity', type: 'NumberInput', col: "6", information: { label: '{{lang}}capacity', placeholder: '{{lang}}capacity', required: false }, showMain: false },
                //             // { key: 'orderPoint', type: 'NumberInput', col: "6", information: { label: '{{lang}}Opening Stock Value', placeholder: '{{lang}}orderPoint', required: false }, showMain: false },
                //             // { type: 'MultiSelectInput', key: 'tags', col: '6', information: { label: '{{lang}}tags', address: 'getMyCommerceTags', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}tags', required: false }, showMain: false },
                //             // {
                //             //     type: 'SubformInput',
                //             //     key: 'count',
                //             //     col: '12',
                //             //     information: {
                //             //         label: '{{lang}}productStatusAndCount',
                //             //         headers: [
                //             //             { type: 'SelectInput', key: 'status', col: '4', information: { label: '{{lang}}Status', type: 'local', items: [{ value: 'stock', title: 'stock' }, { value: 'orderd', title: 'orderd' }, { value: 'sold', title: 'sold' }], isSearchable: true, placeholder: '{{lang}}status', required: false }, showMain: true },
                //             //             { key: 'count', type: 'NumberInput', col: "4", information: { label: '{{lang}}count', placeholder: '{{lang}}count', required: false }, showMain: false },
                //             //             { key: 'availableForsale', type: 'SwitchInput', col: "4", information: { label: '{{lang}}available for sale', placeholder: '{{lang}}available for sale', default: false, required: false }, showMain: false },

                //             //         ],
                //             //         placeholder: '{{lang}}specifications',
                //             //         required: false,
                //             //     },
                //             //     showMain: false

                //             // },

                //         ],
                //         placeholder: '{{lang}}specifications',
                //         title: '{{lang}}Inventory',
                //         required: false,
                //     },
                //     showMain: false

                // },
                // {
                //     type: 'SubformInput',
                //     key: 'inventory',
                //     col: '12',
                //     information: {
                //         label: '{{lang}}inventory',
                //         headers: [
                //             { col: '8', type: 'SelectInput', key: 'warehouse', information: { label: '{{lang}}warehouse', updateAfterSelect: true, isSearchable: true, address: 'getMyWarehoses', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}warehouse', required: false }, showMain: false },
                //             { key: 'defaultWarehouse', type: 'SwitchInput', col: '4',information: { label: '{{lang}}defaultWarehouse', placeholder: '{{lang}}defaultWarehouse', default: false, required: false }, showMain: false },
                //             { key: 'priority', type: 'NumberInput', col: "4", information: { label: '{{lang}}priority', placeholder: '{{lang}}priority', required: false }, showMain: false },
                //             // {
                //             //     type: 'SubformInput',
                //             //     key: 'count',
                //             //     col: '12',
                //             //     information: {
                //             //         label: '{{lang}}productStatusAndCount',
                //             //         headers: [
                //             //             { type: 'SelectInput', key: 'status', col: '4', information: { label: '{{lang}}Status', type: 'local', items: [{ value: 'stuck', title: 'stuck' }, { value: 'orderd', title: 'orderd' }, { value: 'sold', title: 'sold' }], isSearchable: true, placeholder: '{{lang}}status', required: false }, showMain: true },
                //             //             { key: 'count', type: 'NumberInput', col: "4", information: { label: '{{lang}}orderPoint', placeholder: '{{lang}}orderPoint', required: false }, showMain: false },
                //             //             { key: 'availableForsale', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                //             //         ],
                //             //         placeholder: '{{lang}}specifications',
                //             //         required: false,
                //             //     },
                //             //     showMain: false

                //             // },
                //             { key: 'capacity', type: 'NumberInput', col: "4", information: { label: '{{lang}}capacity', placeholder: '{{lang}}capacity', required: false }, showMain: false },
                //             { key: 'orderPoint', type: 'NumberInput', col: "4", information: { label: '{{lang}}orderPoint', placeholder: '{{lang}}orderPoint', required: false }, showMain: false },
                //             { type: 'MultiSelectInput', key: 'tags', col: '6', information: { label: '{{lang}}categories', address: 'getMyCommerceTags', fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },

                //         ],
                //         placeholder: '{{lang}}specifications',
                //         required: false,
                //     },
                //     showMain: false

                // },

                { type: 'MultiSelectInput', key: 'label', section: 'sec-selling', col: '6', pages: ['information'], information: { label: '{{lang}}Item label', type: 'local', items: [{ value: 'Trending', title: '{{lang}}Trending' }, { value: 'Featured', title: '{{lang}}Featured' }, { value: 'New', title: '{{lang}}New' }], isSearchable: true, placeholder: '{{lang}}Label', help: 'Labels help you to specialize your products and services so you can filter them easier when you want to show them to the users', required: false }, showMain: true },






                // { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },

                {
                    type: 'SubformInput',
                    key: 'additionals',
                    col: '12',
                    section: 'sec-additional',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Additoinal options',
                        help: '{{lang}}Additional option helps customization of  product / service. The price can also be customizaed based on these customizations',
                        // formType: 'modal',
                        modalMode: true,
                        headers: [
                            { key: 'title', type: 'TextInput', col: '4', information: { label: '{{lang}}Title', autoFocus: true, placeholder: '{{lang}}e.g. Topping, Style, ...', required: true }, showMain: true },

                            { key: 'type', type: 'SelectInput', col: '4', information: { label: '{{lang}}Type', type: 'local', default: 'multiSelect', items: [{ value: 'multiSelect', title: 'Multi select' }, { value: 'singleSelect', title: 'Single select' }, { value: 'text', title: 'Text' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },

                            {
                                key: 'max', type: 'NumberInput', col: '2', information: { label: '{{lang}}Max allowed options', placeholder: '{{lang}}Unlimited', required: false },
                                dependencies: [{
                                    refKey: 'type', targetKey: 'max',
                                    conditions: [{
                                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multiSelect' } } }, },
                                        effect: { show: true }
                                    }],
                                    else: { show: false },
                                    init: true,

                                }],
                                showMain: false
                            },


                            {
                                key: 'options',
                                type: 'SubformInput',
                                col: '4',
                                information: {
                                    label: '{{lang}}Options',
                                    formType: 'modal',
                                    headers: [
                                        { key: 'label', type: 'TextInput', col: '4', information: { label: '{{lang}}Label', placeholder: '{{lang}}e.g., Material, display, ...', required: true }, showMain: true },
                                        { key: 'priceDifference', type: 'PriceInput', col: '8', information: { label: '{{lang}}Price difference', placeholder: '{{lang}}Value ...', required: true }, showMain: true },
                                    ],
                                    placeholder: '{{lang}}specifications',
                                    required: false,
                                },
                                dependencies: [{
                                    refKey: 'type', targetKey: 'options',
                                    conditions: [{
                                        root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multiSelect' } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'singleSelect' } } }, },
                                        effect: { show: true }
                                    }],
                                    else: { show: false },
                                    init: true,

                                }],
                                showMain: false

                            },



                            {
                                key: 'options-switcher', type: 'componentSwitcher', col: '4',
                                information: { label: '{{lang}}Options' },
                                states: [
                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'text' } } }, },
                                            effect: { show: false }
                                        }],
                                        // header: { key: 'body', type: 'TextEditorInput', col: '4', information: { label: '{{lang}}body', placeholder: '{{lang}}Description', showToolbar: true, required: false }, showMain: true },
                                    },

                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "text" } } }, },
                                            effect: { show: false }
                                        }],
                                        header: {
                                            key: 'options',
                                            type: 'SubformInput',
                                            col: '4',
                                            information: {
                                                // label: '{{lang}}Information sections',
                                                formType: 'modal',
                                                headers: [
                                                    { key: 'label', type: 'TextInput', col: '4', information: { label: '{{lang}}Label', placeholder: '{{lang}}e.g., Material, display, ...', required: true }, showMain: true },
                                                    { key: 'priceDifference', type: 'PriceInput', col: '8', information: { label: '{{lang}}Price difference', placeholder: '{{lang}}Value ...', required: true }, showMain: true },
                                                ],
                                                showCondition: '',
                                                placeholder: '{{lang}}specifications',
                                                required: false,
                                            },
                                            hideInHeader: true,
                                            showMain: true

                                        },

                                    }
                                ]
                                , showMain: true
                            },





                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: ['type'], targetKey: 'additionals',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        },],
                        else: { show: false },
                        init: true,
                    }],
                    showMain: false

                },




                {
                    type: 'SubformInput',
                    key: 'benefits',
                    col: '12',
                    section: 'sec-extra',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Benefits',
                        // help: 'Specifications and extra information about your product / service using this field. These will appeared add seperate sections on the product page.',
                        // formType: 'modal',
                        headers: [
                            { key: 'title', type: 'TextInput', col: '5', information: { label: '{{lang}}Title', autoFocus: true, placeholder: '{{lang}}e.g. Product Info, Policies, ...', required: true }, showMain: true },
                            { type: 'SelectInput', key: 'type', col: '3', information: { label: '{{lang}}Type', type: 'local', default: 'included', items: [{ value: 'included', title: '{{lang}}Included' }, { value: 'excluded', title: '{{lang}}Excluded' }], placeholder: '{{lang}}Type', required: true }, showMain: true },
                            { key: 'description', type: 'TextEditorInput', col: '4', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', showToolbar: true, required: false }, showMain: true },



                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: ['type'], targetKey: 'benefits',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        },],
                        else: { show: false },
                        init: true,
                    }],
                    showMain: false

                },





                {
                    type: 'SubformInput',
                    key: 'sections',
                    col: '12',
                    section: 'sec-extra',

                    // tab: 'specifications',
                    pages: ['information'],
                    information: {
                        label: '{{lang}}Sections ( Sepecifications and information )',
                        help: 'Specifications and extra information about your product / service using this field. These will appeared add seperate sections on the product page.',
                        // formType: 'modal',
                        headers: [
                            { key: 'title', type: 'TextInput', col: '4', information: { label: '{{lang}}Title', autoFocus: true, placeholder: '{{lang}}e.g. Product Info, Policies, ...', required: true }, showMain: true },
                            { type: 'SelectInput', key: 'type', col: '4', information: { label: '{{lang}}Type', type: 'local', default: 'editor', items: [{ value: 'editor', title: 'Editor' }, { value: 'specifications', title: 'Specifications' }], isSearchable: true, placeholder: '{{lang}}Type', required: true }, showMain: true },

                            {
                                key: 'body', type: 'componentSwitcher', col: '4',
                                information: { label: '{{lang}}Body' },
                                states: [
                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'editor' } } }, },
                                            effect: { show: false }
                                        }],
                                        header: { key: 'body', type: 'TextEditorInput', col: '4', information: { label: '{{lang}}body', placeholder: '{{lang}}Description', showToolbar: true, required: false }, showMain: true },
                                    },

                                    {
                                        conditions: [{
                                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "specifications" } } }, },
                                            effect: { show: false }
                                        }],
                                        header: {
                                            type: 'SubformInput',
                                            key: 'list',
                                            col: '4',
                                            information: {
                                                label: '{{lang}}Information sections',
                                                formType: 'modal',
                                                headers: [
                                                    { key: 'label', type: 'TextInput', col: '4', information: { label: '{{lang}}Label', placeholder: '{{lang}}e.g., Material, display, ...', required: true }, showMain: true },
                                                    { key: 'value', type: 'TextInput', col: '8', information: { label: '{{lang}}Value', placeholder: '{{lang}}Value ...', required: true }, showMain: true },

                                                ],
                                                showCondition: '',
                                                placeholder: '{{lang}}specifications',
                                                required: false,
                                            },
                                            hideInHeader: true,
                                            showMain: true

                                        },

                                    }
                                ]
                                , showMain: true
                            },





                        ],
                        placeholder: '{{lang}}specifications',
                        required: false,
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'sections',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        },],
                        else: { show: false },
                        init: true,
                    }],
                    showMain: false

                },




                {
                    key: 'brand', type: 'SelectInput', col: '6', section: 'sec-extra', pages: ['information'], information: { label: '{{lang}}Brand', address: 'getProductsBrands', filter: { appletHub: '{{appletHub}}', applet: '{{appletId}}' }, fields: { title: 'name', image: 'image', value: '_id' }, type: 'api', placeholder: '{{lang}}Brand', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'brand',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: 'membership' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },





                // {
                //     type: 'SubformInput',
                //     key: 'specificationsList',
                //     col: '12',
                //     // tab: 'specifications',
                //     pages: ['information'],
                //     section: 'sec-additional', 
                //     information: {
                //         // label: '{{lang}}Specifications',
                //         headers: [
                //             { col: '4', type: 'TextInput', key: 'key', information: { label: '{{lang}}Specification', updateAfterSelect: true, isSearchable: true, address: 'getFilteredSpecifications', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Specification', required: false }, showMain: false },
                //             { key: 'value', type: 'TextInput', col: '4', information: { label: '{{lang}}value', placeholder: '{{lang}}vlaue', required: false }, showMain: true },
                //             { key: 'featured', type: 'SwitchInput', col: "4", information: { label: '{{lang}}featured', placeholder: '{{lang}}featured', default: false, required: false }, showMain: false },

                //         ],
                //         placeholder: '{{lang}}specifications',
                //         required: false,
                //     },
                //     showMain: false

                // },



                { key: '*extra.dimensions', type: 'TextInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}Dimensions (cm)', hint: '(Length X Width X Height)', placeholder: '{{lang}}Dimensions', required: false }, showMain: false },
                { key: '*extra.weight', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}Weight (kg)', placeholder: '{{lang}}Weight', required: false }, showMain: false },
                { key: '*extra.MPN', type: 'TextInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}MPN', hint: 'Manufacturing Part Number', placeholder: '{{lang}}MPN', required: false }, showMain: false },
                { key: '*extra.UPC', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}UPC', hint: 'Universal product code', placeholder: '{{lang}}UPC', required: false }, showMain: false },
                { key: '*extra.ISBN', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}ISBN', hint: 'International standard book number', placeholder: '{{lang}}ISBN', required: false }, showMain: false },
                { key: '*extra.EAN', type: 'NumberInput', col: '6', tab: 'extra', pages: ['information'], information: { label: '{{lang}}EAN', hint: 'International article number', placeholder: '{{lang}}EAN', required: false }, showMain: false },






                //// MEMBERSHIP

                // { key: 'name', type: 'TextInput', col: '12', page: 'membership', information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
                // { key: 'cover', type: 'ImageInput', col: '12', page: 'membership', information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                // { type: 'ImageInput', key: 'images', col: '12', page: 'membership', information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                // { key: 'description', type: 'EditorInput', col: '12', page: 'membership', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


        orders: {
            key: 'orders',
            title: 'Orders',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getOrders',
            addUrl: 'postOrder',
            editUrl: 'postOrder',

            removeUrl: 'removeOrder',
            helperKey: 'values',
            pageType: 'collection',
            model: 'orders',
            section: 'main',
            parent: 'shop',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            //             tabs: [
            //     { title: 'Pending', filter: { "status": '0' } },
            //     { title: 'Finished', filter: { "status": '2' } },
            //     { title: 'Canceled', filter: { "status": '-1' } },
            // ],
            // addNew: -1,
            image: '/images/back1.jpg',
            // extra: { export: { url: 'usersExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
            headers: [

                { key: 'hub', type: 'AdvancedSelectInput', col: "12", information: { label: '{{lang}}Hub', address: 'searchHub', filter: {}, fields: { title: 'fullname', description: "username", image: 'image', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}user', required: true }, showMain: true },

                { type: 'TextInput', key: 'id', col: '6', information: { label: '{{lang}}id', placeholder: '{{lang}}Id', required: false, disabled: true }, showMain: true, hideComponent: true },

                {
                    type: 'InvoiceInput',
                    key: 'items',
                    information: {
                        inputClass: 'mt-2 p-0',
                        // label: '{{lang}}applets.accounting.items',
                        headers: [
                            { key: 'product', type: 'ProductSelectInput', col: '5', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'getProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', name: 'name', media: 'media', image: 'images', value: '_id', _id: '_id', price: 'price', type: 'type', priceType: 'priceType', subscriptionPrice: 'subscriptionPrice', inventory: 'inventory', variants: 'variants', includesVariants: "includesVariants", additionals: 'additionals', paymentType: 'paymentType', fulfillments: 'fulfillments', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: false },
                            { key: 'count', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: false } },
                            { key: 'amounts.base', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: false } },
                            { key: 'amounts.multiplayed', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false
                    },
                    required: false,

                    showMain: false
                },

                { type: 'AddressInput', key: 'address', col: "12", information: { label: '{{lang}}Delivery address', required: false }, hideComponent: false },


                { type: 'PriceInput', key: 'amounts.totals.final', col: "6", information: { label: '{{lang}}Total amount', placeholder: '{{lang}}anount', required: false }, hideComponent: true },

                // { type: 'PriceInput', key: 'amounts.fulfillments.final', col: '6', information: { label: '{{lang}}Delivery amount', placeholder: '{{lang}}Delivery Price', required: true } },
                // { type: 'PriceInput', key: 'totalPrice', col: '6', information: { label: '{{lang}}Total', placeholder: '{{lang}}Total', required: false, disabled: true } },
                // { type: 'PriceInput', key: 'extraDiscount', col: '6', information: { label: '{{lang}}Extra Discount', placeholder: '{{lang}}Extra Discount', required: true } },

                // { type: 'PhoneInput', key: 'phone', col: "6", information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: true }, showMain: false },
                // { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'active' }, { value: '-1', title: 'rejected' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },

                // { type: 'MultiSelectInput', key: 'lng', col: '12', information: { label: '{{lang}}Languages', type: 'local', items: [{ value: 'en', title: 'English' }, { value: 'fa', title: 'فارسی' }], isSearchable: true, placeholder: '{{lang}}Languages', required: true }, showMain: true },


                { type: 'SelectInput', key: 'status', col: '6', information: { label: '{{lang}}Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'Confirmed' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}status', required: true }, showMain: true },
                { type: 'SelectInput', key: 'paymentStatus', col: '6', information: { label: '{{lang}}Payment Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}Payment Status', required: true }, showMain: true },
                // { type: 'SelectInput', key: 'deliveryStatus', col: '6', information: { label: '{{lang}}Delivery Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '1', title: 'delivered' }], isSearchable: true, placeholder: '{{lang}}Delivery Status', required: true }, showMain: true },
                // { type: 'SelectInput', key: 'transactionStatus', col: '6', information: { label: '{{lang}}Transaction Status', type: 'local', items: [{ value: '0', title: 'pending' }, { value: '2', title: 'Finished' }, { value: '-1', title: 'Canceled' }], isSearchable: true, placeholder: '{{lang}}Transaction Status', required: true }, showMain: true },


                // { type: 'SectionInput', key: '*address', information: { label: '{{lang}}address' }, showMain: false },

                // { type: 'TextInput', key: 'address.province', col: '6', information: { label: '{{lang}}province / state', placeholder: '{{lang}}province / state', required: true }, showMain: false },
                // { type: 'TextInput', key: 'address.city', col: '6', information: { label: '{{lang}}city', placeholder: '{{lang}}city', required: true }, showMain: false },
                // { type: 'TextAreaInput', key: 'address.fullAddress', information: { label: '{{lang}}address', placeholder: '{{lang}}address', required: true }, showMain: false },
                // { type: 'MapLeafletInput', key: 'address.location', information: { label: '{{lang}}location', placeholder: '{{lang}}location', required: false, disabled: true }, showMain: false },

                // { type: 'SectionInput', key: '*recepient', information: { label: '{{lang}}recepient' }, showMain: false },

                // { key: 'addRecipient', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Add Recipient Info Manually', placeholder: '{{lang}}availableForAllProducts', default: false, required: false } },
                // {
                //     type: 'TextInput', key: 'recipient.name', col: '6', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false },
                //     dependencies: [{
                //         refKey: 'addRecipient',
                //         targetKey: 'recipient.name',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.addRecipient' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     type: 'TextInput', key: 'recipient.family', col: '6', information: { label: '{{lang}}family', placeholder: '{{lang}}family', required: false },
                //     dependencies: [{
                //         refKey: 'addRecipient',
                //         targetKey: 'recipient.family',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.addRecipient' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }], showMain: false
                // },

                // {
                //     type: 'PhoneInput', key: 'recipient.phone', col: '6', information: { label: '{{lang}}phone', placeholder: '{{lang}}phone', required: false },
                //     dependencies: [{
                //         refKey: 'addRecipient',
                //         targetKey: 'recipient.phone',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.addRecipient' }, operator: { value: '==' }, target: { value: true } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }], showMain: false
                // },
                // { type: 'TextInput', key: 'recepient.nationalId', col: '6', information: { label: '{{lang}}National Id', pattern: '[0-9]*', maxLength: 10, placeholder: '{{lang}}National Id', required: false }, showMain: false },


                { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false }, showMain: false },
                { key: 'remark', type: 'TextAreaInput', information: { label: '{{lang}}remark', placeholder: '{{lang}}remark', required: false }, showMain: false },
            ]
        },



        categories: {
            key: 'categories',
            title: '{{lang}}categories',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            pageType: 'collection',
            model: 'productCategory',
            section: 'main',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/emotional.png',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        deliveryConfig: {
            key: 'deliveryConfig',
            title: '{{lang}}Fulfillment & delivery',
            description: '{{lang}}The descriptions of this module would be shown here',
            fetchUrl: 'getDeliveryTypes',
            addUrl: 'postDeliveryType',
            editUrl: 'postDeliveryType',
            removeUrl: 'removeDeliveryType',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'fulfillments',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ads-manager.png',

            formPages: [
                {
                    label: '{{lang}}Product Type', key: 'type',

                },
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-thirdparty', information: { label: '{{lang}}Third party', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-config', information: { label: '{{lang}}Configuration', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-limitations', information: { label: '{{lang}}Limitations (Optional)', fontSize: 16, color: '#000', fontWeight: '600' } },

                        // { key: 'sec-price', information: { label: '{{lang}}Pricing' } },
                        // { key: 'sec-inventory', information: { label: '{{lang}}Inventory' } },

                        // { key: 'sec-additional', information: { label: '{{lang}}Additional', fontSize: 16, color: '#000', fontWeight: '600' } },
                        // { key: 'sec-extra', information: { label: '{{lang}}Extra Information' } },
                        // { key: 'sec-selling', information: { label: '{{lang}}Selling Tools' } },

                        // { key: 'sec-custom', information: { label: '{{lang}}Custom Fields' } },

                    ]
                }],

            headers: [


                // { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the delivey type. Each type has its settings and configurations', fontSize: 16, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },

                {
                    key: 'type', type: 'ImageSelectInput', pages: ['type'], col: '12', information: {
                        label: '{{lang}}Delivery type', backgroundColor: '#fff', border: '1px solid #eee', col: 4, imageOnSide: false, type: 'local', inputClass: 'fake', items: [

                            { value: 'group', title: '{{lang}}Group', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/delivery.png' },

                            { value: 'pickup', title: '{{lang}}Pickup', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/delivery.png' },
                            { value: 'flatRate', title: '{{lang}}Flat rate', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/price-tag.png' },
                            { value: 'rateByWeight', title: '{{lang}}Rate by weight', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/weight.png' },
                            { value: 'schedule', title: '{{lang}}Schedule delivery', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/icons/time-chart.svg' },

                            { value: 'UPS', title: '{{lang}}UPS', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/ups.svg' },
                            { value: 'USPS', title: '{{lang}}USPS', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/usps.svg' },

                            { value: 'EasyPost', title: '{{lang}}EasyPost', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/easypost.svg' },

                            { value: 'Fedex', title: '{{lang}}FedEx', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/fedex.svg' },
                            { value: 'DHL', title: '{{lang}}DHL', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Adipisci mollitia alias sequi debitis eaque qui beatae.', image: '/assets/thirdparties/dhl.svg' },

                        ],


                        placeholder: '{{lang}}Select', required: true
                    }, showMain: true
                },


                {
                    key: 'thirdparty', type: 'ThirdPartyInput', col: '12', section: 'sec-thirdparty', pages: ['information'], information: { label: '{{lang}}Connect', refKey: "type", required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'thirdparty',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "pickup" } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "flatRate" } }, 3: { id: 3, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "rateByWeight" } }, 4: { id: 4, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "schedule" } }, 5: { id: 5, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                // { key: 'regions', type: 'RegionsInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Regions', placeholder: '{{lang}}International',hint:'If you do not want to have any limitations, you can leave this field empty.', required: false } },
                {
                    key: 'regions', type: 'RegionsInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Regions', address: 'getCountries', filter: {}, fields: { title: 'name', image: 'emoji', value: '_id', country: '_id' }, type: 'api', root: '', hint: 'If you do not want to have any limitations, you can leave this field empty.', help: "{{lang}}You can limit the delivery address for customers in specific regions. You can leave this empty for no limitation.", placeholder: '{{lang}}International', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'regions',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },

                { key: 'name', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Name', placeholder: '{{lang}}e.g., Standard shipping, Free delivery', help: 'This will be visible to customers in their cart and at checkout process.', required: true } },


                {
                    type: 'SubformInput', key: 'list', col: '12', pages: ['information'], section: 'sec-config',
                    information: {
                        editInModal: true, defaultRow: true, label: '{{lang}}Fulfillments list',

                        // TO DO: Don't fetch the current delivery if is editing
                        headers: [
                            { key: 'fulfillment', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}Name', address: 'getDeliveryTypes', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Select ...', required: true } },
                        ],
                        required: true,
                    },

                    dependencies: [{
                        refKey: 'type', targetKey: 'list',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'group' } } }, },
                            effect: { show: true }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false

                },



                {
                    key: 'time', type: 'TextInput', col: '6', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Est. delivery time', placeholder: '{{lang}}e.g., 3 - 5 business days', required: false },

                    dependencies: [{
                        refKey: 'type', targetKey: 'time',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                },

                {
                    key: 'rate', type: 'PriceInput', col: '6', section: 'sec-config', pages: ['information'], information: {
                        label: '{{lang}}Rate', placeholder: '0', help: "Total rate for a customer's  order (not per product).", required: false
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'rate',
                        conditions: [{
                            root: {
                                id: 'root', action: 'and',
                                conditions: {
                                    // 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "pickup" } },
                                    2: { id: 2, action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "pickup" } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "flatRate" } }, 4: { id: 4, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "schedule" } } } }
                                },
                            },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                },



                {
                    key: 'markup', type: 'PriceInput', col: '6', section: 'sec-config', pages: ['information'], information: {
                        label: '{{lang}}Markup', placeholder: '0', help: "Markup over the delivery price after it is calculated by the thirdparty.",
                        unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}markupUnit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true },
                        required: false
                    },
                    dependencies: [{
                        refKey: 'type', targetKey: 'markup',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "pickup" } }, 2: { id: 2, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "flatRate" } }, 3: { id: 3, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "rateByWeight" } }, 4: { id: 4, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "schedule" } }, 5: { id: 5, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                {
                    type: 'SubformInput',
                    key: 'weightRanges',
                    section: 'sec-config',
                    pages: ['information'],
                    information: {
                        label: "{{lang}}Weight rate ranges",
                        help: "{{lang}}Depending on the total order weight, you can charge different amounts for shipping.",
                        headers: [
                            {
                                key: 'weight', type: 'PriceInput', col: '6', information: {
                                    label: '{{lang}}Weight', placeholder: '{{lang}}Unlimited', help: '{{lang}}Maximum weight for this range.', required: false, type: 'local',
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'lb', type: 'local', items: [{ value: 'lb', title: 'lb' }, { value: 'oz', title: 'oz' }, { value: 'g', title: 'g' }, { value: 'kg', title: 'kg' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            { key: 'rate', type: 'PriceInput', col: '6', information: { label: '{{lang}}Rate', placeholder: '0', required: false, } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        // hint: '{{lang}}If multiple conditions are valid, the biggest number will be considered.',
                        required: true
                    },

                    dependencies: [{
                        refKey: 'type', targetKey: 'weightRanges',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "rateByWeight" } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                {
                    key: 'dicountBasedOnPrice', type: 'SwitchInput', section: 'sec-config', pages: ['information'], col: '12', pages: ['information'], information: { label: '{{lang}}Discount based on price of order? ', default: false, required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'dicountBasedOnPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                {
                    type: 'SubformInput',
                    key: 'priceBasedDiscounts',
                    section: 'sec-config',
                    pages: ['information'],
                    information: {
                        label: "{{lang}}Discount on delivery",
                        help: "{{lang}}Automatic discounts on delivery rate can be considered, based on specific thresholds on delivery's total price of the items.",
                        headers: [
                            { key: 'price', type: 'PriceInput', col: '6', information: { label: '{{lang}}Price From', leftIndicator: '{{currency}}', placeholder: '0', help: '{{lang}}Total price of the items after discount in one delivery.', required: false, type: 'local' } },
                            // { key: 'to', type: 'PriceInput', col: '4', information: { label: '{{lang}}To', placeholder: '{{lang}}More than from', required: false, type: 'local' } },
                            {
                                key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                                    label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            // { key: 'maxDiscount', type: 'PriceInput', col: '3', information: { label: '{{lang}}Max Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        hint: '{{lang}}If multiple conditions are valid, the biggest discount will be applied.',
                        required: true
                    },

                    dependencies: [{
                        refKey: 'dicountBasedOnPrice', targetKey: 'priceBasedDiscounts',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.dicountBasedOnPrice' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                {
                    key: 'origin', type: 'SelectInput', col: '12', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Ship from', address: 'getMyAddresses', filter: { hub: "{{appletHub}}" }, fields: { title: 'nickname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Address ...', required: true },
                    dependencies: [{
                        refKey: 'type', targetKey: 'origin',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                { type: 'MultiSelectInput', key: 'taxes', col: '6', pages: ['information'], section: 'sec-config', information: { label: '{{lang}}Taxes', address: 'getTaxes', groupBy: [{ key: 'type', options: [{ key: 'single', label: '{{lang}}Single rate' }, { key: 'group', label: '{{lang}}Taxes group' }] }], fields: { title: 'name', value: '_id', type: 'type' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Default tax', required: false }, showMain: false },


                { key: 'description', type: 'TextAreaInput', col: '12', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },

                // { type: 'AddressInput', key: 'origin', section: 'sec-config', pages: ['information'], information: { label: '{{lang}}Delivery from', required: true } },

                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', pages: ['information'], information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // {
                //     key: 'products', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                //     dependencies: [{
                //         refKey: 'availableForAllProducts',
                //         targetKey: 'products',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                // },
                // {
                //     key: 'productCategories', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },
                //     dependencies: [{
                //         refKey: 'availableForAllProducts',
                //         targetKey: 'productCategories',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.availableForAllProducts' }, operator: { value: '==' }, target: { value: false } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'pages: ['information'],information.filter.id', value: '@data.thing' },

                //     }],
                // },
                // { key: 'availableForAllHubs', type: 'SwitchInput', section: 'sec-config', col: '12', pages: ['information'], information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },
                // {
                //     key: 'hubs', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },
                //     dependencies: [{
                //         refKey: 'availableForAllHubs',
                //         targetKey: 'hubs',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.availableForAllHubs' }, operator: { value: '==' }, target: { value: false } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                // },


                { key: 'availableFor', type: 'SelectInput', section: 'sec-limitations', pages: ['information'], col: '12', fullCol: true, information: { label: '{{lang}}Available for', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}All hubs and groups", value: 'all' }, { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },

                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-limitations', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                // { key: 'countUnit', type: 'SelectInput', section: 'sec-limitations', fullCol: true, pages: ['information'], information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },

                {
                    key: 'minItemsCount', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Minimum items count', help: "{{lang}}This option can be used if you want to make this delivery available only if the number of items for the delivery are more than a specific count.", placeholder: '1', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'minItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                {
                    key: 'maxItemsCount', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Maximum items count', help: "{{lang}}This option can be used if you want to make this delivery just for a maximum specific number of items in one delivey. If the number of items surpass this number, they will be moved to another delivery.", placeholder: '{{lang}}Unlimited', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'maxItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                // { key: 'extraDiscount', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false },showMain:false },
                // { key: 'minDays', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Min Days', placeholder: '{{lang}}minDays', required: false },showMain:false },
                // { key: 'maxDays', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Max Days', placeholder: '{{lang}}maxDays', required: false },showMain:false },

                {
                    key: 'minOrderPrice', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Minimum order price', help: "{{lang}}This option can be used if you want to make this delivery available for orders above an specific total price.", placeholder: '0', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'minOrderPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                {
                    key: 'maxOrderPrice', type: 'NumberInput', section: 'sec-limitations', col: '6', pages: ['information'], information: { label: '{{lang}}Maximum order price', help: "{{lang}}This option can be used if you want to make this delivery unavailable for orders above an specific total price.", placeholder: '{{lang}}Unlimited', required: false },
                    dependencies: [{
                        refKey: 'type', targetKey: 'maxOrderPrice',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '!=' }, target: { value: "group" } }, }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },
                // { key: 'deliveryPrice', type: 'NumberInput', section: 'sec-config', col: '6', pages: ['information'], information: { label: '{{lang}}Delivery Price', placeholder: '{{lang}}Delivery Price', required: false } },
                // { key: 'paymentTypes', type: 'MultiSelectInput', section: 'sec-config', pages: ['information'], information: { isSearchable: true, label: '{{lang}}Payment Types', address: 'getPaymentTypes', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false } },



                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },



        vouchers: {
            key: 'vouchers',
            title: '{{lang}}Vouchers',
            fetchUrl: 'getVouchers',
            addUrl: 'postVoucher',
            editUrl: 'postVoucher',
            removeUrl: 'removeVoucher',
            // helperKey: 'values',
            pageType: 'collection',
            model: 'vouchers',
            section: 'main',
            actions: [{ type: 'edit' }, { type: 'remove' }],
            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/ad-center.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            formPages: [
                {
                    label: '{{lang}}Information', key: 'information', isLastPage: true,

                    sections: [
                        { key: 'sec-main', information: { label: '{{lang}}Main information', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-more', information: { label: '{{lang}}More information', fontSize: 16, color: '#000', fontWeight: '600' } },

                        { key: 'sec-usagelimitations', information: { label: '{{lang}}Usage Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },
                        { key: 'sec-itemsLimitations', information: { label: '{{lang}}Items Limitations', fontSize: 16, color: '#000', fontWeight: '600' } },




                    ]
                },

            ],
            headers: [
                { key: 'name', type: 'TextInput', section: 'sec-main', col: '12', information: { label: '{{lang}}Name', placeholder: "{{lang}}e.g. New year's discount", required: true }, showMain: true },
                { key: 'levelType', type: 'SelectInput', section: 'sec-main', col: '6', fullCol: true, information: { label: '{{lang}}Discount Type', required: false, type: 'local', default: 'single', items: [{ title: "{{lang}}Single value", value: 'single' }, { title: "{{lang}}Multi level", value: 'multi' }], help: 'Single: for one simple dicount value.\nMulti level: for multiple step discount based on total price or number of items.', required: true }, showMain: false, inExport: true },
                { key: 'code', type: 'CodeGeneratorInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Code', length: 7, placeholder: '{{lang}}e.g. LRK0EW2', required: true }, showMain: true },

                // { key: 'levelType', type: 'SelectInput', col: '6', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "first", value: 'first' }, { title: "second", value: 'second' }] }, showMain: true, inExport: true },
                // { key: 'availableForAllProducts', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Available For All Products', placeholder: '{{lang}}availableForAllProducts', default: true, required: false } },

                { key: 'discountOn', type: 'SelectInput', section: 'sec-main', col: '6', fullCol: true, information: { label: '{{lang}}Discount on', type: 'local', default: 'items', items: [{ title: "{{lang}}Items in the cart", value: 'items' }, { title: "{{lang}}Delivey fee", value: 'delivery' }], required: true, }, showMain: false, inExport: true },

                {
                    key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                        label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: false,
                        unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                    },

                    dependencies: [

                        {
                            refKey: 'levelType', targetKey: 'discount',
                            conditions: [{
                                root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.levelType' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                                effect: { show: false, }
                            }],
                            else: { show: true },
                            init: true,

                        },
                        // {
                        //     refKey: 'discountOn', targetKey: 'discount.value',
                        //     conditions: [{
                        //         root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.discountOn' }, operator: { value: '==' }, target: { value: 'amount' } } }, },
                        //         effect: { changeHeader: [{ key: 'information.leftIndicator', value: '$' }, { key: 'information.max', value: null }] }
                        //     }],
                        //     else: { changeHeader: [{ key: 'information.leftIndicator', value: "%" }, { key: 'information.max', value: 100 }] },
                        //     init: true,

                        // }
                    ],
                    showMain: true
                },


                // {
                //     key: 'discount', type: 'PriceInput', section: 'sec-main', col: '6', information: { label: '{{lang}}Discount value', min: 0, leftIndicator: '%', minusInfinity: 0, placeholder: '{{lang}}Discount value', required: true },
                //     dependencies: [

                //         {
                //             refKey: 'levelType', targetKey: 'discount',
                //             conditions: [{
                //                 root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                //                 effect: { show: false, }
                //             }],
                //             else: { show: true },
                //             init: true,

                //         },
                //         {
                //             refKey: 'discountOn', targetKey: 'discount',
                //             conditions: [{
                //                 root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.discountOn' }, operator: { value: '==' }, target: { value: 'amount' } } }, },
                //                 effect: { changeHeader: [{ key: 'information.leftIndicator', value: '$' }, { key: 'information.max', value: null }] }
                //             }],
                //             else: { changeHeader: [{ key: 'information.leftIndicator', value: "%" }, { key: 'information.max', value: 100 }] },
                //             init: true,

                //         }],
                //     showMain: true
                // },


                {
                    type: 'SubformInput',
                    key: 'levels',
                    section: 'sec-main',
                    information: {
                        label: "{{lang}}Discount levels",
                        headers: [
                            // { key: 'from', type: 'PriceInput', col: '4', information: { label: '{{lang}}From', placeholder: '0', required: false, type: 'local' } },
                            { key: 'to', type: 'PriceInput', col: '6', information: { label: '{{lang}}Items total up to', help: "The maximum order amount for this level. If you leave empty, there will to no maximum for this level.", placeholder: '{{lang}}No maximum', required: false, type: 'local' } },
                            // { key: 'discount', type: 'PriceInput', col: '4', information: { label: '{{lang}}Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}Discount', required: false } },
                            {
                                key: 'discount', section: 'sec-main', type: 'PriceInput', col: '6', information: {
                                    label: '{{lang}}Discount', placeholder: '{{lang}}Discount', required: true,
                                    unit: { key: 'unit', type: 'SelectInput', col: '3', information: { label: '{{lang}}unit', defaultValue: 'percent', type: 'local', items: [{ value: 'percent', title: '%' }, { value: 'amount', title: '$' }], placeholder: '{{lang}}select', required: true }, showMain: true }
                                }
                            },
                            // { key: 'maxDiscount', type: 'PriceInput', col: '3', information: { label: '{{lang}}Max Discount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', required: false } },
                        ],

                        placeholder: '{{lang}}placeholders.insertInformation',
                        hint: '{{lang}}If multiple conditions are valid, the biggest discount will be applied.',
                        required: true
                    },
                    dependencies: [{
                        refKey: 'levelType', targetKey: 'levels',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.levelType' }, operator: { value: '==' }, target: { value: 'multi' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },



                { key: 'usageCondition', type: 'SelectInput', section: 'sec-usagelimitations', col: '6', fullCol: true, information: { label: '{{lang}}Usage condition', required: false, type: 'local', default: 'any', items: [{ title: "{{lang}}No specific condition", value: 'any' }, { title: "{{lang}}Only on First purchase", value: 'firstPurchase' }] }, showMain: false, inExport: true },


                { key: 'availableFor', type: 'SelectInput', section: 'sec-usagelimitations', col: '6', fullCol: true, information: { label: '{{lang}}Available for', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}Any one with code", value: 'all' }, { title: "{{lang}}Specific hubs and groups", value: 'hubsAndGroups' }] }, showMain: false, inExport: true },
                // { title: "{{lang}}Specific hubs", value: 'hubs' }, { title: "{{lang}}Specific groups", value: 'groups' },
                {
                    key: 'hubs', type: 'MultiSelectInput', section: 'sec-usagelimitations', information: { isSearchable: true, label: '{{lang}}Hubs', address: 'searchHub', filter: { hub: "{{appletHub}}" }, fields: { title: 'fullname', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}hubs', required: false },

                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'hubs',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubs' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                {
                    key: 'groups', type: 'MultiSelectInput', section: 'sec-usagelimitations', information: { isSearchable: true, label: '{{lang}}Groups', address: 'getGroups', filter: { hub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Groups', required: false },
                    dependencies: [{
                        refKey: 'availableFor', targetKey: 'groups',
                        conditions: [{
                            root: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'groups' } }, 2: { id: 2, source: { value: '@data.availableFor' }, operator: { value: '==' }, target: { value: 'hubsAndGroups' } } } },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },







                // { key: 'availableForAllHubs', type: 'SwitchInput', section: 'sec-usagelimitations', col: '12', information: { label: '{{lang}}Available For All Hubs', placeholder: '{{lang}}availableForAllProducts', default: true, required: false }, showMain: false },

                // { key: 'countUnit', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Count Unit', required: false, type: 'local', default: '0', items: [{ title: "kg", value: 'kg' }, { title: "number", value: 'number' }] }, showMain: true, inExport: true },
                // { key: 'minimumOrder', type: 'SelectInput', section: 'sec-usagelimitations', fullCol: true, information: { label: '{{lang}}Set Minimum Order Point For', required: false, type: 'local', default: '0', items: [{ title: "{{lang}}Price", value: 'price' }, { title: "{{lang}}Piece", value: 'piece' }] }, showMain: false, inExport: true },


                { key: 'maxDiscount', type: 'PriceInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximum Discount amount', leftIndicator: '{{currency}}', placeholder: '{{lang}}No maximum', help: 'Disount can not surpass this amount. This is useful if your are using percentages for discount and want to have a limitation for maximum discount.', required: false }, showMain: false },


                { key: 'minAmount', type: 'PriceInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Minimum Order amount', leftIndicator: '{{currency}}', placeholder: '0', help: 'The dicount will be applied if the order price be more than this amount.', required: false }, showMain: false },


                { key: 'maxHubsUsage', type: 'NumberInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximun usage / hub', default: 1, placeholder: '{{lang}}Unlimited', help: 'Each hub can not use this discount for more than this number.', required: false }, showMain: false },

                { key: 'maxTotalUsage', type: 'NumberInput', section: 'sec-usagelimitations', col: '6', information: { label: '{{lang}}Maximun usage / Total', placeholder: '{{lang}}Unlimited', help: 'Total number of times that this discount can be used is determined by this number. This is the total number of usage regardless of the person who is using it.', required: false }, showMain: false },





                { key: 'applyTo', type: 'SelectInput', section: 'sec-itemsLimitations', col: '12', fullCol: true, information: { label: '{{lang}}Applies to', required: false, type: 'local', default: 'all', items: [{ title: "{{lang}}Any order", value: 'all' }, { title: "{{lang}}Specific products and categories", value: 'productsAndCategories' },] }, showMain: false, inExport: true },
                // { title: "{{lang}}Specific products", value: 'products' }, { title: "{{lang}}Specific categories", value: 'categories' }
                {
                    key: 'products', type: 'MultiSelectInput', section: 'sec-itemsLimitations', information: { isSearchable: true, label: '{{lang}}Products', address: 'getProducts', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}products', required: false },

                    dependencies: [{
                        refKey: 'applyTo', targetKey: 'products',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.applyTo' }, operator: { value: '==' }, target: { value: 'productsAndCategories' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },
                {
                    key: 'categories', type: 'MultiSelectInput', section: 'sec-itemsLimitations', information: { isSearchable: true, label: '{{lang}}Product Categories', address: 'getProductsCategories', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Products categories', required: false },

                    dependencies: [{
                        refKey: 'applyTo', targetKey: 'categories',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.applyTo' }, operator: { value: '==' }, target: { value: 'productsAndCategories' } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],

                    showMain: false
                },


                { key: 'includesItemsConditions', type: 'SwitchInput', section: 'sec-itemsLimitations', col: '12', information: { label: '{{lang}}Includes specific conditions for items', default: false, required: false }, showMain: false },

                {
                    key: 'minItemsCount', type: 'NumberInput', section: 'sec-itemsLimitations', col: '6', information: { label: '{{lang}}Minimun Items Count', placeholder: '{{lang}}minItemsCount', required: false },
                    dependencies: [{
                        refKey: 'includesItemsConditions', targetKey: 'minItemsCount',
                        conditions: [{
                            root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.itemsConditions' }, operator: { value: '==' }, target: { value: true } } }, },
                            effect: { show: true, }
                        }],
                        else: { show: false },
                        init: true,

                    }],
                    showMain: false
                },


                // { key: 'discountPercentage', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },
                // { key: 'discountPercentage', type: 'NumberInput',  section: 'sec-usagelimitations',col: '6', information: { label: '{{lang}}Discount Percentage%', placeholder: '{{lang}}discountPercentage%', required: false } },



                // { key: 'discountType', type: 'SelectInput', section: 'sec-usagelimitations', col: '12', information: { label: '{{lang}}Type', required: false, type: 'local', items: [{ title: "{{lang}}multi level", value: 'multi' }, { title: "{{lang}}single level", value: 'single' }] }, showMain: false, inExport: true },

                // {
                //     key: 'singleLevelDiscount.unit', type: 'SelectInput', section: 'sec-usagelimitations', col: '4', information: { label: '{{lang}}unit', required: false, type: 'local', items: [{ title: "percentage", value: 'percentage' }, { title: "cash", value: 'cash' }] },
                //     dependencies: [{
                //         refKey: 'discountType',
                //         targetKey: 'singleLevelDiscount.unit',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.discountType' }, operator: { value: '==' }, target: { value: 'single' } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },
                // {
                //     key: 'singleLevelDiscount.discount', type: 'NumberInput', section: 'sec-usagelimitations', col: '4', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: false },
                //     dependencies: [{
                //         refKey: 'discountType',
                //         targetKey: 'singleLevelDiscount.discount',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'and',
                //                 conditions: {
                //                     1: { id: 1, source: { value: '@data.discountType' }, operator: { value: '==' }, target: { value: 'single' } },

                //                 }
                //             },
                //         },
                //         show: true,
                //         init: true,
                //         // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                //     }],
                //     showMain: false
                // },



                { key: 'start', type: 'DateInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Start date', startOrEnd: 'start', placeholder: '{{lang}}From now', required: false }, showMain: true },

                { key: 'expiry', type: 'DateInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Expiry date', startOrEnd: 'end', placeholder: '{{lang}}Never expires', required: false }, showMain: true },

                { key: 'automaticApply', type: 'SwitchInput', section: 'sec-more', col: '6', information: { label: '{{lang}}Automatic Apply', placeholder: '{{lang}}automaticApply', default: false, required: false } },


                { key: 'description', type: 'TextAreaInput', section: 'sec-more', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false }, showMain: false },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },


    }
}







const emailFrames = {
    sections: {
        collections: { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
        manage: { key: 'manage', name: '{{lang}}Manage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // orders: { key: 'orders', name: '{{lang}}Orders', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // loyaltySystem: { key: 'loyaltysystem', name: '{{lang}}Loyalty System', icon: '/images/applets-icons/accounting/063-cart.svg' },
    },
    pages: {

        reports: {
            key: 'reports',
            title: '{{lang}}Reports',
            description: 'Reports list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'manage',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/watch.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },

    }
}



const InquiriesFrames = {


    sections: {
        collections: { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
        manage: { key: 'manage', name: '{{lang}}Manage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // orders: { key: 'orders', name: '{{lang}}Orders', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // loyaltySystem: { key: 'loyaltysystem', name: '{{lang}}Loyalty System', icon: '/images/applets-icons/accounting/063-cart.svg' },
    },


    pages: {

        newInquiry: {
            key: '[var]/new',
            title: '{{lang}}Inquiries',
            description: 'Inquiries List',
            fetchUrl: 'getRecords',
            addUrl: 'postRecord',
            removeUrl: 'removeRecord',

            postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            hideInDashboard: true,

            section: 'collections',
            pageType: 'newInquery',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            headers: [

                { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
                { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
                { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                { type: 'ImageInput', key: 'images', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'description', type: 'EditorInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                { key: 'special', type: 'SwitchInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
                { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

                { key: 'available', type: 'SwitchInput', col: "12", pages: ['information'], information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },

                { key: 'priceSttings.priceBeforeDiscount', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Selling Price', placeholder: '{{lang}}Selling Price', required: false } },

                { key: 'cprice', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Cost Price', placeholder: '{{lang}}Cost Price', required: false }, showMain: false },
                { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },
            ]
        },


        inquiries: {
            key: '[var]/[var]',
            title: '{{lang}}inquiries',
            description: 'Inquiriy edit',
            fetchUrl: 'getRecords',
            addUrl: 'postRecord',
            removeUrl: 'removeRecord',

            postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            hideInDashboard: true,
            section: 'collections',
            pageType: 'singleRecord',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            headers: [

                { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
                { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
                { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                { type: 'ImageInput', key: 'images', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'description', type: 'EditorInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                { key: 'special', type: 'SwitchInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
                { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

                { key: 'available', type: 'SwitchInput', col: "12", pages: ['information'], information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },

                { key: 'priceSttings.priceBeforeDiscount', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Selling Price', placeholder: '{{lang}}Selling Price', required: false } },

                { key: 'cprice', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Cost Price', placeholder: '{{lang}}Cost Price', required: false }, showMain: false },
                { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },
            ]
        },



        inquiry: {
            key: '[var]/[var]',
            title: '{{lang}}Inquiry',
            description: 'Inquiriy edit',
            fetchUrl: 'getRecords',
            addUrl: 'postRecord',
            removeUrl: 'removeRecord',

            postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            hideInDashboard: true,
            section: 'collections',
            pageType: 'singleRecord',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            headers: [

                { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
                { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
                { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
                { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
                { type: 'ImageInput', key: 'images', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
                { key: 'description', type: 'EditorInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

                { key: 'special', type: 'SwitchInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
                { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

                { key: 'available', type: 'SwitchInput', col: "12", pages: ['information'], information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },

                { key: 'priceSttings.priceBeforeDiscount', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Selling Price', placeholder: '{{lang}}Selling Price', required: false } },

                { key: 'cprice', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Cost Price', placeholder: '{{lang}}Cost Price', required: false }, showMain: false },
                { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },
            ]
        },






        reports: {
            key: 'reports',
            title: '{{lang}}Reports',
            description: 'Reports list',
            fetchUrl: 'getProductsCategories',
            addUrl: 'postProductCategory',
            editUrl: 'postProductCategory',
            removeUrl: 'removeProductCategory',
            // helperKey: 'values',
            pageType: 'collection',
            section: 'manage',

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/watch.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: false } },
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Icon', required: false } },
                { key: 'parent', type: 'SelectInput', col: '12', information: { isSearchable: true, label: '{{lang}}parent', address: 'getProductsCategories', filter: { applet: '{{appletId}}' }, fields: { title: 'name', image: 'images', value: '_id' }, type: 'api', root: null, reference: 'parent', placeholder: '{{lang}}parent', required: false } },

                // { key: 'person', type: 'TextInput', col: '6', information: { label: '{{lang}}person', placeholder: '{{lang}}person', required: false } },
            ]
        },

    }
}








const DevelopersFrames = {


    sections: {
        manage: { key: 'manage', name: '{{lang}}Manage', icon: '/images/applets-icons/accounting/063-cart.svg' },
    },


    pages: {


        credentials: {
            key: 'credentials',
            title: '{{lang}}Credentials',
            description: 'credentials list',
            fetchUrl: 'getTokens',
            addUrl: 'postToken',
            editUrl: 'postToken',
            removeUrl: 'removeToken',
            // helperKey: 'values',
            customAdd: { title: '{{lang}}Add Cridencial', function: 'changeStage', functionInput: 'addCridencial' },
            ignorePermission: true,
            pageType: 'collection',
            section: 'manage',
            defaultPage: true,

            options: {},
            sort: { 'cDate': -1 },
            filter: { applet: '{{appletId}}' },
            postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
            icon: '/assets/icons/applets/general/watch.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            headers: [
                { key: 'accessKey.credential', type: 'TextInput', information: { label: '{{lang}}credential', disabled: true, showCopy: true }, },

                // { key: 'name', type: 'TextInput', information: { label: 'Name' } },
                { key: 'accessKey.type', type: 'TextInput', information: { label: 'Type' } },
                { key: 'cDate', type: 'DateInput', information: { label: 'Creation Date', disabled: true }, hideComponent: true },
                // { key: 'credential', type: 'TextInput', information: { label: '{{lang}}credential', disabled: true, showCopy: true }, showMain: false },

            ]
        },




        newCredential: {
            key: 'credentials/new',
            title: '{{lang}}New Credential',
            // description: 'Inquiries List',
            // fetchUrl: 'getRecords',
            addUrl: 'postToken',

            postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
            hideInDashboard: true,

            section: 'collections',
            pageType: 'newCridential',
            options: {},
            sort: { 'cDate': -1 },
            icon: '/assets/icons/applets/general/play-games.png',
            description: '{{lang}}The descriptions of this module would be shown here',

            headers: [

            ]
        },


    }
}



const EmailFrames = {

    sections: {
        manage: { key: 'manage', name: '{{lang}}Manage', icon: '/images/applets-icons/accounting/063-cart.svg' },
    },
    pages: {

        // inquiries: {
        //     key: '[var]/[var]',
        //     title: '{{lang}}inquiries',
        //     description: 'Inquiriy edit',
        //     fetchUrl: 'getRecords',
        //     addUrl: 'postRecord',
        //     removeUrl: 'removeRecord',

        //     postBody: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        //     filter: { hub: "{{appletHub}}", applet: '{{appletId}}' },
        //     hideInDashboard: true,
        //     section: 'collections',
        //     pageType: 'singleRecord',
        //     options: {},
        //     sort: { 'cDate': -1 },
        //     icon: '/assets/icons/applets/general/play-games.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',

        //     headers: [

        //         { key: 'text-1', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Select the type of what you want to sale', fontSize: 20, color: '#000', fontWeight: '600' }, showMain: false },
        //         { key: 'text-2', type: 'StaticText', col: '12', pages: ['type'], information: { label: '{{lang}}Each type has its settings and configurations', fontSize: 14, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
        //         { key: 'sec-main', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Details', fontSize: 16, color: '#000', fontWeight: '600' }, showMain: false },
        //         { key: 'name', type: 'TextInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Product Name', placeholder: '{{lang}}Insert product name', required: false } },
        //         { key: 'cover', type: 'ImageInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Cover Image', single: true, cropper: true, ratio: '4:4', placeholder: '{{lang}}chooseImage', required: false } },
        //         { type: 'ImageInput', key: 'images', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Extra Images', single: false, cropper: true, ratio: "4:4", placeholder: '{{lang}}chooseImage', required: false }, showMain: true },
        //         { key: 'description', type: 'EditorInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false }, showMain: false },

        //         { key: 'special', type: 'SwitchInput', col: '12', section: 'sec-main', pages: ['information'], information: { label: '{{lang}}Special', type: 'local', items: [{ value: 'trending', title: 'trending' }, { value: 'featured', title: 'Featured' }], isSearchable: true, placeholder: '{{lang}}special', required: false }, showMain: true },
        //         { key: 'sec-price', type: 'SectionIndicator', col: '12', pages: ['information'], information: { label: '{{lang}}Pricing' } },

        //         { key: 'available', type: 'SwitchInput', col: "12", pages: ['information'], information: { label: '{{lang}}Available', placeholder: '{{lang}}available', default: true, required: false }, showMain: true },

        //         { key: 'priceSttings.priceBeforeDiscount', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Selling Price', placeholder: '{{lang}}Selling Price', required: false } },

        //         { key: 'cprice', type: 'PriceInput', col: '6', pages: ['information'], information: { label: '{{lang}}Cost Price', placeholder: '{{lang}}Cost Price', required: false }, showMain: false },
        //         { key: 'extraSection', type: 'FormSection', col: '12', pages: ['information'], information: { label: '{{lang}}extra', tabs: [{ key: 'extra', label: '{{lang}}Extra Fields' }, { key: 'specifications', label: '{{lang}}Specifications' }], required: false }, showMain: false },
        //     ]
        // },

    }
}



const DeskFrames = {


    sections: {
        manage: { key: 'manage', name: '{{lang}}Manage', icon: '/images/applets-icons/accounting/063-cart.svg' },
    },


    pages: {


        // mytasks: {
        //     key: 'mytasks',
        //     title: '{{lang}}My Tasks',
        //     description: 'My Tasks list',
        //     fetchUrl: 'getMyTasks',
        //     addUrl: 'addTask',
        //     editUrl: 'updateTask',
        //     removeUrl: 'removeTask',
        //     // helperKey: 'values',
        //     // customAdd: { title: '{{lang}}Add Cridencial', function: 'changeStage', functionInput: 'addCridencial' },

        //     pageType: 'collection',
        //     section: 'manage',
        //     defaultPage: true,

        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", frame: '{{frameId}}' },
        //     icon: '/assets/icons/applets/general/watch.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: true },
        //         { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Description', inplaceEditable: false, placeholder: '{{lang}}desk.insert', required: false }, showMain: false },
        //         { key: 'parent', type: 'SelectInput', information: { label: '{{lang}}parent', address: 'getMyTasks', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false, disabled: true }, showMain: false },
        //         // { key: 'applet', type: 'SelectInput', information: { label: '{{lang}}applet', address: 'getMyTasks', filter: { applet: '{{appletId}}' }, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}', required: false, disabled: true }, showMain: false },

        //         { key: 'timeline.dueDate', type: 'DateInput', col: '12', information: { label: '{{lang}}desk.Due Date', inplaceEditable: false, placeholder: '{{lang}}desk.Date', required: false }, showMain: true },

        //         { key: 'categorizer', type: 'CategorizerInput', fullCol: true, information: { label: '{{lang}}Categorizer', inplaceEditable: false, required: false, type: 'api', address: 'getInputOptions', fields: { title: 'label', value: '_id', parent: 'parent', colors: 'colors' }, filter: { applet: '{{appletId}}', frame: '{{frameId}}', appletHub: '{{appletHub}}' }, }, showMain: true, inExport: true },

        //         { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', inplaceEditable: false, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#fff', bgColor: '#CA5C72' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#fff', bgColor: '#f5b00f' }, { label: '{{lang}}desk.Low', key: 'low', color: '#fff', bgColor: '#20c676' }], required: false } },

        //         { key: 'assignee', type: 'GlobalUserInput', information: { label: '{{lang}}Assignee', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
        //         { key: 'collaborators', type: 'GlobalUserMultiInput', information: { label: '{{lang}}Collaborators', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
        //         // { key: 'frame', type: 'FrameSelector', information: { label: '{{lang}}frame', inplaceEditable: false, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },



        //         // { key: 'source', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}desk.Source', inplaceEditable: false, required: false, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: false, inExport: true },
        //         // { key: 'tags', type: 'MultiSelectInput', fullCol: true, information: { label: '{{lang}}desk.Tags', inplaceEditable: false, required: false, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: false, inExport: true },

        //     ]
        // },




        // projects: {
        //     key: 'projects',
        //     title: '{{lang}}Projects',
        //     description: 'Projects list',
        //     fetchUrl: 'getTokens',
        //     addUrl: 'postToken',
        //     editUrl: 'postToken',
        //     removeUrl: 'removeToken',
        //     // helperKey: 'values',
        //     // customAdd: { title: '{{lang}}Add Cridencial', function: 'changeStage', functionInput: 'addCridencial' },

        //     pageType: 'collection',
        //     section: 'manage',
        //     defaultPage: true,

        //     options: {},
        //     sort: { 'cDate': -1 },
        //     filter: { applet: '{{appletId}}' },
        //     postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}" },
        //     icon: '/assets/icons/applets/general/watch.png',
        //     description: '{{lang}}The descriptions of this module would be shown here',
        //     headers: [
        //         { key: 'credential', type: 'TextInput', information: { label: '{{lang}}credential', disabled: true, showCopy: true }, },

        //         // { key: 'name', type: 'TextInput', information: { label: 'Name' } },
        //         { key: 'type', type: 'TextInput', information: { label: 'Type' } },
        //         { key: 'cDate', type: 'DateInput', information: { label: 'Creation Date', disabled: true }, hideComponent: true },
        //         // { key: 'credential', type: 'TextInput', information: { label: '{{lang}}credential', disabled: true, showCopy: true }, showMain: false },

        //     ]
        // },









    }
}

const DashboardSettings = {

    sections: {
        // general: { key: 'general', noChildren: false, name: 'general' },
        // help: { key: 'help', noChildren: false, name: 'help' },
        // extra: { key: 'extra', noChildren: false, name: 'extra' },

        // purchases: { key: 'purchases', name: 'Purchases', icon: '/images/applets-icons/accounting/shopping-bag.svg' },
        // accountant: { key: 'accountant', name: 'Accountant', icon: '/images/applets-icons/accounting/book.svg' },
        // reports: { key: 'reports', name: 'Reports', icon: '/images/applets-icons/accounting/increasing.svg' },
        // settings: { key: 'settings', name: 'Settings', icon: '/images/settings-4.svg' },

    },

    pages: {

        dashbaord: {
            key: 'dashboards/[var]',
            title: '{{lang}}Page Builder',
            description: 'newpage list',
            fetchUrl: 'newpage',
            addUrl: 'postDashboard',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            pageType: 'pageBuilder',
            options: {},
            sort: { 'cDate': -1 },
            // addNew: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'addRule' },
            hideInDashboard: true,

            filter: { targetHub: "{{targetId}}" },
            postBody: { targetHub: "{{targetId}}" },
            // postBody: { applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}" },
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

        },

        dashbaords: {
            key: 'dashboards',
            title: '{{lang}}Dashboards',
            description: 'Pages list',
            fetchUrl: 'getMyDashboards',
            addUrl: 'postPage',
            editUrl: 'postPage',
            yremoveRelation: 'yremoveConnection',
            pageType: 'dashboards',
            options: {},
            sort: { 'cDate': -1 },

            customAdd: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'dashboards/[var]' },
            customEdit: { title: '{{lang}}Add Rule', function: 'changePage', functionInput: 'dashboards/[var]' },

            filter: { type: 'page', mode: 'dashboard' },
            postBody: {},
            icon: '/assets/icons/applets/general/shop.png',
            description: '{{lang}}The descriptions of this module would be shown here',
            section: 'main',

            // actions: {
            //     edit: { key: "edit", label: "{{lang}}edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            //     remove: { key: "remove", label: "{{lang}}Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
            // },

            headers: [
                // { key: 'name', type: 'GlobalUserInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },
                { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: '{{lang}}Select ...', required: false } },

                // { key: 'status', type: 'StatusInput', col: '12', information: { label: '{{lang}}useful.status', placeholder: '{{lang}}useful.status', required: false, disabled: true }, hideComponent: true, showMain: true },

                // { key: 'groups', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}useful.groups', address: 'getConnectionGroups', filter: { user: "{{targetId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}useful.groups', required: false } },
            ]
        },

    },
}


export { MainSettings, DeskFrames, BookingUserPages, DevelopersFrames, InquiriesFrames, BookingPages, CommercePages, CommerceUserPages, FinanceAdminFrames, ConnectionsPages, AutomationsPages, HubSettings, SettingsFrames, SettingsPages, DashboardSettings, EmailFrames }